webpackJsonp([1],{

/***/ "+8M5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  easyLanguage: 'Lenguaje fácil',
  videoDoesNotYetExist: 'El video aún no existe'
});

/***/ }),

/***/ "+Cth":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+HJ+":
/***/ (function(module, exports) {

module.exports = {"title":"Einloggen","emailPH":"Email","pwdPH":"Passwort","submitTxt":"Einloggen","errMsg":"Deine Anmeldung war nicht erfolgreich","registerHint1":"Noch keinen Account ?","registerHint2":"Hier geht es zur Anmeldung"}

/***/ }),

/***/ "+UcY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"root-view"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('div',{staticStyle:{"height":"5rem"}}),_vm._v(" "),_c('center',[_c('img',{staticStyle:{"width":"60%"},attrs:{"src":__webpack_require__("exSp"),"alt":"Laya"}}),_vm._v(" "),_c('div',{staticStyle:{"height":"1.5rem"}}),_vm._v(" "),_c('h1',[_vm._v(_vm._s(_vm.msg.title))]),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.msg.subtitle))]),_vm._v(" "),_c('div',{staticStyle:{"height":"1.5rem"}})])],1)])]),_vm._v(" "),_c('div',{staticClass:"ly-bg-grey"},[_c('div',{staticClass:"container py-5"},[_c('div',{staticClass:"row align-items-center"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-8"},[_c('h5',{staticClass:"text-left",domProps:{"innerHTML":_vm._s(_vm.msg.promoText1)}})])])])]),_vm._v(" "),_c('div',{staticClass:"container py-5"},[_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col-8"},[_c('h5',{staticClass:"text-right",domProps:{"innerHTML":_vm._s(_vm.msg.promoText2)}})]),_vm._v(" "),_vm._m(1)])]),_vm._v(" "),_c('div',{staticClass:"ly-bg-grey"},[_c('div',{staticClass:"container py-5"},[_c('div',{staticClass:"row align-items-center"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-8"},[_c('h5',{staticClass:"text-left"},[_vm._v(_vm._s(_vm.msg.promoText3))])])])])]),_vm._v(" "),_c('div',{staticClass:"mt-5 text-center"},[_c('router-link',{attrs:{"to":"/register"}},[_c('button',{staticClass:"btn btn-outline-dark btn-lg",attrs:{"type":"button"}},[_c('i',{staticClass:"fas fa-arrow-right"}),_vm._v(" "+_vm._s(_vm.msg.register)+"\n      ")])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-4 text-center"},[_c('img',{staticStyle:{"width":"5rem"},attrs:{"src":__webpack_require__("4M8H"),"alt":"Lernen für alle"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-4 text-center"},[_c('span',{staticStyle:{"font-size":"4rem"}},[_c('i',{staticClass:"fas fa-deaf"}),_vm._v(" "),_c('i',{staticClass:"fas fa-low-vision"}),_vm._v(" "),_c('i',{staticClass:"fas fa-sign-language"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-4 text-center"},[_c('i',{staticClass:"fas fa-universal-access",staticStyle:{"font-size":"5rem"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+riO":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "+sJJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/kPk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_quiz_mchoice_vue__ = __webpack_require__("w/wq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c030a50c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_quiz_mchoice_vue__ = __webpack_require__("Ba7+");
function injectStyle (ssrContext) {
  __webpack_require__("Rg+h")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c030a50c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_quiz_mchoice_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c030a50c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_quiz_mchoice_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0arO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_flex_center_vue__ = __webpack_require__("pTqu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_566073fc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_flex_center_vue__ = __webpack_require__("SkqW");
function injectStyle (ssrContext) {
  __webpack_require__("dEBs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-566073fc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_flex_center_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_566073fc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_flex_center_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1Uil":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-view ly-nav-margin"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('form',{staticClass:"d-flex flex-column align-items-center"},[_c('div',{staticStyle:{"height":"2rem"}}),_vm._v(" "),_c('img',{staticClass:"d-block m-auto w-50",attrs:{"src":__webpack_require__("ya+h"),"alt":"Login"}}),_vm._v(" "),_c('h1',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.i18n.title))]),_vm._v(" "),_c('div',{staticClass:"ly-input",class:{error: _vm.errEmail}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.email),expression:"email",modifiers:{"trim":true}}],attrs:{"id":"email-input","placeholder":_vm.i18n.emailPH,"type":"text","autofocus":"","autocomplete":"on"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value.trim()},"blur":function($event){return _vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"ly-input",class:{error: _vm.errPwd}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.pwd),expression:"pwd",modifiers:{"trim":true}}],attrs:{"placeholder":_vm.i18n.pwdPH,"type":"password","autocomplete":"on"},domProps:{"value":(_vm.pwd)},on:{"input":function($event){if($event.target.composing){ return; }_vm.pwd=$event.target.value.trim()},"blur":function($event){return _vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticStyle:{"height":"2rem"}}),_vm._v(" "),_c('button',{staticClass:"btn btn-lg btn-outline-dark",attrs:{"id":"login-button","type":"submit","aria-describedby":"login-error"},on:{"click":function($event){$event.preventDefault();return _vm.submit($event)}}},[_vm._v("\n          "+_vm._s(_vm.i18n.submitTxt)+" "),_c('i',{staticClass:"fas fa-arrow-right"})]),_vm._v(" "),(_vm.busy)?_c('h5',{staticClass:"text-center"},[_vm._v("\n          "+_vm._s(_vm.i18n.busy)+" "),_c('i',{staticClass:"fas fa-spinner fa-spin"})]):_vm._e(),_vm._v(" "),(_vm.submitFailed)?_c('div',{staticClass:"font-weight-bold text-center mt-3",attrs:{"id":"login-error","aria-hidden":!_vm.submitFailed}},[_c('i',{staticClass:"fas fa-exclamation-triangle"}),_vm._v(" "+_vm._s(_vm.errMsg)+"\n        ")]):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"text-center"},[_vm._v("\n          "+_vm._s(_vm.i18n.registerHint1)),_c('br'),_vm._v(" "),_c('u',[_c('a',{attrs:{"href":"#/register"}},[_vm._v(_vm._s(_vm.i18n.registerHint2))])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1ZG6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__de_js__ = __webpack_require__("J49P");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "de", function() { return __WEBPACK_IMPORTED_MODULE_0__de_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__en_js__ = __webpack_require__("D3ED");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "en", function() { return __WEBPACK_IMPORTED_MODULE_1__en_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "es", function() { return __WEBPACK_IMPORTED_MODULE_1__en_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "it", function() { return __WEBPACK_IMPORTED_MODULE_1__en_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "pl", function() { return __WEBPACK_IMPORTED_MODULE_1__en_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "nl", function() { return __WEBPACK_IMPORTED_MODULE_1__en_js__["a"]; });







/***/ }),

/***/ "1rPj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2dQQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_disableplayer_vue__ = __webpack_require__("76Gz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6be341a9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_disableplayer_vue__ = __webpack_require__("MaJA");
function injectStyle (ssrContext) {
  __webpack_require__("u77a")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_disableplayer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6be341a9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_disableplayer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2i4H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ly-input-img',
  data: function data() {
    return { preview: null };
  },

  props: {
    value: File
  },
  methods: {
    setImg: function setImg() {
      var imgFile = this.$refs.img.files[0];
      this.preview = URL.createObjectURL(imgFile);
      this.$emit('input', imgFile);
    },
    unsetImg: function unsetImg() {
      URL.revokeObjectURL(this.preview);
      this.preview = null;
      this.$emit('input', null);
    }
  }
});

/***/ }),

/***/ "339y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue_es_components_collapse_collapse__ = __webpack_require__("UePd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue_es_components_collapse_collapse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_bootstrap_vue_es_components_collapse_collapse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_vue_es_directives_toggle_toggle__ = __webpack_require__("nIHM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_vue_es_directives_toggle_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_bootstrap_vue_es_directives_toggle_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__comps_accordion__ = __webpack_require__("IznZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__i18n_mycourses__ = __webpack_require__("1ZG6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__misc_utils_js__ = __webpack_require__("QD4S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__backendURL_js__ = __webpack_require__("ksDr");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'mycourses-view',
  data: function data() {
    return {
      cats: [],
      courses: [],

      sortBy: 'nameDESC',
      searchStr: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])(['profile', 'note', 'auth']), {

    i18n: function i18n() {
      return __WEBPACK_IMPORTED_MODULE_7__i18n_mycourses__[this.$store.state.profile.lang];
    },
    avatarURL: function avatarURL() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__backendURL_js__["a" /* default */])() + '/storage/img/download/' + this.profile.avatar;
    },
    nameSortIcon: function nameSortIcon() {
      return {
        'fas fa-sort-up': this.sortBy === 'nameASC',
        'fas fa-sort-down': this.sortBy === 'nameDESC',
        'fas fa-sort': /date/.test(this.sortBy)
      };
    },
    dateSortIcon: function dateSortIcon() {
      return {
        'fas fa-sort-up': this.sortBy === 'dateASC',
        'fas fa-sort-down': this.sortBy === 'dateDESC',
        'fas fa-sort': /name/.test(this.sortBy)
      };
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_8__misc_utils_js__["a" /* default */], {
    search: function search(courses) {
      var searchStr = this.searchStr;

      if (searchStr === '') return courses;
      return courses.filter(function (course) {
        var re = new RegExp(searchStr, 'i');
        return re.test(course.name);
      });
    },
    filter: function filter(courses) {
      if (courses.length === 0) return courses;
      var activeCats = this.cats.filter(function (c) {
        return c.on;
      }).map(function (c) {
        return c.label;
      });
      if (activeCats.length === 0) return courses;
      return courses.filter(function (c) {
        return activeCats.includes(c.category);
      });
    },
    sort: function sort(_courses) {
      var courses = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_courses));
      var by = this.sortBy;
      if (by === 'nameASC') {
        return courses.sort(function (c1, c2) {
          return c1.name < c2.name;
        });
      }
      if (by === 'nameDESC') {
        return courses.sort(function (c1, c2) {
          return c1.name >= c2.name;
        });
      }
      if (by === 'dateASC') {
        return courses.sort(function (c1, c2) {
          return c1.createDate < c2.createDate;
        });
      }
      if (by === 'dateDESC') {
        return courses.sort(function (c1, c2) {
          return c1.createDate >= c2.createDate;
        });
      }
      return courses;
    },
    sortByName: function sortByName() {
      if (this.sortBy === 'nameASC') {
        this.sortBy = 'nameDESC';
        return;
      }
      if (this.sortBy === 'nameDESC') {
        this.sortBy = 'nameASC';
        return;
      }
      this.sortBy = 'nameDESC';
    },
    sortByDate: function sortByDate() {
      if (this.sortBy === 'dateASC') {
        this.sortBy = 'dateDESC';
        return;
      }
      if (this.sortBy === 'dateDESC') {
        this.sortBy = 'dateASC';
        return;
      }
      this.sortBy = 'dateDESC';
    }
  }),
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next();
  },
  mounted: function mounted() {
    document.querySelector('#tab-focus').focus();
  },
  created: function created() {
    var ctx = this;
    this.$store.commit('setBusy', true);
    this.$store.commit('clearMyCourse');
    /*
     * fetch courses */
    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get('accounts/' + ctx.auth.userId + '/mycourses?filter[include]=author').then(function (_ref) {
      var data = _ref.data;

      ctx.courses = data;
      /*
       * create filters from categories */
      var filters = [];
      var cats = ctx.courses.map(function (course) {
        return course.category;
      });
      cats.forEach(function (cat) {
        if (filters.indexOf(cat) === -1) filters.push(cat);
      });
      ctx.cats = filters.map(function (f) {
        return { label: f, on: false };
      });
    }).catch(function (err) {
      return console.error(err);
    }).then(function () {
      return ctx.$store.commit('setBusy', false);
    });
  },

  components: {
    lyAccordion: __WEBPACK_IMPORTED_MODULE_5__comps_accordion__["a" /* default */], bCollapse: __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue_es_components_collapse_collapse___default.a, vBToggle: __WEBPACK_IMPORTED_MODULE_4_bootstrap_vue_es_directives_toggle_toggle___default.a
  }
});

/***/ }),

/***/ "39ur":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__comps_header__ = __webpack_require__("Sl7e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__comps_footer__ = __webpack_require__("N/Iy");
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  watch: {
    '$route': 'relocateUnauthorized'
  },
  created: function created() {
    /*
     * restore auth from local storage */
    var auth = this.$ls.get('auth', false);
    if (!auth) return;
    console.log('Auth restored');
    this.$store.commit('login', auth);
    this.$store.dispatch('fetchProfile');
    this.$store.dispatch('fetchRole');
  },

  methods: {
    relocateUnauthorized: function relocateUnauthorized() {
      /* DSE Speciale */
      var dse = true;
      if (dse) return;

      /* pass access if auth true */
      if (this.$ls.get('auth', false)) return;

      var publicURLs = ['#/', '#/login', '#/register', '#/imprint', '#/privacy', '#/dse', '#/dse/overview', '#/dse/long-term-support', '#/dse/accounting-finance', '#/dse/marketing-sales', '#/dse/public-relations', '#/dse/it'];

      /* target url is public */
      if (publicURLs.includes(location.hash)) return;

      /* auth first */
      this.$router.push('/login');
    }
  },
  components: { lyHeader: __WEBPACK_IMPORTED_MODULE_0__comps_header__["a" /* default */], lyFooter: __WEBPACK_IMPORTED_MODULE_1__comps_footer__["a" /* default */] }
});

/***/ }),

/***/ "3E4u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"navigation-sidebar","aria-labelledy":"navigation-titel","role":"navigation"}},[_c('h4',{attrs:{"id":"navigation-titel"}},[_c('span',{staticClass:"sr-only"},[_vm._v(_vm._s(_vm.i18n.submenu))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.i18n.content))])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"toc"},[_c('router-link',{attrs:{"to":"/dse/overview"}},[_c('span',[_vm._v(_vm._s(_vm.i18n.overview))])])],1),_vm._v(" "),_c('div',{staticClass:"toc"},[_c('span',[_vm._v(_vm._s(_vm.i18n.longTermSupport))]),_vm._v(" "),_c('router-link',{attrs:{"to":"/dse/long-term-support-1"}},[_c('span',[_vm._v(_vm._s(_vm.i18n.skillsAndTalents))])]),_vm._v(" "),_c('router-link',{attrs:{"to":"/dse/long-term-support-2"}},[_c('span',[_vm._v(_vm._s(_vm.i18n.yourMap))])]),_vm._v(" "),_c('router-link',{attrs:{"to":"/dse/long-term-support-3"}},[_c('span',[_vm._v(_vm._s(_vm.i18n.motivationAndEmotionalIntelligence))])]),_vm._v(" "),_c('router-link',{attrs:{"to":"/dse/long-term-support-4"}},[_c('span',[_vm._v(_vm._s(_vm.i18n.alliancesCompromisesAndResources))])]),_vm._v(" "),_c('router-link',{attrs:{"to":"/dse/long-term-support-5"}},[_c('span',[_vm._v(_vm._s(_vm.i18n.skillsToStartABusiness))])])],1),_vm._v(" "),_c('div',{staticClass:"toc"},[_c('span',[_vm._v(_vm._s(_vm.i18n.accountingAndFinance))]),_vm._v(" "),_c('router-link',{attrs:{"to":"/dse/accounting-finance-1"}},[_c('span',[_vm._v(_vm._s(_vm.i18n.settingUpYourOwnBusiness))])]),_vm._v(" "),_c('router-link',{attrs:{"to":"/dse/accounting-finance-2"}},[_c('span',[_vm._v(_vm._s(_vm.i18n.accountingBasics))])]),_vm._v(" "),_c('router-link',{attrs:{"to":"/dse/accounting-finance-3"}},[_c('span',[_vm._v(_vm._s(_vm.i18n.openingABankAccount))])]),_vm._v(" "),_c('router-link',{attrs:{"to":"/dse/accounting-finance-4"}},[_c('span',[_vm._v(_vm._s(_vm.i18n.businessPlanBasicInformation))])]),_vm._v(" "),_c('router-link',{attrs:{"to":"/dse/accounting-finance-5"}},[_c('span',[_vm._v(_vm._s(_vm.i18n.taxes))])]),_vm._v(" "),_c('router-link',{attrs:{"to":"/dse/accounting-finance-6"}},[_c('span',[_vm._v(_vm._s(_vm.i18n.legalFormsOfEmployment))])])],1),_vm._v(" "),_c('div',{staticClass:"toc"},[_c('span',[_vm._v(_vm._s(_vm.i18n.marketingAndSales))]),_vm._v(" "),_c('router-link',{attrs:{"to":"/dse/marketing-sales-1"}},[_c('span',[_vm._v(_vm._s(_vm.i18n.whatAreMyProducts))])]),_vm._v(" "),_c('router-link',{attrs:{"to":"/dse/marketing-sales-2"}},[_c('span',[_vm._v(_vm._s(_vm.i18n.whoAreMyClients))])]),_vm._v(" "),_c('router-link',{attrs:{"to":"/dse/marketing-sales-3"}},[_c('span',[_vm._v(_vm._s(_vm.i18n.communication))])]),_vm._v(" "),_c('router-link',{attrs:{"to":"/dse/marketing-sales-4"}},[_c('span',[_vm._v(_vm._s(_vm.i18n.positioning))])]),_vm._v(" "),_c('router-link',{attrs:{"to":"/dse/marketing-sales-5"}},[_c('span',[_vm._v(_vm._s(_vm.i18n.sales))])]),_vm._v(" "),_c('router-link',{attrs:{"to":"/dse/marketing-sales-6"}},[_c('span',[_vm._v(_vm._s(_vm.i18n.uniqueSellingPoints))])])],1),_vm._v(" "),_c('div',{staticClass:"toc"},[_c('span',[_vm._v(_vm._s(_vm.i18n.publicRelations))]),_vm._v(" "),_c('router-link',{attrs:{"to":"/dse/public-relations-1"}},[_c('span',[_vm._v(_vm._s(_vm.i18n.introduction))])]),_vm._v(" "),_c('router-link',{attrs:{"to":"/dse/public-relations-2"}},[_c('span',[_vm._v(_vm._s(_vm.i18n.strategy))])]),_vm._v(" "),_c('router-link',{attrs:{"to":"/dse/public-relations-3"}},[_c('span',[_vm._v(_vm._s(_vm.i18n.communication))])]),_vm._v(" "),_c('router-link',{attrs:{"to":"/dse/public-relations-4"}},[_c('span',[_vm._v(_vm._s(_vm.i18n.messagesAndTools))])]),_vm._v(" "),_c('router-link',{attrs:{"to":"/dse/public-relations-5"}},[_c('span',[_vm._v(_vm._s(_vm.i18n.digitalPRAndSMRevolution))])])],1),_vm._v(" "),_c('div',{staticClass:"toc"},[_c('span',[_vm._v(_vm._s(_vm.i18n.it))]),_vm._v(" "),_c('router-link',{attrs:{"to":"/dse/it-1"}},[_c('span',[_vm._v(_vm._s(_vm.i18n.cloudVSOnPremises))])]),_vm._v(" "),_c('router-link',{attrs:{"to":"/dse/it-2"}},[_c('span',[_vm._v(_vm._s(_vm.i18n.email))])]),_vm._v(" "),_c('router-link',{attrs:{"to":"/dse/it-3"}},[_c('span',[_vm._v(_vm._s(_vm.i18n.onlineMarketing))])]),_vm._v(" "),_c('router-link',{attrs:{"to":"/dse/it-4"}},[_c('span',[_vm._v(_vm._s(_vm.i18n.webshop))])]),_vm._v(" "),_c('router-link',{attrs:{"to":"/dse/it-5"}},[_c('span',[_vm._v(_vm._s(_vm.i18n.website))])])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3EWg":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+Cjxzdmcgd2lkdGg9IjI2cHgiIGhlaWdodD0iMjZweCIgdmlld0JveD0iMCAwIDI2IDI2IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCAzLjcuMiAoMjgyNzYpIC0gaHR0cDovL3d3dy5ib2hlbWlhbmNvZGluZy5jb20vc2tldGNoIC0tPgogICAgPHRpdGxlPmZhY2Vib29rPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+CiAgICAgICAgPHBvbHlnb24gaWQ9InBhdGgtMSIgcG9pbnRzPSIwIDI2IDI1LjcyNyAyNiAyNS43MjcgMC40MTggMCAwLjQxOCI+PC9wb2x5Z29uPgogICAgPC9kZWZzPgogICAgPGcgaWQ9IlBhZ2UtMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9ImZhY2Vib29rIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjAwMDAwMCwgLTEuMDAwMDAwKSI+CiAgICAgICAgICAgIDxnIGlkPSJQYWdlLTEiPgogICAgICAgICAgICAgICAgPGcgaWQ9Ikdyb3VwLTMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuMDAwMDAwLCAwLjU4MTcwMCkiPgogICAgICAgICAgICAgICAgICAgIDxtYXNrIGlkPSJtYXNrLTIiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgICAgICAgICAgICAgPHVzZSB4bGluazpocmVmPSIjcGF0aC0xIj48L3VzZT4KICAgICAgICAgICAgICAgICAgICA8L21hc2s+CiAgICAgICAgICAgICAgICAgICAgPGcgaWQ9IkNsaXAtMiI+PC9nPgogICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0xMi44NjM2LDI2IEMxOS45Njc2LDI2IDI1LjcyNzYsMjAuMjczIDI1LjcyNzYsMTMuMjA5IEMyNS43Mjc2LDYuMTQ1IDE5Ljk2NzYsMC40MTggMTIuODYzNiwwLjQxOCBDNS43NTk2LDAuNDE4IC0wLjAwMDQsNi4xNDUgLTAuMDAwNCwxMy4yMDkgQy0wLjAwMDQsMjAuMjczIDUuNzU5NiwyNiAxMi44NjM2LDI2IiBpZD0iRmlsbC0xIiBmaWxsPSIjMUQxQzFCIiBtYXNrPSJ1cmwoI21hc2stMikiPjwvcGF0aD4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0xMy45MzU1LDIwLjc2NDIgTDExLjA1NDUsMjAuNzY0MiBMMTEuMDU0NSwxMy43OTAyIEw5LjYxNDUsMTMuNzkwMiBMOS42MTQ1LDExLjM4NzIgTDExLjA1NDUsMTEuMzg3MiBMMTEuMDU0NSw5Ljk0NDIgQzExLjA1NDUsNy45ODMyIDExLjg2NzUsNi44MTcyIDE0LjE3NjUsNi44MTcyIEwxNi4wOTk1LDYuODE3MiBMMTYuMDk5NSw5LjIyMTIgTDE0Ljg5NzUsOS4yMjEyIEMxMy45OTg1LDkuMjIxMiAxMy45Mzk1LDkuNTU3MiAxMy45Mzk1LDEwLjE4NDIgTDEzLjkzNTUsMTEuMzg3MiBMMTYuMTEyNSwxMS4zODcyIEwxNS44NTg1LDEzLjc5MDIgTDEzLjkzNTUsMTMuNzkwMiBMMTMuOTM1NSwyMC43NjQyIFoiIGlkPSJGaWxsLTQiIGZpbGw9IiNGRUZFRkUiPjwvcGF0aD4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+"

/***/ }),

/***/ "3uio":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_course_detail_vue__ = __webpack_require__("Db5O");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44bfabbe_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_course_detail_vue__ = __webpack_require__("v0mw");
function injectStyle (ssrContext) {
  __webpack_require__("J2v2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-44bfabbe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_course_detail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44bfabbe_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_course_detail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "4JXS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_quiz_schoice_vue__ = __webpack_require__("Swq6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e2113966_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_quiz_schoice_vue__ = __webpack_require__("rHpT");
function injectStyle (ssrContext) {
  __webpack_require__("JrZY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e2113966"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_quiz_schoice_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e2113966_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_quiz_schoice_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4M8H":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "4U1n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"privacy-view"},[_c('div',{staticClass:"container mt-3"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('h1',[_c('b',[_vm._v("Datenschutzbestimmungen")])]),_vm._v(" "),_c('div',{staticStyle:{"height":"1rem"}}),_vm._v(" "),_c('div',{staticClass:"WordSection1"},[_c('p',{staticClass:"MsoNormal"},[_vm._v("Wir freuen uns sehr über Ihr Interesse an unserem\n            Unternehmen. Datenschutz hat einen besonders hohen Stellenwert für die\n            Geschäftsleitung der KOPF, HAND und FUSS gemeinnützige Gesellschaft für Bildung\n            mbH. Eine Nutzung der Internetseiten der KOPF, HAND und FUSS gemeinnützige\n            Gesellschaft für Bildung mbH ist grundsätzlich ohne jede Angabe\n            personenbezogener Daten möglich. Sofern eine betroffene Person besondere\n            Services unseres Unternehmens über unsere Internetseite in Anspruch nehmen\n            möchte, könnte jedoch eine Verarbeitung personenbezogener Daten erforderlich\n            werden. Ist die Verarbeitung personenbezogener Daten erforderlich und besteht\n            für eine solche Verarbeitung keine gesetzliche Grundlage, holen wir generell\n            eine Einwilligung der betroffenen Person ein.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Die Verarbeitung personenbezogener Daten, beispielsweise des\n            Namens, der Anschrift, E-Mail-Adresse oder Telefonnummer einer betroffenen\n            Person, erfolgt stets im Einklang mit der Datenschutz-Grundverordnung und in\n            Übereinstimmung mit den für die KOPF, HAND und FUSS gemeinnützige Gesellschaft\n            für Bildung mbH geltenden landesspezifischen Datenschutzbestimmungen. Mittels\n            dieser Datenschutzerklärung möchte unser Unternehmen die Öffentlichkeit über\n            Art, Umfang und Zweck der von uns erhobenen, genutzten und verarbeiteten\n            personenbezogenen Daten informieren. Ferner werden betroffene Personen mittels\n            dieser Datenschutzerklärung über die ihnen zustehenden Rechte aufgeklärt.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Die KOPF, HAND und FUSS gemeinnützige Gesellschaft für\n            Bildung mbH hat als für die Verarbeitung Verantwortlicher zahlreiche technische\n            und organisatorische Maßnahmen umgesetzt, um einen möglichst lückenlosen Schutz\n            der über diese Internetseite verarbeiteten personenbezogenen Daten\n            sicherzustellen. Dennoch können Internetbasierte Datenübertragungen\n            grundsätzlich Sicherheitslücken aufweisen, sodass ein absoluter Schutz nicht\n            gewährleistet werden kann. Aus diesem Grund steht es jeder betroffenen Person\n            frei, personenbezogene Daten auch auf alternativen Wegen, beispielsweise\n            telefonisch, an uns zu übermitteln.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("1. Begriffsbestimmungen")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Die Datenschutzerklärung der KOPF, HAND und FUSS\n            gemeinnützige Gesellschaft für Bildung mbH beruht auf den Begrifflichkeiten,\n            die durch den Europäischen Richtlinien- und Verordnungsgeber beim Erlass der\n            Datenschutz-Grundverordnung (DS-GVO) verwendet wurden. Unsere\n            Datenschutzerklärung soll sowohl für die Öffentlichkeit als auch für unsere\n            Kunden und Geschäftspartner einfach lesbar und verständlich sein. Um dies zu\n            gewährleisten, möchten wir vorab die verwendeten Begrifflichkeiten erläutern.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Wir verwenden in dieser Datenschutzerklärung unter anderem\n            die folgenden Begriffe:")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("a)    personenbezogene Daten")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Personenbezogene Daten sind alle Informationen, die sich auf\n            eine identifizierte oder identifizierbare natürliche Person (im Folgenden\n            „betroffene Person“) beziehen. Als identifizierbar wird eine natürliche Person\n            angesehen, die direkt oder indirekt, insbesondere mittels Zuordnung zu einer\n            Kennung wie einem Namen, zu einer Kennnummer, zu Standortdaten, zu einer\n            Online-Kennung oder zu einem oder mehreren besonderen Merkmalen, die Ausdruck\n            der physischen, physiologischen, genetischen, psychischen, wirtschaftlichen,\n            kulturellen oder sozialen Identität dieser natürlichen Person sind,\n            identifiziert werden kann.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("b)    betroffene Person")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Betroffene Person ist jede identifizierte oder\n            identifizierbare natürliche Person, deren personenbezogene Daten von dem für\n            die Verarbeitung Verantwortlichen verarbeitet werden.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("c)    Verarbeitung")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Verarbeitung ist jeder mit oder ohne Hilfe automatisierter\n            Verfahren ausgeführte Vorgang oder jede solche Vorgangsreihe im Zusammenhang\n            mit personenbezogenen Daten wie das Erheben, das Erfassen, die Organisation,\n            das Ordnen, die Speicherung, die Anpassung oder Veränderung, das Auslesen, das\n            Abfragen, die Verwendung, die Offenlegung durch Übermittlung, Verbreitung oder\n            eine andere Form der Bereitstellung, den Abgleich oder die Verknüpfung, die\n            Einschränkung, das Löschen oder die Vernichtung.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("d)    Einschränkung der Verarbeitung")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Einschränkung der Verarbeitung ist die Markierung\n            gespeicherter personenbezogener Daten mit dem Ziel, ihre künftige Verarbeitung\n            einzuschränken.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("e)    Profiling")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Profiling ist jede Art der automatisierten Verarbeitung\n            personenbezogener Daten, die darin besteht, dass diese personenbezogenen Daten\n            verwendet werden, um bestimmte persönliche Aspekte, die sich auf eine\n            natürliche Person beziehen, zu bewerten, insbesondere, um Aspekte bezüglich\n            Arbeitsleistung, wirtschaftlicher Lage, Gesundheit, persönlicher Vorlieben,\n            Interessen, Zuverlässigkeit, Verhalten, Aufenthaltsort oder Ortswechsel dieser\n            natürlichen Person zu analysieren oder vorherzusagen.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("f)     Pseudonymisierung")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Pseudonymisierung ist die Verarbeitung personenbezogener\n            Daten in einer Weise, auf welche die personenbezogenen Daten ohne Hinzuziehung\n            zusätzlicher Informationen nicht mehr einer spezifischen betroffenen Person\n            zugeordnet werden können, sofern diese zusätzlichen Informationen gesondert\n            aufbewahrt werden und technischen und organisatorischen Maßnahmen unterliegen,\n            die gewährleisten, dass die personenbezogenen Daten nicht einer identifizierten\n            oder identifizierbaren natürlichen Person zugewiesen werden.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("g)    Verantwortlicher oder für die Verarbeitung\n            Verantwortlicher")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Verantwortlicher oder für die Verarbeitung Verantwortlicher\n            ist die natürliche oder juristische Person, Behörde, Einrichtung oder andere\n            Stelle, die allein oder gemeinsam mit anderen über die Zwecke und Mittel der\n            Verarbeitung von personenbezogenen Daten entscheidet. Sind die Zwecke und\n            Mittel dieser Verarbeitung durch das Unionsrecht oder das Recht der\n            Mitgliedstaaten vorgegeben, so kann der Verantwortliche beziehungsweise können\n            die bestimmten Kriterien seiner Benennung nach dem Unionsrecht oder dem Recht\n            der Mitgliedstaaten vorgesehen werden.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("h)    Auftragsverarbeiter")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Auftragsverarbeiter ist eine natürliche oder juristische\n            Person, Behörde, Einrichtung oder andere Stelle, die personenbezogene Daten im\n            Auftrag des Verantwortlichen verarbeitet.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("i)      Empfänger")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Empfänger ist eine natürliche oder juristische Person,\n            Behörde, Einrichtung oder andere Stelle, der personenbezogene Daten offengelegt\n            werden, unabhängig davon, ob es sich bei ihr um einen Dritten handelt oder\n            nicht. Behörden, die im Rahmen eines bestimmten Untersuchungsauftrags nach dem\n            Unionsrecht oder dem Recht der Mitgliedstaaten möglicherweise personenbezogene\n            Daten erhalten, gelten jedoch nicht als Empfänger.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("j)      Dritter")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Dritter ist eine natürliche oder juristische Person,\n            Behörde, Einrichtung oder andere Stelle außer der betroffenen Person, dem\n            Verantwortlichen, dem Auftragsverarbeiter und den Personen, die unter der\n            unmittelbaren Verantwortung des Verantwortlichen oder des Auftragsverarbeiters\n            befugt sind, die personenbezogenen Daten zu verarbeiten.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("k)    Einwilligung")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Einwilligung ist jede von der betroffenen Person freiwillig\n            für den bestimmten Fall in informierter Weise und unmissverständlich abgegebene\n            Willensbekundung in Form einer Erklärung oder einer sonstigen eindeutigen\n            bestätigenden Handlung, mit der die betroffene Person zu verstehen gibt, dass\n            sie mit der Verarbeitung der sie betreffenden personenbezogenen Daten\n            einverstanden ist.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("2. Name und Anschrift des für die Verarbeitung\n            Verantwortlichen")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Verantwortlicher im Sinne der Datenschutz-Grundverordnung,\n            sonstiger in den Mitgliedstaaten der Europäischen Union geltenden\n            Datenschutzgesetze und anderer Bestimmungen mit datenschutzrechtlichem\n            Charakter ist die:")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("KOPF, HAND und FUSS gemeinnützige Gesellschaft für Bildung\n            mbH")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Ludwigkirchstr. 2")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("10719 Berlin")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Deutschland")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Tel.: 030 8321 66 40")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("E-Mail: info@kopfhandundfuss.de")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Website: https://www.kopfhandundfuss.de")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("3. Erfassung von allgemeinen Daten und Informationen")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Die Internetseite der KOPF, HAND und FUSS gemeinnützige\n            Gesellschaft für Bildung mbH erfasst mit jedem Aufruf der Internetseite durch\n            eine betroffene Person oder ein automatisiertes System eine Reihe von\n            allgemeinen Daten und Informationen. Diese allgemeinen Daten und Informationen\n            werden in den Logfiles des Servers gespeichert. Erfasst werden können die (1)\n            verwendeten Browsertypen und Versionen, (2) das vom zugreifenden System\n            verwendete Betriebssystem, (3) die Internetseite, von welcher ein zugreifendes\n            System auf unsere Internetseite gelangt (sogenannte Referrer), (4) die\n            Unterwebseiten, welche über ein zugreifendes System auf unserer Internetseite\n            angesteuert werden, (5) das Datum und die Uhrzeit eines Zugriffs auf die\n            Internetseite, (6) eine Internet-Protokoll-Adresse (IP-Adresse), (7) der\n            Internet-Service-Provider des zugreifenden Systems und (8) sonstige ähnliche\n            Daten und Informationen, die der Gefahrenabwehr im Falle von Angriffen auf\n            unsere informationstechnologischen Systeme dienen.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Bei der Nutzung dieser allgemeinen Daten und Informationen\n            zieht die KOPF, HAND und FUSS gemeinnützige Gesellschaft für Bildung mbH keine\n            Rückschlüsse auf die betroffene Person. Diese Informationen werden vielmehr\n            benötigt, um (1) die Inhalte unserer Internetseite korrekt auszuliefern, (2)\n            die Inhalte unserer Internetseite sowie die Werbung für diese zu optimieren,\n            (3) die dauerhafte Funktionsfähigkeit unserer informationstechnologischen\n            Systeme und der Technik unserer Internetseite zu gewährleisten sowie (4) um\n            Strafverfolgungsbehörden im Falle eines Cyberangriffes die zur Strafverfolgung\n            notwendigen Informationen bereitzustellen. Diese anonym erhobenen Daten und\n            Informationen werden durch die KOPF, HAND und FUSS gemeinnützige Gesellschaft\n            für Bildung mbH daher einerseits statistisch und ferner mit dem Ziel\n            ausgewertet, den Datenschutz und die Datensicherheit in unserem Unternehmen zu\n            erhöhen, um letztlich ein optimales Schutzniveau für die von uns verarbeiteten\n            personenbezogenen Daten sicherzustellen. Die anonymen Daten der Server-Logfiles\n            werden getrennt von allen durch eine betroffene Person angegebenen\n            personenbezogenen Daten gespeichert.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("4. Registrierung auf unserer Internetseite")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Die betroffene Person hat die Möglichkeit, sich auf der\n            Internetseite des für die Verarbeitung Verantwortlichen unter Angabe von\n            personenbezogenen Daten zu registrieren. Welche personenbezogenen Daten dabei\n            an den für die Verarbeitung Verantwortlichen übermittelt werden, ergibt sich\n            aus der jeweiligen Eingabemaske, die für die Registrierung verwendet wird. Die\n            von der betroffenen Person eingegebenen personenbezogenen Daten werden\n            ausschließlich für die interne Verwendung bei dem für die Verarbeitung\n            Verantwortlichen und für eigene Zwecke erhoben und gespeichert. Der für die\n            Verarbeitung Verantwortliche kann die Weitergabe an einen oder mehrere\n            Auftragsverarbeiter, beispielsweise einen Paketdienstleister, veranlassen, der\n            die personenbezogenen Daten ebenfalls ausschließlich für eine interne\n            Verwendung, die dem für die Verarbeitung Verantwortlichen zuzurechnen ist,\n            nutzt.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Durch eine Registrierung auf der Internetseite des für die\n            Verarbeitung Verantwortlichen wird ferner die vom Internet-Service-Provider\n            (ISP) der betroffenen Person vergebene IP-Adresse, das Datum sowie die Uhrzeit\n            der Registrierung gespeichert. Die Speicherung dieser Daten erfolgt vor dem\n            Hintergrund, dass nur so der Missbrauch unserer Dienste verhindert werden kann,\n            und diese Daten im Bedarfsfall ermöglichen, begangene Straftaten aufzuklären.\n            Insofern ist die Speicherung dieser Daten zur Absicherung des für die\n            Verarbeitung Verantwortlichen erforderlich. Eine Weitergabe dieser Daten an\n            Dritte erfolgt grundsätzlich nicht, sofern keine gesetzliche Pflicht zur\n            Weitergabe besteht oder die Weitergabe der Strafverfolgung dient.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Die Registrierung der betroffenen Person unter freiwilliger\n            Angabe personenbezogener Daten dient dem für die Verarbeitung Verantwortlichen\n            dazu, der betroffenen Person Inhalte oder Leistungen anzubieten, die aufgrund\n            der Natur der Sache nur registrierten Benutzern angeboten werden können.\n            Registrierten Personen steht die Möglichkeit frei, die bei der Registrierung\n            angegebenen personenbezogenen Daten jederzeit abzuändern oder vollständig aus\n            dem Datenbestand des für die Verarbeitung Verantwortlichen löschen zu lassen.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Der für die Verarbeitung Verantwortliche erteilt jeder\n            betroffenen Person jederzeit auf Anfrage Auskunft darüber, welche\n            personenbezogenen Daten über die betroffene Person gespeichert sind. Ferner\n            berichtigt oder löscht der für die Verarbeitung Verantwortliche\n            personenbezogene Daten auf Wunsch oder Hinweis der betroffenen Person, soweit\n            dem keine gesetzlichen Aufbewahrungspflichten entgegenstehen. Die Gesamtheit\n            der Mitarbeiter des für die Verarbeitung Verantwortlichen stehen der\n            betroffenen Person in diesem Zusammenhang als Ansprechpartner zur Verfügung.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("5. Abonnement unseres Newsletters")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Auf der Internetseite der KOPF, HAND und FUSS gemeinnützige\n            Gesellschaft für Bildung mbH wird den Benutzern die Möglichkeit eingeräumt, den\n            Newsletter unseres Unternehmens zu abonnieren. Welche personenbezogenen Daten\n            bei der Bestellung des Newsletters an den für die Verarbeitung Verantwortlichen\n            übermittelt werden, ergibt sich aus der hierzu verwendeten Eingabemaske.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Die KOPF, HAND und FUSS gemeinnützige Gesellschaft für\n            Bildung mbH informiert ihre Kunden und Geschäftspartner in regelmäßigen\n            Abständen im Wege eines Newsletters über Angebote des Unternehmens. Der\n            Newsletter unseres Unternehmens kann von der betroffenen Person grundsätzlich\n            nur dann empfangen werden, wenn (1) die betroffene Person über eine gültige\n            E-Mail-Adresse verfügt und (2) die betroffene Person sich für den\n            Newsletterversand registriert. An die von einer betroffenen Person erstmalig\n            für den Newsletterversand eingetragene E-Mail-Adresse wird aus rechtlichen\n            Gründen eine Bestätigungsmail im Double-Opt-In-Verfahren versendet. Diese\n            Bestätigungsmail dient der Überprüfung, ob der Inhaber der E-Mail-Adresse als\n            betroffene Person den Empfang des Newsletters autorisiert hat.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Bei der Anmeldung zum Newsletter speichern wir ferner die\n            vom Internet-Service-Provider (ISP) vergebene IP-Adresse des von der\n            betroffenen Person zum Zeitpunkt der Anmeldung verwendeten Computersystems\n            sowie das Datum und die Uhrzeit der Anmeldung. Die Erhebung dieser Daten ist\n            erforderlich, um den(möglichen) Missbrauch der E-Mail-Adresse einer betroffenen\n            Person zu einem späteren Zeitpunkt nachvollziehen zu können und dient deshalb\n            der rechtlichen Absicherung des für die Verarbeitung Verantwortlichen.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Die im Rahmen einer Anmeldung zum Newsletter erhobenen\n            personenbezogenen Daten werden ausschließlich zum Versand unseres Newsletters\n            verwendet. Ferner könnten Abonnenten des Newsletters per E-Mail informiert\n            werden, sofern dies für den Betrieb des Newsletter-Dienstes oder eine\n            diesbezügliche Registrierung erforderlich ist, wie dies im Falle von Änderungen\n            am Newsletterangebot oder bei der Veränderung der technischen Gegebenheiten der\n            Fall sein könnte. Es erfolgt keine Weitergabe der im Rahmen des\n            Newsletter-Dienstes erhobenen personenbezogenen Daten an Dritte. Das Abonnement\n            unseres Newsletters kann durch die betroffene Person jederzeit gekündigt\n            werden. Die Einwilligung in die Speicherung personenbezogener Daten, die die\n            betroffene Person uns für den Newsletterversand erteilt hat, kann jederzeit\n            widerrufen werden. Zum Zwecke des Widerrufs der Einwilligung findet sich in\n            jedem Newsletter ein entsprechender Link. Ferner besteht die Möglichkeit, sich\n            jederzeit auch direkt auf der Internetseite des für die Verarbeitung\n            Verantwortlichen vom Newsletterversand abzumelden oder dies dem für die\n            Verarbeitung Verantwortlichen auf andere Weise mitzuteilen.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("6. Newsletter-Tracking")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Die Newsletter der KOPF, HAND und FUSS gemeinnützige\n            Gesellschaft für Bildung mbH enthalten sogenannte Zählpixel. Ein Zählpixel ist\n            eine Miniaturgrafik, die in solche E-Mails eingebettet wird, welche im\n            HTML-Format versendet werden, um eine Logdatei-Aufzeichnung und eine\n            Logdatei-Analyse zu ermöglichen. Dadurch kann eine statistische Auswertung des\n            Erfolges oder Misserfolges von Online-Marketing-Kampagnen durchgeführt werden.\n            Anhand des eingebetteten Zählpixels kann die KOPF, HAND und FUSS gemeinnützige\n            Gesellschaft für Bildung mbH erkennen, ob und wann eine E-Mail von einer\n            betroffenen Person geöffnet wurde und welche in der E-Mail befindlichen Links\n            von der betroffenen Person aufgerufen wurden.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Solche über die in den Newslettern enthaltenen Zählpixel\n            erhobenen personenbezogenen Daten, werden von dem für die Verarbeitung\n            Verantwortlichen gespeichert und ausgewertet, um den Newsletterversand zu\n            optimieren und den Inhalt zukünftiger Newsletter noch besser den Interessen der\n            betroffenen Person anzupassen. Diese personenbezogenen Daten werden nicht an\n            Dritte weitergegeben. Betroffene Personen sind jederzeit berechtigt, die\n            diesbezügliche gesonderte, über das Double-Opt-In-Verfahren abgegebene\n            Einwilligungserklärung zu widerrufen. Nach einem Widerruf werden diese\n            personenbezogenen Daten von dem für die Verarbeitung Verantwortlichen gelöscht.\n            Eine Abmeldung vom Erhalt des Newsletters deutet die KOPF, HAND und FUSS\n            gemeinnützige Gesellschaft für Bildung mbH automatisch als Widerruf.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("7. Abonnement von Kommentaren im Blog auf der Internetseite")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Die im Blog der KOPF, HAND und FUSS gemeinnützige\n            Gesellschaft für Bildung mbH abgegebenen Kommentare können grundsätzlich von\n            Dritten abonniert werden. Insbesondere besteht die Möglichkeit, dass ein\n            Kommentator die seinem Kommentar nachfolgenden Kommentare zu einem bestimmten\n            Blog-Beitrag abonniert.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Sofern sich eine betroffene Person für die Option\n            entscheidet, Kommentare zu abonnieren, versendet der für die Verarbeitung\n            Verantwortliche eine automatische Bestätigungsmail, um im\n            Double-Opt-In-Verfahren zu überprüfen, ob sich wirklich der Inhaber der\n            angegebenen E-Mail-Adresse für diese Option entschieden hat. Die Option zum\n            Abonnement von Kommentaren kann jederzeit beendet werden.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("8. Routinemäßige Löschung und Sperrung von personenbezogenen\n            Daten")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Der für die Verarbeitung Verantwortliche verarbeitet und\n            speichert personenbezogene Daten der betroffenen Person nur für den Zeitraum,\n            der zur Erreichung des Speicherungszwecks erforderlich ist oder sofern dies\n            durch den Europäischen Richtlinien- und Verordnungsgeber oder einen anderen\n            Gesetzgeber in Gesetzen oder Vorschriften, welchen der für die Verarbeitung\n            Verantwortliche unterliegt, vorgesehen wurde.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Entfällt der Speicherungszweck oder läuft eine vom\n            Europäischen Richtlinien- und Verordnungsgeber oder einem anderen zuständigen\n            Gesetzgeber vorgeschriebene Speicherfrist ab, werden die personenbezogenen\n            Daten routinemäßig und entsprechend den gesetzlichen Vorschriften gesperrt oder\n            gelöscht.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("9. Rechte der betroffenen Person")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("a)    Recht auf Bestätigung")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Jede betroffene Person hat das vom Europäischen Richtlinien-\n            und Verordnungsgeber eingeräumte Recht, von dem für die Verarbeitung\n            Verantwortlichen eine Bestätigung darüber zu verlangen, ob sie betreffende\n            personenbezogene Daten verarbeitet werden. Möchte eine betroffene Person dieses\n            Bestätigungsrecht in Anspruch nehmen, kann sie sich hierzu jederzeit an einen\n            Mitarbeiter des für die Verarbeitung Verantwortlichen wenden.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("b)    Recht auf Auskunft")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Jede von der Verarbeitung personenbezogener Daten betroffene\n            Person hat das vom Europäischen Richtlinien- und Verordnungsgeber gewährte\n            Recht, jederzeit von dem für die Verarbeitung Verantwortlichen unentgeltliche\n            Auskunft über die zu seiner Person gespeicherten personenbezogenen Daten und\n            eine Kopie dieser Auskunft zu erhalten. Ferner hat der Europäische Richtlinien-\n            und Verordnungsgeber der betroffenen Person Auskunft über folgende\n            Informationen zugestanden:")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("die Verarbeitungszwecke")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("die Kategorien personenbezogener Daten, die verarbeitet\n            werden")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("die Empfänger oder Kategorien von Empfängern, gegenüber\n            denen die personenbezogenen Daten offengelegt worden sind oder noch offengelegt\n            werden, insbesondere bei Empfängern in Drittländern oder bei internationalen\n            Organisationen")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("falls möglich die geplante Dauer, für die die\n            personenbezogenen Daten gespeichert werden, oder, falls dies nicht möglich ist,\n            die Kriterien für die Festlegung dieser Dauer")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("das Bestehen eines Rechts auf Berichtigung oder Löschung der\n            sie betreffenden personenbezogenen Daten oder auf Einschränkung der\n            Verarbeitung durch den Verantwortlichen oder eines Widerspruchsrechts gegen\n            diese Verarbeitung")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("das Bestehen eines Beschwerderechts bei einer\n            Aufsichtsbehörde")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("wenn die personenbezogenen Daten nicht bei der betroffenen\n            Person erhoben werden: Alle verfügbaren Informationen über die Herkunft der\n            Daten")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("das Bestehen einer automatisierten Entscheidungsfindung\n            einschließlich Profiling gemäß Artikel 22 Abs.1 und 4 DS-GVO und — zumindest in\n            diesen Fällen — aussagekräftige Informationen über die involvierte Logik sowie\n            die Tragweite und die angestrebten Auswirkungen einer derartigen Verarbeitung\n            für die betroffene Person")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Ferner steht der betroffenen Person ein Auskunftsrecht\n            darüber zu, ob personenbezogene Daten an ein Drittland oder an eine\n            internationale Organisation übermittelt wurden. Sofern dies der Fall ist, so\n            steht der betroffenen Person im Übrigen das Recht zu, Auskunft über die\n            geeigneten Garantien im Zusammenhang mit der Übermittlung zu erhalten.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Möchte eine betroffene Person dieses Auskunftsrecht in\n            Anspruch nehmen, kann sie sich hierzu jederzeit an einen Mitarbeiter des für\n            die Verarbeitung Verantwortlichen wenden.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("c)    Recht auf Berichtigung")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Jede von der Verarbeitung personenbezogener Daten betroffene\n            Person hat das vom Europäischen Richtlinien- und Verordnungsgeber gewährte\n            Recht, die unverzügliche Berichtigung sie betreffender unrichtiger\n            personenbezogener Daten zu verlangen. Ferner steht der betroffenen Person das\n            Recht zu, unter Berücksichtigung der Zwecke der Verarbeitung, die\n            Vervollständigung unvollständiger personenbezogener Daten — auch mittels einer\n            ergänzenden Erklärung — zu verlangen.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Möchte eine betroffene Person dieses Berichtigungsrecht in\n            Anspruch nehmen, kann sie sich hierzu jederzeit an einen Mitarbeiter des für\n            die Verarbeitung Verantwortlichen wenden.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("d)    Recht auf Löschung (Recht auf Vergessen werden)")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Jede von der Verarbeitung personenbezogener Daten betroffene\n            Person hat das vom Europäischen Richtlinien- und Verordnungsgeber gewährte\n            Recht, von dem Verantwortlichen zu verlangen, dass die sie betreffenden\n            personenbezogenen Daten unverzüglich gelöscht werden, sofern einer der\n            folgenden Gründe zutrifft und soweit die Verarbeitung nicht erforderlich ist:")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Die personenbezogenen Daten wurden für solche Zwecke erhoben\n            oder auf sonstige Weise verarbeitet, für welche sie nicht mehr notwendig sind.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Die betroffene Person widerruft ihre Einwilligung, auf die\n            sich die Verarbeitung gemäß Art. 6 Abs. 1 Buchstabe a DS-GVO oder Art. 9 Abs. 2\n            Buchstabe a DS-GVO stützte, und es fehlt an einer anderweitigen Rechtsgrundlage\n            für die Verarbeitung.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Die betroffene Person legt gemäß Art. 21 Abs. 1 DS-GVO\n            Widerspruch gegen die Verarbeitung ein, und es liegen keine vorrangigen\n            berechtigten Gründe für die Verarbeitung vor, oder die betroffene Person legt\n            gemäß Art. 21 Abs. 2 DS-GVO Widerspruch gegen die Verarbeitung ein.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Die personenbezogenen Daten wurden unrechtmäßig verarbeitet.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Die Löschung der personenbezogenen Daten ist zur Erfüllung\n            einer rechtlichen Verpflichtung nach dem Unionsrecht oder dem Recht der\n            Mitgliedstaaten erforderlich, dem der Verantwortliche unterliegt.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Die personenbezogenen Daten wurden in Bezug auf angebotene\n            Dienste der Informationsgesellschaft gemäß Art. 8 Abs. 1 DS-GVO erhoben.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Sofern einer der oben genannten Gründe zutrifft und eine\n            betroffene Person die Löschung von personenbezogenen Daten, die bei der KOPF,\n            HAND und FUSS gemeinnützige Gesellschaft für Bildung mbH gespeichert sind,\n            veranlassen möchte, kann sie sich hierzu jederzeit an einen Mitarbeiter des für\n            die Verarbeitung Verantwortlichen wenden. Der Mitarbeiter der KOPF, HAND und\n            FUSS gemeinnützige Gesellschaft für Bildung mbH wird veranlassen, dass dem\n            Löschverlangen unverzüglich nachgekommen wird.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Wurden die personenbezogenen Daten von der KOPF, HAND und\n            FUSS gemeinnützige Gesellschaft für Bildung mbH öffentlich gemacht und ist\n            unser Unternehmen als Verantwortlicher gemäß Art. 17 Abs. 1 DS-GVO zur Löschung\n            der personenbezogenen Daten verpflichtet, so trifft die KOPF, HAND und FUSS\n            gemeinnützige Gesellschaft für Bildung mbH unter Berücksichtigung der\n            verfügbaren Technologie und der Implementierungskosten angemessene Maßnahmen,\n            auch technischer Art, um andere für die Datenverarbeitung Verantwortliche,\n            welche die veröffentlichten personenbezogenen Daten verarbeiten, darüber in\n            Kenntnis zu setzen, dass die betroffene Person von diesen anderen für die\n            Datenverarbeitung Verantwortlichen die Löschung sämtlicher Links zu diesen\n            personenbezogenen Daten oder von Kopien oder Replikationen dieser\n            personenbezogenen Daten verlangt hat, soweit die Verarbeitung nicht\n            erforderlich ist. Der Mitarbeiter der KOPF, HAND und FUSS gemeinnützige\n            Gesellschaft für Bildung mbH wird im Einzelfall das Notwendige veranlassen.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("e)    Recht auf Einschränkung der Verarbeitung")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Jede von der Verarbeitung personenbezogener Daten betroffene\n            Person hat das vom Europäischen Richtlinien- und Verordnungsgeber gewährte\n            Recht, von dem Verantwortlichen die Einschränkung der Verarbeitung zu\n            verlangen, wenn eine der folgenden Voraussetzungen gegeben ist:")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Die Richtigkeit der personenbezogenen Daten wird von der\n            betroffenen Person bestritten, und zwar für eine Dauer, die es dem Verantwortlichen\n            ermöglicht, die Richtigkeit der personenbezogenen Daten zu überprüfen.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Die Verarbeitung ist unrechtmäßig, die betroffene Person\n            lehnt die Löschung der personenbezogenen Daten ab und verlangt stattdessen die\n            Einschränkung der Nutzung der personenbezogenen Daten.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Der Verantwortliche benötigt die personenbezogenen Daten für\n            die Zwecke der Verarbeitung nicht länger, die betroffene Person benötigt sie\n            jedoch zur Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Die betroffene Person hat Widerspruch gegen die Verarbeitung\n            gem. Art. 21 Abs. 1 DS-GVO eingelegt und es steht noch nicht fest, ob die\n            berechtigten Gründe des Verantwortlichen gegenüber denen der betroffenen Person\n            überwiegen.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Sofern eine der oben genannten Voraussetzungen gegeben ist\n            und eine betroffene Person die Einschränkung von personenbezogenen Daten, die\n            bei der KOPF, HAND und FUSS gemeinnützige Gesellschaft für Bildung mbH\n            gespeichert sind, verlangen möchte, kann sie sich hierzu jederzeit an einen\n            Mitarbeiter des für die Verarbeitung Verantwortlichen wenden. Der Mitarbeiter\n            der KOPF, HAND und FUSS gemeinnützige Gesellschaft für Bildung mbH wird die\n            Einschränkung der Verarbeitung veranlassen.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("f)     Recht auf Datenübertragbarkeit")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Jede von der Verarbeitung personenbezogener Daten betroffene\n            Person hat das vom Europäischen Richtlinien- und Verordnungsgeber gewährte\n            Recht, die sie betreffenden personenbezogenen Daten, welche durch die\n            betroffene Person einem Verantwortlichen bereitgestellt wurden, in einem\n            strukturierten, gängigen und maschinenlesbaren Format zu erhalten. Sie hat\n            außerdem das Recht, diese Daten einem anderen Verantwortlichen ohne Behinderung\n            durch den Verantwortlichen, dem die personenbezogenen Daten bereitgestellt\n            wurden, zu übermitteln, sofern die Verarbeitung auf der Einwilligung gemäß Art.\n            6 Abs. 1 Buchstabe a DS-GVO oder Art. 9 Abs. 2 Buchstabe a DS-GVO oder auf\n            einem Vertrag gemäß Art. 6 Abs. 1 Buchstabe b DS-GVO beruht und die\n            Verarbeitung mithilfe automatisierter Verfahren erfolgt, sofern die\n            Verarbeitung nicht für die Wahrnehmung einer Aufgabe erforderlich ist, die im\n            öffentlichen Interesse liegt oder in Ausübung öffentlicher Gewalt erfolgt,\n            welche dem Verantwortlichen übertragen wurde.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Ferner hat die betroffene Person bei der Ausübung ihres\n            Rechts auf Datenübertragbarkeit gemäß Art. 20 Abs. 1 DS-GVO das Recht, zu\n            erwirken, dass die personenbezogenen Daten direkt von einem Verantwortlichen an\n            einen anderen Verantwortlichen übermittelt werden, soweit dies technisch\n            machbar ist und sofern hiervon nicht die Rechte und Freiheiten anderer Personen\n            beeinträchtigt werden.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Zur Geltendmachung des Rechts auf Datenübertragbarkeit kann\n            sich die betroffene Person jederzeit an einen Mitarbeiter der KOPF, HAND und\n            FUSS gemeinnützige Gesellschaft für Bildung mbH wenden.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("g)    Recht auf Widerspruch")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Jede von der Verarbeitung personenbezogener Daten betroffene\n            Person hat das vom Europäischen Richtlinien- und Verordnungsgeber gewährte\n            Recht, aus Gründen, die sich aus ihrer besonderen Situation ergeben, jederzeit\n            gegen die Verarbeitung sie betreffender personenbezogener Daten, die aufgrund\n            von Art. 6 Abs. 1 Buchstaben e oder f DS-GVO erfolgt, Widerspruch einzulegen.\n            Dies gilt auch für ein auf diese Bestimmungen gestütztes Profiling.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Die KOPF, HAND und FUSS gemeinnützige Gesellschaft für\n            Bildung mbH verarbeitet die personenbezogenen Daten im Falle des Widerspruchs\n            nicht mehr, es sei denn, wir können zwingende schutzwürdige Gründe für die\n            Verarbeitung nachweisen, die den Interessen, Rechten und Freiheiten der\n            betroffenen Person überwiegen, oder die Verarbeitung dient der Geltendmachung,\n            Ausübung oder Verteidigung von Rechtsansprüchen.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Verarbeitet die KOPF, HAND und FUSS gemeinnützige\n            Gesellschaft für Bildung mbH personenbezogene Daten, um Direktwerbung zu\n            betreiben, so hat die betroffene Person das Recht, jederzeit Widerspruch gegen\n            die Verarbeitung der personenbezogenen Daten zum Zwecke derartiger Werbung\n            einzulegen. Dies gilt auch für das Profiling, soweit es mit solcher\n            Direktwerbung in Verbindung steht. Widerspricht die betroffene Person gegenüber\n            der KOPF, HAND und FUSS gemeinnützige Gesellschaft für Bildung mbH der\n            Verarbeitung für Zwecke der Direktwerbung, so wird die KOPF, HAND und FUSS\n            gemeinnützige Gesellschaft für Bildung mbH die personenbezogenen Daten nicht\n            mehr für diese Zwecke verarbeiten.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Zudem hat die betroffene Person das Recht, aus Gründen, die\n            sich aus ihrer besonderen Situation ergeben, gegen die sie betreffende\n            Verarbeitung personenbezogener Daten, die bei der KOPF, HAND und FUSS\n            gemeinnützige Gesellschaft für Bildung mbH zu wissenschaftlichen oder\n            historischen Forschungszwecken oder zu statistischen Zwecken gemäß Art. 89 Abs.\n            1 DS-GVO erfolgen, Widerspruch einzulegen, es sei denn, eine solche\n            Verarbeitung ist zur Erfüllung einer im öffentlichen Interesse liegenden\n            Aufgabe erforderlich.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Zur Ausübung des Rechts auf Widerspruch kann sich die\n            betroffene Person direkt jeden Mitarbeiter der KOPF, HAND und FUSS\n            gemeinnützige Gesellschaft für Bildung mbH oder einen anderen Mitarbeiter\n            wenden. Der betroffenen Person steht es ferner frei, im Zusammenhang mit der\n            Nutzung von Diensten der Informationsgesellschaft, ungeachtet der Richtlinie\n            2002/58/EG, ihr Widerspruchsrecht mittels automatisierter Verfahren auszuüben,\n            bei denen technische Spezifikationen verwendet werden.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("h)    Automatisierte Entscheidungen im Einzelfall\n            einschließlich Profiling")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Jede von der Verarbeitung personenbezogener Daten betroffene\n            Person hat das vom Europäischen Richtlinien- und Verordnungsgeber gewährte\n            Recht, nicht einer ausschließlich auf einer automatisierten Verarbeitung —\n            einschließlich Profiling — beruhenden Entscheidung unterworfen zu werden, die\n            ihr gegenüber rechtliche Wirkung entfaltet oder sie in ähnlicher Weise\n            erheblich beeinträchtigt, sofern die Entscheidung (1) nicht für den Abschluss\n            oder die Erfüllung eines Vertrags zwischen der betroffenen Person und dem\n            Verantwortlichen erforderlich ist, oder (2) aufgrund von Rechtsvorschriften der\n            Union oder der Mitgliedstaaten, denen der Verantwortliche unterliegt, zulässig\n            ist und diese Rechtsvorschriften angemessene Maßnahmen zur Wahrung der Rechte\n            und Freiheiten sowie der berechtigten Interessen der betroffenen Person\n            enthalten oder (3) mit ausdrücklicher Einwilligung der betroffenen Person\n            erfolgt.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Ist die Entscheidung (1) für den Abschluss oder die\n            Erfüllung eines Vertrags zwischen der betroffenen Person und dem\n            Verantwortlichen erforderlich oder (2) erfolgt sie mit ausdrücklicher\n            Einwilligung der betroffenen Person, trifft die KOPF, HAND und FUSS\n            gemeinnützige Gesellschaft für Bildung mbH angemessene Maßnahmen, um die Rechte\n            und Freiheiten sowie die berechtigten Interessen der betroffenen Person zu\n            wahren, wozu mindestens das Recht auf Erwirkung des Eingreifens einer Person\n            seitens des Verantwortlichen, auf Darlegung des eigenen Standpunkts und auf\n            Anfechtung der Entscheidung gehört.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Möchte die betroffene Person Rechte mit Bezug auf\n            automatisierte Entscheidungen geltend machen, kann sie sich hierzu jederzeit an\n            einen Mitarbeiter des für die Verarbeitung Verantwortlichen wenden.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("i)      Recht auf Widerruf einer datenschutzrechtlichen\n            Einwilligung")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Jede von der Verarbeitung personenbezogener Daten betroffene\n            Person hat das vom Europäischen Richtlinien- und Verordnungsgeber gewährte\n            Recht, eine Einwilligung zur Verarbeitung personenbezogener Daten jederzeit zu\n            widerrufen.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Möchte die betroffene Person ihr Recht auf Widerruf einer\n            Einwilligung geltend machen, kann sie sich hierzu jederzeit an einen\n            Mitarbeiter des für die Verarbeitung Verantwortlichen wenden.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("10. Datenschutz bei Bewerbungen und im Bewerbungsverfahren")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Der für die Verarbeitung Verantwortliche erhebt und\n            verarbeitet die personenbezogenen Daten von Bewerbern zum Zwecke der Abwicklung\n            des Bewerbungsverfahrens. Die Verarbeitung kann auch auf elektronischem Wege\n            erfolgen. Dies ist insbesondere dann der Fall, wenn ein Bewerber entsprechende\n            Bewerbungsunterlagen auf dem elektronischen Wege, beispielsweise per E-Mail\n            oder über ein auf der Internetseite befindliches Webformular, an den für die\n            Verarbeitung Verantwortlichen übermittelt. Schließt der für die Verarbeitung\n            Verantwortliche einen Anstellungsvertrag mit einem Bewerber, werden die\n            übermittelten Daten zum Zwecke der Abwicklung des Beschäftigungsverhältnisses\n            unter Beachtung der gesetzlichen Vorschriften gespeichert. Wird von dem für die\n            Verarbeitung Verantwortlichen kein Anstellungsvertrag mit dem Bewerber\n            geschlossen, so werden die Bewerbungsunterlagen zwei Monate nach Bekanntgabe\n            der Absageentscheidung automatisch gelöscht, sofern einer Löschung keine\n            sonstigen berechtigten Interessen des für die Verarbeitung Verantwortlichen\n            entgegenstehen. Sonstiges berechtigtes Interesse in diesem Sinne ist\n            beispielsweise eine Beweispflicht in einem Verfahren nach dem Allgemeinen\n            Gleichbehandlungsgesetz (AGG).")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("11. Datenschutzbestimmungen zu Einsatz und Verwendung von\n            Facebook")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Der für die Verarbeitung Verantwortliche hat auf dieser\n            Internetseite Komponenten des Unternehmens Facebook integriert. Facebook ist\n            ein soziales Netzwerk.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Ein soziales Netzwerk ist ein im Internet betriebener\n            sozialer Treffpunkt, eine Online-Gemeinschaft, die es den Nutzern in der Regel\n            ermöglicht, untereinander zu kommunizieren und im virtuellen Raum zu\n            interagieren. Ein soziales Netzwerk kann als Plattform zum Austausch von\n            Meinungen und Erfahrungen dienen oder ermöglicht es der Internetgemeinschaft,\n            persönliche oder unternehmensbezogene Informationen bereitzustellen. Facebook\n            ermöglicht den Nutzern des sozialen Netzwerkes unter anderem die Erstellung von\n            privaten Profilen, den Upload von Fotos und eine Vernetzung über\n            Freundschaftsanfragen.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Betreibergesellschaft von Facebook ist die Facebook, Inc., 1\n            Hacker Way, Menlo Park, CA 94025, USA. Für die Verarbeitung personenbezogener\n            Daten Verantwortlicher ist, wenn eine betroffene Person außerhalb der USA oder\n            Kanada lebt, die Facebook Ireland Ltd., 4 Grand Canal Square, Grand Canal\n            Harbour, Dublin 2, Ireland.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Durch jeden Aufruf einer der Einzelseiten dieser\n            Internetseite, die durch den für die Verarbeitung Verantwortlichen betrieben\n            wird und auf welcher eine Facebook-Komponente (Facebook-Plug-In) integriert\n            wurde, wird der Internetbrowser auf dem informationstechnologischen System der\n            betroffenen Person automatisch durch die jeweilige Facebook-Komponente\n            veranlasst, eine Darstellung der entsprechenden Facebook-Komponente von\n            Facebook herunterzuladen. Eine Gesamtübersicht über alle Facebook-Plug-Ins kann\n            unter https://developers.facebook.com/docs/plugins/?locale=de_DE abgerufen\n            werden. Im Rahmen dieses technischen Verfahrens erhält Facebook Kenntnis\n            darüber, welche konkrete Unterseite unserer Internetseite durch die betroffene\n            Person besucht wird.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Sofern die betroffene Person gleichzeitig bei Facebook\n            eingeloggt ist, erkennt Facebook mit jedem Aufruf unserer Internetseite durch\n            die betroffene Person und während der gesamten Dauer des jeweiligen\n            Aufenthaltes auf unserer Internetseite, welche konkrete Unterseite unserer\n            Internetseite die betroffene Person besucht. Diese Informationen werden durch\n            die Facebook-Komponente gesammelt und durch Facebook dem jeweiligen\n            Facebook-Account der betroffenen Person zugeordnet. Betätigt die betroffene\n            Person einen der auf unserer Internetseite integrierten Facebook-Buttons,\n            beispielsweise den „Gefällt mir“-Button, oder gibt die betroffene Person einen\n            Kommentar ab, ordnet Facebook diese Information dem persönlichen\n            Facebook-Benutzerkonto der betroffenen Person zu und speichert diese\n            personenbezogenen Daten.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Facebook erhält über die Facebook-Komponente immer dann eine\n            Information darüber, dass die betroffene Person unsere Internetseite besucht\n            hat, wenn die betroffene Person zum Zeitpunkt des Aufrufs unserer Internetseite\n            gleichzeitig bei Facebook eingeloggt ist; dies findet unabhängig davon statt,\n            ob die betroffene Person die Facebook-Komponente anklickt oder nicht. Ist eine\n            derartige Übermittlung dieser Informationen an Facebook von der betroffenen\n            Person nicht gewollt, kann diese die Übermittlung dadurch verhindern, dass sie\n            sich vor einem Aufruf unserer Internetseite aus ihrem Facebook-Account\n            ausloggt.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Die von Facebook veröffentlichte Datenrichtlinie, die unter\n            https://de-de.facebook.com/about/privacy/ abrufbar ist, gibt Aufschluss über\n            die Erhebung, Verarbeitung und Nutzung personenbezogener Daten durch Facebook.\n            Ferner wird dort erläutert, welche Einstellungsmöglichkeiten Facebook zum\n            Schutz der Privatsphäre der betroffenen Person bietet. Zudem sind\n            unterschiedliche Applikationen erhältlich, die es ermöglichen, eine\n            Datenübermittlung an Facebook zu unterdrücken. Solche Applikationen können\n            durch die betroffene Person genutzt werden, um eine Datenübermittlung an\n            Facebook zu unterdrücken.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("12. Datenschutzbestimmungen zu Einsatz und Verwendung von\n            Google-AdWords")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Der für die Verarbeitung Verantwortliche hat auf dieser\n            Internetseite Google AdWords integriert. Google AdWords ist ein Dienst zur\n            Internetwerbung, der es Werbetreibenden gestattet, sowohl Anzeigen in den\n            Suchmaschinenergebnissen von Google als auch im Google-Werbenetzwerk zu\n            schalten. Google AdWords ermöglicht es einem Werbetreibenden, vorab bestimmte\n            Schlüsselwörter festzulegen, mittels derer eine Anzeige in den\n            Suchmaschinenergebnissen von Google ausschließlich dann angezeigt wird, wenn\n            der Nutzer mit der Suchmaschine ein schlüsselwortrelevantes Suchergebnis\n            abruft. Im Google-Werbenetzwerk werden die Anzeigen mittels eines automatischen\n            Algorithmus und unter Beachtung der zuvor festgelegten Schlüsselwörter auf\n            themenrelevanten Internetseiten verteilt.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Betreibergesellschaft der Dienste von Google AdWords ist die\n            Google Inc., 1600 Amphitheatre Pkwy, Mountain View, CA 94043-1351, USA.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Der Zweck von Google AdWords ist die Bewerbung unserer\n            Internetseite durch die Einblendung von interessenrelevanter Werbung auf den\n            Internetseiten von Drittunternehmen und in den Suchmaschinenergebnissen der\n            Suchmaschine Google und eine Einblendung von Fremdwerbung auf unserer\n            Internetseite.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Gelangt eine betroffene Person über eine Google-Anzeige auf\n            unsere Internetseite, wird auf dem informationstechnologischen System der\n            betroffenen Person durch Google ein sogenannter Conversion-Cookie abgelegt. Was\n            Cookies sind, wurde oben bereits erläutert. Ein Conversion-Cookie verliert nach\n            dreißig Tagen seine Gültigkeit und dient nicht zur Identifikation der\n            betroffenen Person. Über den Conversion-Cookie wird, sofern das Cookie noch\n            nicht abgelaufen ist, nachvollzogen, ob bestimmte Unterseiten, beispielsweise\n            der Warenkorb von einem Online-Shop-System, auf unserer Internetseite\n            aufgerufen wurden. Durch den Conversion-Cookie können sowohl wir als auch\n            Google nachvollziehen, ob eine betroffene Person, die über eine AdWords-Anzeige\n            auf unsere Internetseite gelangt ist, einen Umsatz generierte, also einen\n            Warenkauf vollzogen oder abgebrochen hat.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Die durch die Nutzung des Conversion-Cookies erhobenen Daten\n            und Informationen werden von Google verwendet, um Besuchsstatistiken für unsere\n            Internetseite zu erstellen. Diese Besuchsstatistiken werden durch uns wiederum\n            genutzt, um die Gesamtanzahl der Nutzer zu ermitteln, welche über\n            AdWords-Anzeigen an uns vermittelt wurden, also um den Erfolg oder Misserfolg der\n            jeweiligen AdWords-Anzeige zu ermitteln und um unsere AdWords-Anzeigen für die\n            Zukunft zu optimieren. Weder unser Unternehmen noch andere Werbekunden von\n            Google-AdWords erhalten Informationen von Google, mittels derer die betroffene\n            Person identifiziert werden könnte.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Mittels des Conversion-Cookies werden personenbezogene\n            Informationen, beispielsweise die durch die betroffene Person besuchten\n            Internetseiten, gespeichert. Bei jedem Besuch unserer Internetseiten werden\n            demnach personenbezogene Daten, einschließlich der IP-Adresse des von der\n            betroffenen Person genutzten Internetanschlusses, an Google in den Vereinigten\n            Staaten von Amerika übertragen. Diese personenbezogenen Daten werden durch\n            Google in den Vereinigten Staaten von Amerika gespeichert. Google gibt diese\n            über das technische Verfahren erhobenen personenbezogenen Daten unter Umständen\n            an Dritte weiter.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Die betroffene Person kann die Setzung von Cookies durch\n            unsere Internetseite, wie oben bereits dargestellt, jederzeit mittels einer\n            entsprechenden Einstellung des genutzten Internetbrowsers verhindern und damit\n            der Setzung von Cookies dauerhaft widersprechen. Eine solche Einstellung des\n            genutzten Internetbrowsers würde auch verhindern, dass Google einen\n            Conversion-Cookie auf dem informationstechnologischen System der betroffenen\n            Person setzt. Zudem kann ein von Google AdWords bereits gesetzter Cookie\n            jederzeit über den Internetbrowser oder andere Softwareprogramme gelöscht\n            werden.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Ferner besteht für die betroffene Person die Möglichkeit,\n            der interessenbezogenen Werbung durch Google zu widersprechen. Hierzu muss die\n            betroffene Person von jedem der von ihr genutzten Internetbrowser aus den Link\n            www.google.de/settings/ads aufrufen und dort die gewünschten Einstellungen\n            vornehmen.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Weitere Informationen und die geltenden\n            Datenschutzbestimmungen von Google können unter\n            https://www.google.de/intl/de/policies/privacy/ abgerufen werden.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("13. Datenschutzbestimmungen zu Einsatz und Verwendung von\n            Instagram")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Der für die Verarbeitung Verantwortliche hat auf dieser\n            Internetseite Komponenten des Dienstes Instagram integriert. Instagram ist ein\n            Dienst, der als audiovisuelle Plattform zu qualifizieren ist und den Nutzern\n            das Teilen von Fotos und Videos und zudem eine Weiterverbreitung solcher Daten\n            in anderen sozialen Netzwerken ermöglicht.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Betreibergesellschaft der Dienste von Instagram ist die\n            Instagram LLC, 1 Hacker Way, Building 14 First Floor, Menlo Park, CA, USA.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Durch jeden Aufruf einer der Einzelseiten dieser\n            Internetseite, die durch den für die Verarbeitung Verantwortlichen betrieben\n            wird und auf welcher eine Instagram-Komponente (Insta-Button) integriert wurde,\n            wird der Internetbrowser auf dem informationstechnologischen System der\n            betroffenen Person automatisch durch die jeweilige Instagram-Komponente veranlasst,\n            eine Darstellung der entsprechenden Komponente von Instagram herunterzuladen.\n            Im Rahmen dieses technischen Verfahrens erhält Instagram Kenntnis darüber,\n            welche konkrete Unterseite unserer Internetseite durch die betroffene Person\n            besucht wird.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Sofern die betroffene Person gleichzeitig bei Instagram\n            eingeloggt ist, erkennt Instagram mit jedem Aufruf unserer Internetseite durch\n            die betroffene Person und während der gesamten Dauer des jeweiligen\n            Aufenthaltes auf unserer Internetseite, welche konkrete Unterseite die\n            betroffene Person besucht. Diese Informationen werden durch die\n            Instagram-Komponente gesammelt und durch Instagram dem jeweiligen\n            Instagram-Account der betroffenen Person zugeordnet. Betätigt die betroffene\n            Person einen der auf unserer Internetseite integrierten Instagram-Buttons,\n            werden die damit übertragenen Daten und Informationen dem persönlichen\n            Instagram-Benutzerkonto der betroffenen Person zugeordnet und von Instagram\n            gespeichert und verarbeitet.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Instagram erhält über die Instagram-Komponente immer dann\n            eine Information darüber, dass die betroffene Person unsere Internetseite\n            besucht hat, wenn die betroffene Person zum Zeitpunkt des Aufrufs unserer\n            Internetseite gleichzeitig bei Instagram eingeloggt ist; dies findet unabhängig\n            davon statt, ob die betroffene Person die Instagram-Komponente anklickt oder\n            nicht. Ist eine derartige Übermittlung dieser Informationen an Instagram von\n            der betroffenen Person nicht gewollt, kann diese die Übermittlung dadurch\n            verhindern, dass sie sich vor einem Aufruf unserer Internetseite aus ihrem\n            Instagram-Account ausloggt.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Weitere Informationen und die geltenden\n            Datenschutzbestimmungen von Instagram können unter\n            https://help.instagram.com/155833707900388 und\n            https://www.instagram.com/about/legal/privacy/ abgerufen werden.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("14. Datenschutzbestimmungen zu Einsatz und Verwendung von\n            Jetpack für WordPress")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Der für die Verarbeitung Verantwortliche hat auf dieser\n            Internetseite Jetpack integriert. Jetpack ist ein WordPress-Plug-In, welches\n            dem Betreiber einer Internetseite, die auf WordPress aufbaut, zusätzliche\n            Funktionen bietet. Jetpack gestattet dem Internetseitenbetreiber unter anderem\n            eine Übersicht über die Besucher der Seite. Durch die Anzeige von verwandten\n            Beiträgen und Publikationen oder die Möglichkeit, Inhalte auf der Seite zu\n            teilen, ist ferner die Steigerung der Besucherzahlen möglich. Außerdem sind\n            Sicherheitsfunktionen in Jetpack integriert, sodass eine Jetpack nutzende\n            Internetseite besser gegen Brute-Force-Attacken geschützt ist. Jetpack optimiert\n            und beschleunigt ferner das Laden der auf der Internetseite integrierten\n            Bilder.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Betreibergesellschaft des Jetpack-Plug-Ins für WordPress ist\n            die Automattic Inc., 132 Hawthorne Street, San Francisco, CA 94107, USA. Die\n            Betreibergesellschaft setzt die Trackingtechnologie der Quantcast Inc., 201\n            Third Street, San Francisco, CA 94103, USA, ein.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Jetpack setzt ein Cookie auf dem informationstechnologischen\n            System der betroffenen Person. Was Cookies sind, wurde oben bereits erläutert.\n            Durch jeden Aufruf einer der Einzelseiten dieser Internetseite, die durch den\n            für die Verarbeitung Verantwortlichen betrieben wird und auf welcher eine\n            Jetpack-Komponente integriert wurde, wird der Internetbrowser auf dem\n            informationstechnologischen System der betroffenen Person automatisch durch die\n            jeweilige Jetpack-Komponente veranlasst, Daten zur Analysezwecken an Automattic\n            zu übermitteln. Im Rahmen dieses technischen Verfahrens erhält Automattic\n            Kenntnis über Daten, die in der Folge zur Erstellung einer Übersicht der\n            Internetseiten-Besuche verwendet werden. Die so gewonnenen Daten dienen der\n            Analyse des Verhaltens der betroffenen Person, welche auf die Internetseite des\n            für die Verarbeitung Verantwortlichen zugegriffen hat und werden mit dem Ziel,\n            die Internetseite zu optimieren, ausgewertet. Die über die Jetpack-Komponente\n            erhobenen Daten werden nicht ohne eine vorherige Einholung einer gesonderten\n            ausdrücklichen Einwilligung der betroffenen Person dazu genutzt, die betroffene\n            Person zu identifizieren. Die Daten gelangen ferner Quantcast zur Kenntnis.\n            Quantcast nutzt die Daten zu den gleichen Zwecken wie Automattic.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Die betroffene Person kann die Setzung von Cookies durch\n            unsere Internetseite, wie oben bereits dargestellt, jederzeit mittels einer\n            entsprechenden Einstellung des genutzten Internetbrowsers verhindern und damit\n            der Setzung von Cookies dauerhaft widersprechen. Eine solche Einstellung des\n            genutzten Internetbrowsers würde auch verhindern, dass Automattic/Quantcast ein\n            Cookie auf dem informationstechnologischen System der betroffenen Person setzt.\n            Zudem können von Automattic bereits gesetzte Cookies jederzeit über den\n            Internetbrowser oder andere Softwareprogramme gelöscht werden.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Ferner besteht für die betroffene Person die Möglichkeit,\n            einer Erfassung der durch das Jetpack-Cookie erzeugten, auf eine Nutzung dieser\n            Internetseite bezogenen Daten sowie der Verarbeitung dieser Daten durch\n            Automattic/Quantcast zu widersprechen und eine solche zu verhindern. Hierzu\n            muss die betroffene Person den Opt-Out-Button unter dem Link https://www.quantcast.com/opt-out/\n            drücken, der einen Opt-Out-Cookie setzt. Der mit dem Widerspruch gesetzte\n            Opt-Out-Cookie wird auf dem von der betroffenen Person genutzten\n            informationstechnologischen System abgelegt. Werden die Cookies auf dem System\n            der betroffenen Person nach einem Widerspruch gelöscht, muss die betroffene\n            Person den Link erneut aufrufen und einen neuen Opt-Out-Cookie setzen.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Mit der Setzung des Opt-Out-Cookies besteht jedoch die\n            Möglichkeit, dass die Internetseiten des für die Verarbeitung Verantwortlichen\n            für die betroffene Person nicht mehr vollumfänglich nutzbar sind.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Die geltenden Datenschutzbestimmungen von Automattic sind\n            unter https://automattic.com/privacy/ abrufbar. Die geltenden\n            Datenschutzbestimmungen von Quantcast sind unter\n            https://www.quantcast.com/privacy/ abrufbar.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("15. Datenschutzbestimmungen zu Einsatz und Verwendung von\n            LinkedIn")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Der für die Verarbeitung Verantwortliche hat auf dieser\n            Internetseite Komponenten der LinkedIn Corporation integriert. LinkedIn ist ein\n            Internetbasiertes soziales Netzwerk, das eine Konnektierung der Nutzer mit\n            bestehenden Geschäftskontakten sowie das Knüpfen von neuen Businesskontakten\n            ermöglicht. Über 400 Millionen registrierte Personen nutzen LinkedIn in mehr\n            als 200 Ländern. Damit ist LinkedIn derzeit die größte Plattform für\n            Businesskontakte und eine der meistbesuchten Internetseiten der Welt.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Betreibergesellschaft von LinkedIn ist die LinkedIn\n            Corporation, 2029 Stierlin Court Mountain View, CA 94043, USA. Für\n            Datenschutzangelegenheiten außerhalb der USA ist LinkedIn Ireland, Privacy\n            Policy Issues, Wilton Plaza, Wilton Place, Dublin 2, Ireland, zuständig.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Bei jedem einzelnen Abruf unserer Internetseite, die mit\n            einer LinkedIn-Komponente (LinkedIn-Plug-In) ausgestattet ist, veranlasst diese\n            Komponente, dass der von der betroffenen Person verwendete Browser eine\n            entsprechende Darstellung der Komponente von LinkedIn herunterlädt. Weitere\n            Informationen zu den LinkedIn-Plug-Ins können unter\n            https://developer.linkedin.com/plugins abgerufen werden. Im Rahmen dieses\n            technischen Verfahrens erhält LinkedIn Kenntnis darüber, welche konkrete\n            Unterseite unserer Internetseite durch die betroffene Person besucht wird.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Sofern die betroffene Person gleichzeitig bei LinkedIn\n            eingeloggt ist, erkennt LinkedIn mit jedem Aufruf unserer Internetseite durch\n            die betroffene Person und während der gesamten Dauer des jeweiligen\n            Aufenthaltes auf unserer Internetseite, welche konkrete Unterseite unserer\n            Internetseite die betroffene Person besucht. Diese Informationen werden durch\n            die LinkedIn-Komponente gesammelt und durch LinkedIn dem jeweiligen\n            LinkedIn-Account der betroffenen Person zugeordnet. Betätigt die betroffene\n            Person einen auf unserer Internetseite integrierten LinkedIn-Button, ordnet\n            LinkedIn diese Information dem persönlichen LinkedIn-Benutzerkonto der\n            betroffenen Person zu und speichert diese personenbezogenen Daten.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("LinkedIn erhält über die LinkedIn-Komponente immer dann eine\n            Information darüber, dass die betroffene Person unsere Internetseite besucht\n            hat, wenn die betroffene Person zum Zeitpunkt des Aufrufes unserer\n            Internetseite gleichzeitig bei LinkedIn eingeloggt ist; dies findet unabhängig\n            davon statt, ob die betroffene Person die LinkedIn-Komponente anklickt oder\n            nicht. Ist eine derartige Übermittlung dieser Informationen an LinkedIn von der\n            betroffenen Person nicht gewollt, kann diese die Übermittlung dadurch\n            verhindern, dass sie sich vor einem Aufruf unserer Internetseite aus ihrem\n            LinkedIn-Account ausloggt.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("LinkedIn bietet unter https://www.linkedin.com/psettings/guest-controls\n            die Möglichkeit, E-Mail-Nachrichten, SMS-Nachrichten und zielgerichtete\n            Anzeigen abzubestellen sowie Anzeigen-Einstellungen zu verwalten. LinkedIn\n            nutzt ferner Partner wie Quantcast, Google Analytics, BlueKai, DoubleClick,\n            Nielsen, Comscore, Eloqua und Lotame, die Cookies setzen können. Solche Cookies\n            können unter https://www.linkedin.com/legal/cookie-policy abgelehnt werden. Die\n            geltenden Datenschutzbestimmungen von LinkedIn sind unter\n            https://www.linkedin.com/legal/privacy-policy abrufbar. Die Cookie-Richtlinie\n            von LinkedIn ist unter https://www.linkedin.com/legal/cookie-policy abrufbar.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("16. Datenschutzbestimmungen zu Einsatz und Verwendung von\n            Pinterest")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Der für die Verarbeitung Verantwortliche hat auf dieser Internetseite\n            Komponenten der Pinterest Inc. integriert. Pinterest ist ein sogenanntes\n            soziales Netzwerk. Ein soziales Netzwerk ist ein im Internet betriebener\n            sozialer Treffpunkt, eine Online-Gemeinschaft, die es den Nutzern in der Regel\n            ermöglicht, untereinander zu kommunizieren und im virtuellen Raum zu\n            interagieren. Ein soziales Netzwerk kann als Plattform zum Austausch von\n            Meinungen und Erfahrungen dienen oder ermöglicht es der Internetgemeinschaft,\n            persönliche oder unternehmensbezogene Informationen bereitzustellen. Pinterest\n            ermöglicht den Nutzern des sozialen Netzwerkes unter anderem,\n            Bilderkollektionen und Einzelbilder sowie Beschreibungen an virtuellen\n            Pinnwänden zu veröffentlichen (sogenanntes pinnen), welche dann wiederum von\n            anderen Nutzern geteilt (sogenanntes repinnen) oder kommentiert werden können.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Betreibergesellschaft von Pinterest ist die Pinterest Inc.,\n            808 Brannan Street, San Francisco, CA 94103, USA.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Durch jeden Aufruf einer der Einzelseiten dieser\n            Internetseite, die durch den für die Verarbeitung Verantwortlichen betrieben\n            wird und auf welcher eine Pinterest-Komponente (Pinterest-Plug-In) integriert\n            wurde, wird der Internetbrowser auf dem informationstechnologischen System der\n            betroffenen Person automatisch durch die jeweilige Pinterest-Komponente\n            veranlasst, eine Darstellung der entsprechenden Pinterest-Komponente von\n            Pinterest herunterzuladen. Mehr Informationen zu Pinterest sind unter\n            https://pinterest.com/ abrufbar. Im Rahmen dieses technischen Verfahrens erhält\n            Pinterest Kenntnis darüber, welche konkrete Unterseite unserer Internetseite\n            durch die betroffene Person besucht wird.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Sofern die betroffene Person gleichzeitig bei Pinterest\n            eingeloggt ist, erkennt Pinterest mit jedem Aufruf unserer Internetseite durch\n            die betroffene Person und während der gesamten Dauer des jeweiligen\n            Aufenthaltes auf unserer Internetseite, welche konkrete Unterseite unserer\n            Internetseite die betroffene Person besucht. Diese Informationen werden durch\n            die Pinterest-Komponente gesammelt und durch Pinterest dem jeweiligen\n            Pinterest-Account der betroffenen Person zugeordnet. Betätigt die betroffene\n            Person einen auf unserer Internetseite integrierten Pinterest-Button, ordnet\n            Pinterest diese Information dem persönlichen Pinterest-Benutzerkonto der\n            betroffenen Person zu und speichert diese personenbezogenen Daten.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Pinterest erhält über die Pinterest-Komponente immer dann\n            eine Information darüber, dass die betroffene Person unsere Internetseite\n            besucht hat, wenn die betroffene Person zum Zeitpunkt des Aufrufs unserer\n            Internetseite gleichzeitig bei Pinterest eingeloggt ist; dies findet unabhängig\n            davon statt, ob die betroffene Person die Pinterest-Komponente anklickt oder\n            nicht. Ist eine derartige Übermittlung dieser Informationen an Pinterest von\n            der betroffenen Person nicht gewollt, kann diese die Übermittlung dadurch\n            verhindern, dass sie sich vor einem Aufruf unserer Internetseite aus ihrem\n            Pinterest-Account ausloggt.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Die von Pinterest veröffentlichte Datenschutzrichtlinie, die\n            unter https://about.pinterest.com/privacy-policy abrufbar ist, gibt Aufschluss\n            über die Erhebung, Verarbeitung und Nutzung personenbezogener Daten durch\n            Pinterest.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("17. Datenschutzbestimmungen zu Einsatz und Verwendung von\n            Twitter")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Der für die Verarbeitung Verantwortliche hat auf dieser\n            Internetseite Komponenten von Twitter integriert. Twitter ist ein\n            multilingualer öffentlich zugänglicher Mikroblogging-Dienst, auf welchem die\n            Nutzer sogenannte Tweets, also Kurznachrichten, die auf 280 Zeichen begrenzt\n            sind, veröffentlichen und verbreiten können. Diese Kurznachrichten sind für\n            jedermann, also auch für nicht bei Twitter angemeldete Personen abrufbar. Die\n            Tweets werden aber auch den sogenannten Followern des jeweiligen Nutzers\n            angezeigt. Follower sind andere Twitter-Nutzer, die den Tweets eines Nutzers\n            folgen. Ferner ermöglicht Twitter über Hashtags, Verlinkungen oder Retweets die\n            Ansprache eines breiten Publikums.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Betreibergesellschaft von Twitter ist die Twitter, Inc.,\n            1355 Market Street, Suite 900, San Francisco, CA 94103, USA.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Durch jeden Aufruf einer der Einzelseiten dieser\n            Internetseite, die durch den für die Verarbeitung Verantwortlichen betrieben\n            wird und auf welcher eine Twitter-Komponente (Twitter-Button) integriert wurde,\n            wird der Internetbrowser auf dem informationstechnologischen System der\n            betroffenen Person automatisch durch die jeweilige Twitter-Komponente\n            veranlasst, eine Darstellung der entsprechenden Twitter-Komponente von Twitter\n            herunterzuladen. Weitere Informationen zu den Twitter-Buttons sind unter\n            https://about.twitter.com/de/resources/buttons abrufbar. Im Rahmen dieses\n            technischen Verfahrens erhält Twitter Kenntnis darüber, welche konkrete\n            Unterseite unserer Internetseite durch die betroffene Person besucht wird.\n            Zweck der Integration der Twitter-Komponente ist es, unseren Nutzern eine\n            Weiterverbreitung der Inhalte diese Internetseite zu ermöglichen, diese\n            Internetseite in der digitalen Welt bekannt zu machen und unsere Besucherzahlen\n            zu erhöhen.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Sofern die betroffene Person gleichzeitig bei Twitter\n            eingeloggt ist, erkennt Twitter mit jedem Aufruf unserer Internetseite durch\n            die betroffene Person und während der gesamten Dauer des jeweiligen\n            Aufenthaltes auf unserer Internetseite, welche konkrete Unterseite unserer\n            Internetseite die betroffene Person besucht. Diese Informationen werden durch\n            die Twitter-Komponente gesammelt und durch Twitter dem jeweiligen\n            Twitter-Account der betroffenen Person zugeordnet. Betätigt die betroffene\n            Person einen der auf unserer Internetseite integrierten Twitter-Buttons, werden\n            die damit übertragenen Daten und Informationen dem persönlichen\n            Twitter-Benutzerkonto der betroffenen Person zugeordnet und von Twitter\n            gespeichert und verarbeitet.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Twitter erhält über die Twitter-Komponente immer dann eine\n            Information darüber, dass die betroffene Person unsere Internetseite besucht\n            hat, wenn die betroffene Person zum Zeitpunkt des Aufrufs unserer Internetseite\n            gleichzeitig bei Twitter eingeloggt ist; dies findet unabhängig davon statt, ob\n            die betroffene Person die Twitter-Komponente anklickt oder nicht. Ist eine\n            derartige Übermittlung dieser Informationen an Twitter von der betroffenen\n            Person nicht gewollt, kann diese die Übermittlung dadurch verhindern, dass sie\n            sich vor einem Aufruf unserer Internetseite aus ihrem Twitter-Account ausloggt.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Die geltenden Datenschutzbestimmungen von Twitter sind unter\n            https://twitter.com/privacy?lang=de abrufbar.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("18. Datenschutzbestimmungen zu Einsatz und Verwendung von\n            Xing")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Der für die Verarbeitung Verantwortliche hat auf dieser\n            Internetseite Komponenten von Xing integriert. Xing ist ein Internetbasiertes\n            soziales Netzwerk, das die Konnektierung der Nutzer mit bestehenden\n            Geschäftskontakten sowie das Knüpfen von neuen Businesskontakten ermöglicht.\n            Die einzelnen Nutzer können bei Xing ein persönliches Profil von sich anlegen.\n            Unternehmen können beispielsweise Unternehmensprofile erstellen oder\n            Stellenangebote auf Xing veröffentlichen.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Betreibergesellschaft von Xing ist die XING SE,\n            Dammtorstraße 30, 20354 Hamburg, Deutschland.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Durch jeden Aufruf einer der Einzelseiten dieser\n            Internetseite, die durch den für die Verarbeitung Verantwortlichen betrieben\n            wird und auf welcher eine Xing-Komponente (Xing-Plug-In) integriert wurde, wird\n            der Internetbrowser auf dem informationstechnologischen System der betroffenen\n            Person automatisch durch die jeweilige Xing-Komponente veranlasst, eine\n            Darstellung der entsprechenden Xing-Komponente von Xing herunterzuladen.\n            Weitere Informationen zum den Xing-Plug-Ins können unter\n            https://dev.xing.com/plugins abgerufen werden. Im Rahmen dieses technischen\n            Verfahrens erhält Xing Kenntnis darüber, welche konkrete Unterseite unserer\n            Internetseite durch die betroffene Person besucht wird.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Sofern die betroffene Person gleichzeitig bei Xing\n            eingeloggt ist, erkennt Xing mit jedem Aufruf unserer Internetseite durch die\n            betroffene Person und während der gesamten Dauer des jeweiligen Aufenthaltes\n            auf unserer Internetseite, welche konkrete Unterseite unserer Internetseite die\n            betroffene Person besucht. Diese Informationen werden durch die Xing-Komponente\n            gesammelt und durch Xing dem jeweiligen Xing-Account der betroffenen Person\n            zugeordnet. Betätigt die betroffene Person einen der auf unserer Internetseite\n            integrierten Xing-Buttons, beispielsweise den „Share“-Button, ordnet Xing diese\n            Information dem persönlichen Xing-Benutzerkonto der betroffenen Person zu und\n            speichert diese personenbezogenen Daten.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Xing erhält über die Xing-Komponente immer dann eine\n            Information darüber, dass die betroffene Person unsere Internetseite besucht\n            hat, wenn die betroffene Person zum Zeitpunkt des Aufrufs unserer Internetseite\n            gleichzeitig bei Xing eingeloggt ist; dies findet unabhängig davon statt, ob\n            die betroffene Person die Xing-Komponente anklickt oder nicht. Ist eine\n            derartige Übermittlung dieser Informationen an Xing von der betroffenen Person\n            nicht gewollt, kann diese die Übermittlung dadurch verhindern, dass sie sich\n            vor einem Aufruf unserer Internetseite aus ihrem Xing-Account ausloggt.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Die von Xing veröffentlichten Datenschutzbestimmungen, die\n            unter https://www.xing.com/privacy abrufbar sind, geben Aufschluss über die\n            Erhebung, Verarbeitung und Nutzung personenbezogener Daten durch Xing. Ferner\n            hat Xing unter https://www.xing.com/app/share?op=data_protection\n            Datenschutzhinweise für den XING-Share-Button veröffentlicht.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("19. Datenschutzbestimmungen zu Einsatz und Verwendung von\n            YouTube")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Der für die Verarbeitung Verantwortliche hat auf dieser\n            Internetseite Komponenten von YouTube integriert. YouTube ist ein\n            Internet-Videoportal, dass Video-Publishern das kostenlose Einstellen von\n            Videoclips und anderen Nutzern die ebenfalls kostenfreie Betrachtung, Bewertung\n            und Kommentierung dieser ermöglicht. YouTube gestattet die Publikation aller\n            Arten von Videos, weshalb sowohl komplette Film- und Fernsehsendungen, aber\n            auch Musikvideos, Trailer oder von Nutzern selbst angefertigte Videos über das\n            Internetportal abrufbar sind.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Betreibergesellschaft von YouTube ist die YouTube, LLC, 901\n            Cherry Ave., San Bruno, CA 94066, USA. Die YouTube, LLC ist einer\n            Tochtergesellschaft der Google Inc., 1600 Amphitheatre Pkwy, Mountain View, CA\n            94043-1351, USA.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Durch jeden Aufruf einer der Einzelseiten dieser\n            Internetseite, die durch den für die Verarbeitung Verantwortlichen betrieben\n            wird und auf welcher eine YouTube-Komponente (YouTube-Video) integriert wurde,\n            wird der Internetbrowser auf dem informationstechnologischen System der\n            betroffenen Person automatisch durch die jeweilige YouTube-Komponente\n            veranlasst, eine Darstellung der entsprechenden YouTube-Komponente von YouTube\n            herunterzuladen. Weitere Informationen zu YouTube können unter\n            https://www.youtube.com/yt/about/de/ abgerufen werden. Im Rahmen dieses\n            technischen Verfahrens erhalten YouTube und Google Kenntnis darüber, welche\n            konkrete Unterseite unserer Internetseite durch die betroffene Person besucht\n            wird.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Sofern die betroffene Person gleichzeitig bei YouTube\n            eingeloggt ist, erkennt YouTube mit dem Aufruf einer Unterseite, die ein\n            YouTube-Video enthält, welche konkrete Unterseite unserer Internetseite die\n            betroffene Person besucht. Diese Informationen werden durch YouTube und Google\n            gesammelt und dem jeweiligen YouTube-Account der betroffenen Person zugeordnet.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("YouTube und Google erhalten über die YouTube-Komponente\n            immer dann eine Information darüber, dass die betroffene Person unsere Internetseite\n            besucht hat, wenn die betroffene Person zum Zeitpunkt des Aufrufs unserer\n            Internetseite gleichzeitig bei YouTube eingeloggt ist; dies findet unabhängig\n            davon statt, ob die betroffene Person ein YouTube-Video anklickt oder nicht.\n            Ist eine derartige Übermittlung dieser Informationen an YouTube und Google von\n            der betroffenen Person nicht gewollt, kann diese die Übermittlung dadurch\n            verhindern, dass sie sich vor einem Aufruf unserer Internetseite aus ihrem\n            YouTube-Account ausloggt.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Die von YouTube veröffentlichten Datenschutzbestimmungen,\n            die unter https://www.google.de/intl/de/policies/privacy/ abrufbar sind, geben\n            Aufschluss über die Erhebung, Verarbeitung und Nutzung personenbezogener Daten\n            durch YouTube und Google.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("20. Rechtsgrundlage der Verarbeitung")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Art. 6 I lit. a DS-GVO dient unserem Unternehmen als\n            Rechtsgrundlage für Verarbeitungsvorgänge, bei denen wir eine Einwilligung für\n            einen bestimmten Verarbeitungszweck einholen. Ist die Verarbeitung\n            personenbezogener Daten zur Erfüllung eines Vertrags, dessen Vertragspartei die\n            betroffene Person ist, erforderlich, wie dies beispielsweise bei\n            Verarbeitungsvorgängen der Fall ist, die für eine Lieferung von Waren oder die\n            Erbringung einer sonstigen Leistung oder Gegenleistung notwendig sind, so\n            beruht die Verarbeitung auf Art. 6 I lit. b DS-GVO. Gleiches gilt für solche\n            Verarbeitungsvorgänge die zur Durchführung vorvertraglicher Maßnahmen\n            erforderlich sind, etwa in Fällen von Anfragen zur unseren Produkten oder\n            Leistungen. Unterliegt unser Unternehmen einer rechtlichen Verpflichtung durch\n            welche eine Verarbeitung von personenbezogenen Daten erforderlich wird, wie\n            beispielsweise zur Erfüllung steuerlicher Pflichten, so basiert die\n            Verarbeitung auf Art. 6 I lit. c DS-GVO. In seltenen Fällen könnte die\n            Verarbeitung von personenbezogenen Daten erforderlich werden, um lebenswichtige\n            Interessen der betroffenen Person oder einer anderen natürlichen Person zu\n            schützen. Dies wäre beispielsweise der Fall, wenn ein Besucher in unserem\n            Betrieb verletzt werden würde und daraufhin sein Name, sein Alter, seine\n            Krankenkassendaten oder sonstige lebenswichtige Informationen an einen Arzt,\n            ein Krankenhaus oder sonstige Dritte weitergegeben werden müssten. Dann würde\n            die Verarbeitung auf Art. 6 I lit. d DS-GVO beruhen. Letztlich könnten Verarbeitungsvorgänge\n            auf Art. 6 I lit. f DS-GVO beruhen. Auf dieser Rechtsgrundlage basieren\n            Verarbeitungsvorgänge, die von keiner der vorgenannten Rechtsgrundlagen erfasst\n            werden, wenn die Verarbeitung zur Wahrung eines berechtigten Interesses unseres\n            Unternehmens oder eines Dritten erforderlich ist, sofern die Interessen,\n            Grundrechte und Grundfreiheiten des Betroffenen nicht überwiegen. Solche\n            Verarbeitungsvorgänge sind uns insbesondere deshalb gestattet, weil sie durch\n            den Europäischen Gesetzgeber besonders erwähnt wurden. Er vertrat insoweit die\n            Auffassung, dass ein berechtigtes Interesse anzunehmen sein könnte, wenn die\n            betroffene Person ein Kunde des Verantwortlichen ist (Erwägungsgrund 47 Satz 2\n            DS-GVO).")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("21. Berechtigte Interessen an der Verarbeitung, die von dem\n            Verantwortlichen oder einem Dritten verfolgt werden")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Basiert die Verarbeitung personenbezogener Daten auf Artikel\n            6 I lit. f DS-GVO ist unser berechtigtes Interesse die Durchführung unserer\n            Geschäftstätigkeit zugunsten des Wohlergehens all unserer Mitarbeiter und\n            unserer Anteilseigner.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("22. Dauer, für die die personenbezogenen Daten gespeichert\n            werden")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Das Kriterium für die Dauer der Speicherung von\n            personenbezogenen Daten ist die jeweilige gesetzliche Aufbewahrungsfrist. Nach\n            Ablauf der Frist werden die entsprechenden Daten routinemäßig gelöscht, sofern\n            sie nicht mehr zur Vertragserfüllung oder Vertragsanbahnung erforderlich sind.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("23. Gesetzliche oder vertragliche Vorschriften zur\n            Bereitstellung der personenbezogenen Daten; Erforderlichkeit für den Vertragsabschluss;\n            Verpflichtung der betroffenen Person, die personenbezogenen Daten\n            bereitzustellen; mögliche Folgen der Nichtbereitstellung")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Wir klären Sie darüber auf, dass die Bereitstellung\n            personenbezogener Daten zum Teil gesetzlich vorgeschrieben ist (z.B.\n            Steuervorschriften) oder sich auch aus vertraglichen Regelungen (z.B. Angaben\n            zum Vertragspartner) ergeben kann. Mitunter kann es zu einem Vertragsschluss\n            erforderlich sein, dass eine betroffene Person uns personenbezogene Daten zur\n            Verfügung stellt, die in der Folge durch uns verarbeitet werden müssen. Die\n            betroffene Person ist beispielsweise verpflichtet uns personenbezogene Daten\n            bereitzustellen, wenn unser Unternehmen mit ihr einen Vertrag abschließt. Eine\n            Nichtbereitstellung der personenbezogenen Daten hätte zur Folge, dass der\n            Vertrag mit dem Betroffenen nicht geschlossen werden könnte. Vor einer\n            Bereitstellung personenbezogener Daten durch den Betroffenen muss sich der\n            Betroffene an einen unserer Mitarbeiter wenden. Unser Mitarbeiter klärt den Betroffenen\n            einzelfallbezogen darüber auf, ob die Bereitstellung der personenbezogenen\n            Daten gesetzlich oder vertraglich vorgeschrieben oder für den Vertragsabschluss\n            erforderlich ist, ob eine Verpflichtung besteht, die personenbezogenen Daten\n            bereitzustellen, und welche Folgen die Nichtbereitstellung der\n            personenbezogenen Daten hätte.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("24. Bestehen einer automatisierten Entscheidungsfindung")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Als verantwortungsbewusstes Unternehmen verzichten wir auf\n            eine automatische Entscheidungsfindung oder ein Profiling.")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_vm._v("Diese Datenschutzerklärung wurde durch den\n            Datenschutzerklärungs-Generator der DGD Deutsche Gesellschaft für Datenschutz\n            GmbH, die als Externer Datenschutzbeauftragter Bamberg tätig ist, in\n            Kooperation mit dem IT- und Datenschutzrecht Anwalt Christian Solmecke ("),_c('a',{attrs:{"href":"https://www.wbs-law.de/it-und-internet-recht/datenschutzrecht/"}},[_c('span',{staticStyle:{"color":"windowtext","text-decoration":"none"}},[_vm._v("https://www.wbs-law.de/it-und-internet-recht/datenschutzrecht/")])]),_vm._v(")\n            erstellt.")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4utZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__i18n_common__ = __webpack_require__("sknz");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ly-ableplayer',
  data: function data() {
    return {
      main_ok: false,
      sign_ok: false,
      sub_ok: false,
      ableplayer: null
    };
  },

  props: {
    src: String,
    sign: String,
    sub: String
  },
  mounted: function mounted() {
    var ctx = this;

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(ctx.src).then(function () {
      ctx.main_ok = true;
    });
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(ctx.sign).then(function () {
      ctx.sign_ok = true;
    });
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(ctx.sub).then(function () {
      ctx.sub_ok = true;
    });

    var el = document.getElementById(this.playerId);
    this.ableplayer = new window.AblePlayer(el);
  },
  computed: {
    i18n: function i18n() {
      return __WEBPACK_IMPORTED_MODULE_1__i18n_common__[this.$store.state.profile.lang];
    },
    playerId: function playerId() {
      return 'ly-ableplayer-video-' + this._uid;
    },
    lang: function lang() {
      return this.$store.state.profile.lang;
    }
  }
});

/***/ }),

/***/ "5iqm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__comps_btn__ = __webpack_require__("FP6n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__comps_input_img__ = __webpack_require__("flDJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__comps_flex_center__ = __webpack_require__("0arO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__i18n_register__ = __webpack_require__("aatY");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'register-view',
  mounted: function mounted() {
    document.querySelector('#register-focus').focus();
  },
  data: function data() {
    return {

      /* form model */
      name: '',
      email: '',
      pwd1: '',
      pwd2: '',
      profileImg: null,

      /* temp */
      errmsg: '',
      busy: false,
      submitOk: false,
      nameTaken: false,
      emailTaken: false
    };
  },

  computed: {

    /* messages */
    msg: function msg() {
      return __WEBPACK_IMPORTED_MODULE_4__i18n_register__[this.$store.state.profile.lang];
    },

    /* form validation */
    errName: function errName() {
      return (/\W/.test(this.name) || /^$/.test(this.name) || this.nameTaken
      );
    },
    errEmail: function errEmail() {
      return !/^[^@\s]+[@][^@\s]+$/.test(this.email) || this.emailTaken;
    },
    errPwds: function errPwds() {
      return (/^$/.test(this.pwd1) || /^$/.test(this.pwd2) || this.pwd1 !== this.pwd2
      );
    },
    errForm: function errForm() {
      return this.errName || this.errEmail || this.errPwds;
    }
  },
  methods: {

    focusImgInput: function focusImgInput() {
      document.querySelector('#image-input').focus();
    },

    isNameTaken: function isNameTaken() {
      var ctx = this;
      if (ctx.name.length === 0) {
        ctx.nameTaken = false;
        return;
      }
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('accounts/name/' + ctx.name).then(function (_ref) {
        var data = _ref.data;

        ctx.nameTaken = data;
      });
    },

    isEmailTaken: function isEmailTaken() {
      var ctx = this;
      if (ctx.email.length === 0) {
        ctx.emailTaken = false;
        return;
      }
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('accounts/email/' + ctx.email).then(function (_ref2) {
        var data = _ref2.data;

        ctx.emailTaken = data;
      });
    },

    submit: function submit() {
      if (this.errForm || this.nameTaken || this.emailTaken) {
        console.log('Not Submitting');
        return;
      }

      console.log('Submitting...');
      this.busy = true;
      var ctx = this;

      var avatarFileName = ctx.profileImg ? ctx.name + '.' + ctx.profileImg.name.split('.').slice(-1).pop() : '';

      var requests = [__WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('accounts/student', {
        email: ctx.email,
        username: ctx.name,
        password: ctx.pwd1,
        avatar: avatarFileName,
        lang: this.$store.state.profile.lang
      })];

      //
      // upload profile pic if set
      if (ctx.profileImg) {
        var data = new FormData();
        data.append('file', ctx.profileImg);
        requests.push(__WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('storage/img/upload?name=' + avatarFileName, data).then(function (res) {
          return console.log(res);
        }).catch(function (err) {
          return console.error(err);
        }));
      }

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.all(requests).then(__WEBPACK_IMPORTED_MODULE_3_axios___default.a.spread(function () {
        ctx.submitOk = true;
      })).catch(function (err) {
        console.log(err);
        ctx.errmsg = this.msg.fail;
      }).then(function () {
        ctx.busy = false;
      });
    }
  },
  components: {
    lyBtn: __WEBPACK_IMPORTED_MODULE_0__comps_btn__["a" /* default */],
    lyInputImg: __WEBPACK_IMPORTED_MODULE_1__comps_input_img__["a" /* default */],
    lyFlexCenter: __WEBPACK_IMPORTED_MODULE_2__comps_flex_center__["a" /* default */]
  }
});

/***/ }),

/***/ "61mS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ly-video-wrapper',[_vm._v("\n  Ich bin ein Inhalt, holt mich hier raus!\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6Rv0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6VII":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMjgiIGhlaWdodD0iMTI4IiB2ZXJzaW9uPSIxIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGZpbGw9IiNBRjJEMjciIGQ9Ik0wIDBoMTI4djEyOEgweiIvPjxwYXRoIGZpbGw9IiMyMTQ2OEIiIGQ9Ik0xMjggMHYxMjhIMEwxMjggMHoiLz48dGV4dCBmaWxsPSIjRkZGRkZGIiBmb250LWZhbWlseT0iQXJpYWwiIGZvbnQtc2l6ZT0iNjQiPjx0c3BhbiB4PSIyMyIgeT0iODUiPk5MPC90c3Bhbj48L3RleHQ+PC9nPjwvc3ZnPgo="

/***/ }),

/***/ "76Gz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__i18n_common__ = __webpack_require__("sknz");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ly-disableplayer',
  data: function data() {
    return {
      main_ok: false,
      sign_ok: false,
      sub_ok: false,

      busy: false,
      ableplayer: null
    };
  },

  props: {
    src: String,
    sign: String,
    sub: String
  },
  watch: {
    src: function src() {
      this.checkSources();
    }
  },
  mounted: function mounted() {
    this.checkSources();
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])(['profile']), {
    i18n: function i18n() {
      return __WEBPACK_IMPORTED_MODULE_4__i18n_common__[this.$store.state.profile.lang];
    },
    playerId: function playerId() {
      return "ly-ableplayer-" + this._uid;
    },
    playerCopyId: function playerCopyId() {
      return this.playerId + "-copy";
    },
    playerContainerId: function playerContainerId() {
      return this.playerId + "-container";
    },
    pw: function pw() {
      return window.innerWidth * 0.42;
    }
  }),
  methods: {
    checkSources: function checkSources() {
      var ctx = this;
      ctx.busy = true;

      // check src
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(ctx.src).then(function () {
        ctx.main_ok = true;
        //
        // check sign
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(ctx.sign).then(function () {
          ctx.sign_ok = true;
          //
          // check sub
          __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(ctx.sub).then(function () {
            ctx.sub_ok = true;
          }).catch(function () {
            ctx.sub_ok = false;
          }).then(function () {
            ctx.$forceUpdate();ctx.reloadPlayer();
          });
        }).catch(function () {
          ctx.sign_ok = false;
          ctx.$forceUpdate();
          ctx.reloadPlayer();
        });
      }).catch(function () {
        ctx.main_ok = false;
        ctx.busy = false;
        ctx.$forceUpdate();
      });
    },
    reloadPlayer: function reloadPlayer() {
      var ctx = this;
      ctx.busy = true;

      ctx.ableplayer = null;
      var playerContainer = __WEBPACK_IMPORTED_MODULE_1_jquery___default()("#" + ctx.playerContainerId);
      playerContainer.empty();

      setTimeout(function () {
        if (ctx.ableplayer !== null) return;
        ctx.busy = false;
        var playerCopy = __WEBPACK_IMPORTED_MODULE_1_jquery___default()("#" + ctx.playerId).clone();
        playerCopy.attr("data-lang", ctx.profile.lang === "pl" ? "en" : ctx.profile.lang);
        console.log("Player lang: ", playerCopy.attr("data-lang"));
        playerContainer.append(playerCopy);
        ctx.ableplayer = new window.AblePlayer(playerCopy);
      }, 2000);
    }
  }
});

/***/ }),

/***/ "7VUh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mycourses-view"},[_c('div',{staticClass:"bg-dark pt-5 pb-3 mb-5"},[(_vm.profile.avatar !== '')?_c('img',{staticClass:"d-block rounded-circle mx-auto avatar",attrs:{"src":_vm.avatarURL,"alt":"Avatar"}}):_c('img',{staticClass:"d-block rounded-circle mx-auto avatar",attrs:{"src":__webpack_require__("ya+h"),"alt":"Avatar"}}),_vm._v(" "),_c('h1',{staticClass:"text-center text-light"},[_vm._v("\n      "+_vm._s(_vm.profile.name)+"\n    ")])]),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"d-flex justify-content-between"},[_c('h2',{attrs:{"id":"tab-focus","tabindex":"0"}},[_c('b',[_vm._v(_vm._s(_vm.i18n.title))])])]),_vm._v(" "),_c('div',{staticClass:"sep"}),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-start flex-wrap",attrs:{"id":"filters"}},_vm._l((_vm.cats),function(cat){return _c('a',{staticClass:"filter",class:{active: cat.on},attrs:{"href":""},on:{"click":function($event){$event.preventDefault();cat.on = !cat.on}}},[_c('u',[_vm._v(_vm._s(cat.label))])])}),0),_vm._v(" "),_c('div',{staticClass:"sep"}),_vm._v(" "),_c('div',{staticClass:"ly-search-bar"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchStr),expression:"searchStr"}],attrs:{"id":"search-bar","type":"text","placeholder":_vm.i18n.searchPH,"autofocus":""},domProps:{"value":(_vm.searchStr)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchStr=$event.target.value}}}),_vm._v(" "),_c('i',{staticClass:"fas fa-search"})])])])]),_vm._v(" "),_c('div',{staticStyle:{"height":"2rem"}}),_vm._v(" "),_c('div',{staticClass:"ly-bg-grey"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('ly-accordion',{attrs:{"data":_vm.search(_vm.sort(_vm.filter(_vm.courses)))},scopedSlots:_vm._u([{key:"item",fn:function(data){return _c('div',{},[_c('div',{staticClass:"d-flex"},[_c('div',{staticClass:"w-25 pr-5"},[_c('h3',{staticClass:"d-flex justify-content-start h-25"},[(data.item.locked)?_c('span',{staticClass:"mr-2"},[_c('i',{staticClass:"fas fa-lock"})]):_vm._e(),_vm._v(" "),(data.item.endDate)?_c('span',{staticClass:"mr-2"},[_c('i',{staticClass:"fas fa-stopwatch"})]):_vm._e()]),_vm._v(" "),(data.item.endDate)?_c('span',[_vm._v("\n                    "+_vm._s(_vm.shortDate(data.item.startDate))+" —\n                    "+_vm._s(_vm.shortDate(data.item.endDate))+"\n                  ")]):_vm._e()]),_vm._v(" "),_c('a',{staticClass:"w-50",attrs:{"href":"#/dse"}},[_c('h4',{staticClass:"m-0"},[_c('u',[_c('strong',[_vm._v(_vm._s(data.item.name))])])]),_vm._v(" "),_c('span',[_vm._v(_vm._s(data.item.category))]),_vm._v(" "),_c('span',[_vm._v("—")]),_c('br'),_vm._v(" "),_c('span',[_vm._v("Stefanie")])]),_vm._v(" "),_c('div',{staticClass:"w-25 text-right"},[_c('span',[_vm._v(_vm._s(_vm.locDate(data.item.createDate)))])])])])}}])},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('div',{staticClass:"d-flex"},[_c('div',{staticStyle:{"flex-basis":"25%"}}),_vm._v(" "),_c('a',{staticClass:"w-50 pt-3 pb-3",attrs:{"href":""},on:{"click":function($event){$event.preventDefault();return _vm.sortByName($event)}}},[_c('i',{class:_vm.nameSortIcon}),_vm._v(" "),_c('span',{staticClass:"d-none d-sm-inline"},[_vm._v(_vm._s(_vm.i18n.sortByName))])]),_vm._v(" "),_c('a',{staticClass:"w-25 text-right pt-3 pb-3",attrs:{"href":""},on:{"click":function($event){$event.preventDefault();return _vm.sortByDate($event)}}},[_c('i',{class:_vm.dateSortIcon}),_vm._v(" "),_c('span',{staticClass:"d-none d-sm-inline"},[_vm._v(_vm._s(_vm.i18n.sortByDate))])])])])])],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8bKB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__i18n_contentnav__ = __webpack_require__("J42g");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'content-nav',
  computed: {
    i18n: function i18n() {
      return __WEBPACK_IMPORTED_MODULE_0__i18n_contentnav__[this.$store.state.profile.lang];
    }
  }
});

/***/ }),

/***/ "9M+g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9Y/g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  title: 'Registration',

  namePH: 'Name',
  nameTaken: 'This name is already taken',
  nameErr: 'Your name may only contain letters and digits',

  emailPH: 'Email',
  emailTaken: 'This email is already taken',
  emailErr: 'This email is invalid',

  pwd1PH: 'Password',
  pwd2PH: 'Repeat password',
  pwdErr: 'The passwords must match',

  profilePic: 'Avatar',

  formErr: 'Please review your inputs for errors',
  submit: 'Register',
  busy: 'Please Wait',
  success: 'Your registration was successful! Proceed to the login',
  fail: 'Something went wrong - please try again later'
});

/***/ }),

/***/ "9cbl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__i18n_common__ = __webpack_require__("sknz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__comps_simple_icon__ = __webpack_require__("IKt7");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ly-media-selector',
  created: function created() {},
  data: function data() {
    return {
      content: {},
      contents: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])(['profile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['isAuthor']), {
    i18n: function i18n() {
      return __WEBPACK_IMPORTED_MODULE_3__i18n_common__[this.$store.state.profile.lang];
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapMutations */])(['toggleMedia'])),
  components: {
    lySimpleIcon: __WEBPACK_IMPORTED_MODULE_4__comps_simple_icon__["a" /* default */]
  }
});

/***/ }),

/***/ "9v0i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('ly-header'),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('ly-footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9wdI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"ly-button",attrs:{"for":"ly-submit"}},[_vm._v("\n\n  "+_vm._s(_vm.left ? '❮' : '')+"\n  "),_vm._t("default"),_vm._v("\n  "+_vm._s(_vm.right ? '❯' : '')+"\n\n  "),(_vm.submit)?_c('input',{staticClass:"d-none",attrs:{"id":"ly-submit","type":"submit"}}):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "A3so":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__i18n_footer__ = __webpack_require__("wxLn");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ly-footer',
  data: function data() {
    return {};
  },

  computed: {
    i18n: function i18n() {
      return __WEBPACK_IMPORTED_MODULE_0__i18n_footer__[this.$store.state.profile.lang];
    }
  },
  components: {}
});

/***/ }),

/***/ "AyZG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ly-video-wrapper',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])(['profile']), {
    hint: function hint() {
      if (this.profile.prefs.media.video) {
        if (this.profile.lang === 'de') {
          return 'Video-Inhalt verstecken';
        } else {
          return 'Hide video content';
        }
      } else {
        if (this.profile.lang === 'de') {
          return 'Inhalt als Video anzeigen';
        } else {
          return 'Show content as video';
        }
      }
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapMutations */])(['toggleMedia']))
});

/***/ }),

/***/ "BERp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_test_vue__ = __webpack_require__("R9pO");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25706f86_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_test_vue__ = __webpack_require__("61mS");
function injectStyle (ssrContext) {
  __webpack_require__("epL0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-25706f86"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_test_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25706f86_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_test_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "BXiF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  title: 'All courses',
  searchPH: 'Search by course name',
  noCourses: 'No courses found'
});

/***/ }),

/***/ "Ba7+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fieldset',{staticClass:"ly-quiz-mchoice"},[_c('legend',{attrs:{"tabindex":"0"}},[_vm._v(_vm._s(_vm.task))]),_vm._v(" "),_c('div',{staticClass:"p-3 bg-light"},_vm._l((_vm.options),function(option,i){return _c('div',{key:'mchoice-'+_vm._uid+'-option-'+i,staticClass:"form-check"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.answers),expression:"answers"}],staticClass:"form-check-input",attrs:{"id":'mchoice-in-'+_vm._uid+'-'+i,"type":"checkbox"},domProps:{"value":i,"checked":Array.isArray(_vm.answers)?_vm._i(_vm.answers,i)>-1:(_vm.answers)},on:{"change":function($event){var $$a=_vm.answers,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=i,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.answers=$$a.concat([$$v]))}else{$$i>-1&&(_vm.answers=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.answers=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":'mchoice-in-'+_vm._uid+'-'+i}},[_vm._v("\n        "+_vm._s(option)+"\n      ")]),_vm._v(" "),_c('i',{staticClass:"ml-2",class:{'far fa-check-circle text-success': _vm.correct(i)}}),_vm._v(" "),_c('i',{staticClass:"ml-2",class:{'far fa-times-circle text-danger': _vm.incorrect(i)}})])}),0),_vm._v(" "),(_vm.maxTries > 0)?_c('div',{staticClass:"text-secondary my-2",attrs:{"tabindex":"0"}},[(_vm.profile.lang === 'de')?_c('span',[_vm._v("Versuche übrig:")]):_c('span',[_vm._v("Tries left:")]),_vm._v("\n    "+_vm._s(_vm.maxTries-_vm.tries)+"\n  ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":_vm.freeze},on:{"click":_vm.check}},[_c('i',{staticClass:"fas fa-check"}),_vm._v(" "),(_vm.profile.lang === 'de')?_c('span',[_vm._v("Prüfen")]):_c('span',[_vm._v("Check")])]),_vm._v(" "),_c('span',{staticClass:"ml-2",attrs:{"id":_vm.feedbackId,"aria-live":"polite"}},[_vm._v(_vm._s(_vm.feedback))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BxaP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__quiz_schoice_vue__ = __webpack_require__("4JXS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__quiz_mchoice_vue__ = __webpack_require__("/kPk");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ly-quiz-choice',
  created: function created() {},
  activated: function activated() {
    if (!this.loaded) {
      this.onUrlChange();
    }
  },
  data: function data() {
    return {
      type: "single",
      task: "",
      options: [],
      solutions: [],
      maxTries: 0,
      loaded: false
    };
  },

  props: {
    url: String
  },
  watch: {
    url: function url() {
      this.onUrlChange();
    }
  },
  computed: {},
  methods: {
    onUrlChange: function onUrlChange() {
      var ctx = this;
      console.log("quiz url", ctx.url);

      if (ctx.url !== null && ctx.url !== "") {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(ctx.url).then(function (_ref) {
          var data = _ref.data;

          ctx.type = data.type;
          ctx.task = data.task;
          ctx.options = data.options;
          ctx.solutions = data.solutions;
          ctx.maxTries = data.maxTries;
          ctx.loaded = true;
        });
      }
    }
  },
  components: {
    schoice: __WEBPACK_IMPORTED_MODULE_2__quiz_schoice_vue__["a" /* default */],
    mchoice: __WEBPACK_IMPORTED_MODULE_3__quiz_mchoice_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "C1hs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  title: 'Welcome to LAYA',
  subtitle: 'the inclusive learning platform',
  promoText1: 'We offer lectures for trending topics like <b>burnout</b> and <b>compliance</b> for students with learning disabilities or sensory impairments.',
  promoText2: 'For students with audio-visual impairments we provide our content in a best-fit representation.<br>Videos are accompanied by sign language.',
  promoText3: 'Our website is designed with assistive technologies in mind.',
  register: 'Register now!'
});

/***/ }),

/***/ "C2Dk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  laya: 'The digital learning platform for inclusive learning',
  imprint: 'imprint',
  privacy: 'privacy'
});

/***/ }),

/***/ "CHU7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CYcw":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMjgiIGhlaWdodD0iMTI4IiB2ZXJzaW9uPSIxIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGZpbGw9IiM0OTkzNDgiIGQ9Ik0wIDBoMTI4djEyOEgweiIvPjxwYXRoIGZpbGw9IiNDRjM3MzciIGQ9Ik0xMjggMHYxMjhIMEwxMjggMHoiLz48dGV4dCBmaWxsPSIjRkZGRkZGIiBmb250LWZhbWlseT0iQXJpYWwiIGZvbnQtc2l6ZT0iNjQiPjx0c3BhbiB4PSIzNSIgeT0iODUiPklUPC90c3Bhbj48L3RleHQ+PC9nPjwvc3ZnPgo="

/***/ }),

/***/ "CYh6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  title: 'Willkommen auf LAYA',
  subtitle: 'der inklusiven Lernplattform',
  promoText1: 'Wir bieten Lernkurse zu aktuellen Themen wie Burnout und Compliance für Schüler mit Lernschwächen oder sensorischen Einschränkungen.<br>Unsere Inhalte gibt es auch in einfacher Sprache.',
  promoText2: 'Für Schüler mit Hör- oder Sehschwächen bieten wir unsere Inhalte sowohl in Audio- als auch in Videoform an.<br>Unsere Videos werden durch Gebärdensprache begleitet.',
  promoText3: 'Unsere Seite ist für die Navigation mit der Tastatur optimiert und durch die Benutzung eines Screen-Readers getestet.',

  register: 'Melde Dich an!'
});

/***/ }),

/***/ "D+VX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__misc_roles_js__ = __webpack_require__("cPUx");




/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    userId: 0,
    online: false,
    role: __WEBPACK_IMPORTED_MODULE_1__misc_roles_js__["a" /* default */].STUDENT
  },
  getters: {
    isAuthor: function isAuthor(state) {
      return state.role === __WEBPACK_IMPORTED_MODULE_1__misc_roles_js__["a" /* default */].AUTHOR;
    }
  },
  mutations: {
    setRole: function setRole(state, role) {
      state.role = role;
    },
    login: function login(state, _ref) {
      var id = _ref.id,
          userId = _ref.userId;

      state.online = true;
      state.userId = userId;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.common['Authorization'] = id;
    },
    logout: function logout(state) {
      state.online = false;
      state.userId = -1;
      state.role = __WEBPACK_IMPORTED_MODULE_1__misc_roles_js__["a" /* default */].STUDENT;

      delete __WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.common['Authorization'];
    }
  },
  actions: {
    fetchRole: function fetchRole(_ref2) {
      var commit = _ref2.commit,
          state = _ref2.state;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('accounts/' + state.userId + '/role').then(function (_ref3) {
        var data = _ref3.data;
        return commit('setRole', data.role);
      }).catch(function (err) {
        return console.error(err);
      });
    }
  }
});

/***/ }),

/***/ "D3ED":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  title: 'My Courses',
  searchPH: 'Search by course name',
  sortByName: 'Course name',
  sortByDate: 'Created on'
});

/***/ }),

/***/ "Db5O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__comps_btn__ = __webpack_require__("FP6n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__comps_accordion__ = __webpack_require__("IznZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_vue_es_components_collapse_collapse__ = __webpack_require__("UePd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_vue_es_components_collapse_collapse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_bootstrap_vue_es_components_collapse_collapse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap_vue_es_directives_toggle_toggle__ = __webpack_require__("nIHM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap_vue_es_directives_toggle_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_bootstrap_vue_es_directives_toggle_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__i18n_login__ = __webpack_require__("NwLz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__misc_utils_js__ = __webpack_require__("QD4S");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'course-detail-view',
  data: function data() {
    return {
      course: {},
      contents: {},
      userEnrolled: false,
      backUrl: '',

      newContent: { type: '' },
      vstate: {}, /* header collapse state */
      authorMsg: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])(['auth', 'note']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['isAuthor']), {

    msg: function msg() {
      return __WEBPACK_IMPORTED_MODULE_8__i18n_login__[this.$store.state.profile.lang];
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_9__misc_utils_js__["a" /* default */], {

    empty: function empty(obj) {
      if (Array.isArray(obj)) return obj.length === 0;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(obj).length === 0;
    },
    emptyContent: function emptyContent(obj) {
      // TODO
    },
    /*
     * collapse cat headers */
    show: function show(cat, bool) {
      this.vstate[cat] = bool;
      this.$forceUpdate();
    },
    toggle: function toggle(cat) {
      this.vstate[cat] = !this.vstate[cat];
      this.$forceUpdate();
    },

    /*
     * course enrollment/subscription */
    subscribe: function subscribe() {
      var ctx = this;
      __WEBPACK_IMPORTED_MODULE_7_axios___default.a.put('accounts/' + ctx.auth.userId + '/mycourses/rel/' + ctx.course.name).then(function (_ref) {
        var data = _ref.data;

        ctx.$store.commit('addMyCourse');
        ctx.userEnrolled = true;
      }).catch(function (err) {
        return console.error(err);
      });
    },
    unsubscribe: function unsubscribe() {
      var ctx = this;
      ctx.$store.commit('setBusy', true);
      __WEBPACK_IMPORTED_MODULE_7_axios___default.a.delete('accounts/' + ctx.auth.userId + '/mycourses/rel/' + ctx.course.name).then(function (_ref2) {
        var data = _ref2.data;

        ctx.userEnrolled = false;
      }).catch(function (err) {
        return console.error(err);
      }).then(function () {
        ctx.$store.commit('setBusy', false);
      });
    },

    /*
     * author controls */
    storeNewContent: function storeNewContent() {
      var ctx = this;
      var id = this.course.name;
      var _newContent = this.newContent,
          name = _newContent.name,
          category = _newContent.category,
          type = _newContent.type;

      if (!name || !category || !type) {
        this.authorMsg = 'Kontrolliere Deine Eingaben!';
        return;
      }
      this.authorMsg = '';
      __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post('courses/' + id + '/' + type, { name: name, category: category }).then(function (_ref3) {
        var data = _ref3.data;

        __WEBPACK_IMPORTED_MODULE_9__misc_utils_js__["a" /* default */].categorize([data], ctx.contents, type);
        ctx.$forceUpdate();
      }).catch(function (err) {
        return console.error(err);
      });
    },
    delContent: function delContent(id, pos, cat, type) {
      var ctx = this;
      __WEBPACK_IMPORTED_MODULE_7_axios___default.a.delete('courses/' + ctx.course.name + '/' + type + '/' + id).then(function () {
        ctx.contents[cat][type].splice(pos, 1);
        ctx.$forceUpdate();
      }).catch(function (err) {
        return console.error(err);
      });
    }
  }),
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      vm.backUrl = from.path;
    });
  },
  created: function created() {
    var _this = this;

    var ctx = this;
    window.scrollTo(0, 0);
    ctx.$store.commit('setBusy', true);
    /*
     * fetch course */
    __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get('courses/' + ctx.$route.params.id + '/?filter={"include":["author", {"topics": "contents"}, {"quizzes": "contents"}]}').then(function (_ref4) {
      var data = _ref4.data;

      ctx.course = data;
      /*
       * categorize content */
      var contents = {};
      __WEBPACK_IMPORTED_MODULE_9__misc_utils_js__["a" /* default */].categorize(data.topics, contents, 'topics');
      __WEBPACK_IMPORTED_MODULE_9__misc_utils_js__["a" /* default */].categorize(data.quizzes, contents, 'quizzes');
      ctx.contents = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, contents);
      /*
       * is student enrolled */
      __WEBPACK_IMPORTED_MODULE_7_axios___default.a.head('courses/' + data.name + '/students/rel/' + ctx.auth.userId).then(function () {
        ctx.userEnrolled = true;
      });
    }).catch(function (err) {
      /*
       * redirect off invalid course */
      console.error(err);
      _this.$router.push('/courses');
    }).then(function () {
      return ctx.$store.commit('setBusy', false);
    });
  },

  components: {
    lyBtn: __WEBPACK_IMPORTED_MODULE_3__comps_btn__["a" /* default */],
    lyAccordion: __WEBPACK_IMPORTED_MODULE_4__comps_accordion__["a" /* default */],
    bCollapse: __WEBPACK_IMPORTED_MODULE_5_bootstrap_vue_es_components_collapse_collapse___default.a,
    vBToggle: __WEBPACK_IMPORTED_MODULE_6_bootstrap_vue_es_directives_toggle_toggle___default.a
  }
});

/***/ }),

/***/ "EQ5Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'imprint-view',
  mounted: function mounted() {
    window.scroll(0, 0);
  }
});

/***/ }),

/***/ "FFAd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mycourses_vue__ = __webpack_require__("339y");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a7d23d8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mycourses_vue__ = __webpack_require__("7VUh");
function injectStyle (ssrContext) {
  __webpack_require__("ZiK9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0a7d23d8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mycourses_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a7d23d8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mycourses_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "FP6n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_btn_vue__ = __webpack_require__("xOdV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dfd94e6e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_btn_vue__ = __webpack_require__("9wdI");
function injectStyle (ssrContext) {
  __webpack_require__("N45j")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-dfd94e6e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_btn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dfd94e6e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_btn_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Fbqb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  easyLanguage: 'Leichte Sprache',
  videoDoesNotYetExist: 'Video nicht gefunden'
});

/***/ }),

/***/ "Fp8L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function () {
  return 'https://dse.kopfhandundfuss.net';
});

/***/ }),

/***/ "IKt7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_simple_icon_vue__ = __webpack_require__("oYty");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8f7f9a42_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_simple_icon_vue__ = __webpack_require__("JAzY");
function injectStyle (ssrContext) {
  __webpack_require__("CHU7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8f7f9a42"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_simple_icon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8f7f9a42_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_simple_icon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_auth_js__ = __webpack_require__("D+VX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_note_js__ = __webpack_require__("yMiU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_profile_js__ = __webpack_require__("PMOm");



/* modules */




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* default */]);

var debug = "production" !== 'production';
console.log(debug ? 'vuex in debug mode' : '');

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* default */].Store({
  modules: {
    auth: __WEBPACK_IMPORTED_MODULE_2__modules_auth_js__["a" /* default */],
    note: __WEBPACK_IMPORTED_MODULE_3__modules_note_js__["a" /* default */],
    profile: __WEBPACK_IMPORTED_MODULE_4__modules_profile_js__["a" /* default */]
  },
  strict: debug
}));

/***/ }),

/***/ "IznZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_accordion_vue__ = __webpack_require__("t8ey");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f6f6bd4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_accordion_vue__ = __webpack_require__("SdPe");
function injectStyle (ssrContext) {
  __webpack_require__("uSsV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7f6f6bd4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_accordion_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f6f6bd4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_accordion_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "J2v2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "J42g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__de_js__ = __webpack_require__("mVMy");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "de", function() { return __WEBPACK_IMPORTED_MODULE_0__de_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__en_js__ = __webpack_require__("erqz");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "en", function() { return __WEBPACK_IMPORTED_MODULE_1__en_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__es_js__ = __webpack_require__("Sqh6");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "es", function() { return __WEBPACK_IMPORTED_MODULE_2__es_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__it_js__ = __webpack_require__("RuOD");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "it", function() { return __WEBPACK_IMPORTED_MODULE_3__it_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "pl", function() { return __WEBPACK_IMPORTED_MODULE_1__en_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__nl_js__ = __webpack_require__("PelO");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "nl", function() { return __WEBPACK_IMPORTED_MODULE_4__nl_js__["a"]; });







/***/ }),

/***/ "J49P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  title: 'Meine Kurse',
  searchPH: 'Suche nach Kursnamen',
  sortByName: 'Kursname',
  sortByDate: 'Hinzugefügt'
});

/***/ }),

/***/ "JAzY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ly-simple-icon"},[_c('i',{staticClass:"lc fas fa-circle"}),_vm._v(" "),_c('i',{staticClass:"rc fas fa-circle"}),_vm._v(" "),_c('i',{staticClass:"text far fa-comment-alt"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JJzB":
/***/ (function(module, exports) {

module.exports = {"title":"Einloggen","emailPH":"Email","pwdPH":"Passwort","submitTxt":"Einloggen","busyTxt":"Bitte Warten...","errMsg":"Deine Anmeldung war nicht erfolgreich - prüfe Deine Eingaben!","registerHint1":"Noch keinen Account ?","registerHint2":"Hier geht es zur Anmeldung"}

/***/ }),

/***/ "JrZY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KDSd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LAIC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dse_vue__ = __webpack_require__("SH0Y");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e37d0be_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dse_vue__ = __webpack_require__("Vbt8");
function injectStyle (ssrContext) {
  __webpack_require__("c7Sd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5e37d0be"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dse_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e37d0be_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dse_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LWt6":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMjgiIGhlaWdodD0iMTI4IiB2ZXJzaW9uPSIxIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGZpbGw9IiNERTNCMzAiIGQ9Ik0wIDBoMTI4djEyOEgweiIvPjxwYXRoIGZpbGw9IiNGQUNEMzMiIGQ9Ik0xMjggMzh2ODlsLTEgMUgzOGw5MC05MHoiLz48cGF0aCBmaWxsPSIjMDAwMDAwIiBkPSJNMSAwaDg5TDAgOTBWMWwxLTF6Ii8+PHRleHQgZmlsbD0iI0ZGRkZGRiIgZm9udC1mYW1pbHk9IkFyaWFsIiBmb250LXNpemU9IjY0Ij48dHNwYW4geD0iMTkiIHk9Ijg1Ij5ERTwvdHNwYW4+PC90ZXh0PjwvZz48L3N2Zz4K"

/***/ }),

/***/ "LXeo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ly-ableplayer"},[(_vm.main_ok)?[_c('video',{attrs:{"id":_vm.playerId,"preload":"auto","height":"480","width":"720","data-lang":_vm.lang,"data-force-lang":""}},[(_vm.sign_ok)?[_c('source',{attrs:{"type":"video/mp4","src":_vm.src,"data-sign-src":_vm.sign}})]:[_c('source',{attrs:{"type":"video/mp4","src":_vm.src}})],_vm._v(" "),(_vm.sub_ok)?[_c('track',{attrs:{"kind":"captions","src":_vm.sub,"default":""}})]:_vm._e()],2)]:[_c('h1',[_vm._v(_vm._s(_vm.i18n.videoDoesNotYetExist))])]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Lfuy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"register-view ly-nav-margin"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('form',{staticClass:"d-flex flex-column align-items-center"},[_c('div',{staticStyle:{"height":"2rem"}}),_vm._v(" "),_c('img',{staticClass:"w-50",attrs:{"src":__webpack_require__("ya+h"),"alt":"Login"}}),_vm._v(" "),_c('h1',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.msg.title))]),_vm._v(" "),_c('div',{staticClass:"ly-input",class:{error: _vm.errName}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],staticClass:"w-100",attrs:{"id":"register-focus","placeholder":_vm.msg.namePH,"type":"text","disabled":_vm.submitOk,"aria-describedby":"name-err"},domProps:{"value":(_vm.name)},on:{"blur":_vm.isNameTaken,"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"text-center",class:{'d-none': !_vm.errName}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.nameTaken),expression:"nameTaken"}],staticClass:"text-center",attrs:{"id":"name-err","aria-hidden":!_vm.nameTaken}},[_vm._v("\n            "+_vm._s(_vm.nameTaken ? _vm.msg.nameTaken : _vm.msg.nameErr)+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"ly-input",class:{error: _vm.errEmail}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"w-100",attrs:{"placeholder":_vm.msg.emailPH,"type":"text","disabled":_vm.submitOk,"aria-describedby":"email-err"},domProps:{"value":(_vm.email)},on:{"blur":_vm.isEmailTaken,"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"text-center",class:{'d-none': !_vm.errEmail}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.emailTaken),expression:"emailTaken"}],staticClass:"text-center",attrs:{"id":"email-err","aria-hidden":!_vm.emailTaken}},[_vm._v("\n            "+_vm._s(_vm.emailTaken ? _vm.msg.emailTaken : _vm.msg.emailErr)+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"ly-input",class:{error: _vm.errPwds}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pwd1),expression:"pwd1"}],staticClass:"w-100",attrs:{"placeholder":_vm.msg.pwd1PH,"type":"password","disabled":_vm.submitOk,"aria-describedby":"pwd-err"},domProps:{"value":(_vm.pwd1)},on:{"input":function($event){if($event.target.composing){ return; }_vm.pwd1=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"ly-input",class:{error: _vm.errPwds}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pwd2),expression:"pwd2"}],staticClass:"w-100",attrs:{"placeholder":_vm.msg.pwd2PH,"type":"password","disabled":_vm.submitOk,"aria-describedby":"pwd-err"},domProps:{"value":(_vm.pwd2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.pwd2=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"text-center",class:{'d-none': !_vm.errPwds},attrs:{"id":"pwd-err","aria-hidden":!_vm.errPwds}},[_vm._v("\n          "+_vm._s(_vm.msg.pwdErr)+"\n        ")]),_vm._v(" "),_c('div',{staticStyle:{"height":"2rem"}}),_vm._v(" "),_c('div',{staticClass:"position-relative"},[_c('div',{staticClass:"position-absolute"},[_vm._v(_vm._s(_vm.msg.profilePic))]),_vm._v(" "),_c('ly-input-img',{staticClass:"m-auto",staticStyle:{"width":"7rem"},model:{value:(_vm.profileImg),callback:function ($$v) {_vm.profileImg=$$v},expression:"profileImg"}},[_c('img',{attrs:{"src":__webpack_require__("QP9e"),"alt":"Profilbild wählen"}})])],1),_vm._v(" "),_c('div',{staticStyle:{"height":"4rem"}}),_vm._v(" "),_c('h4',{class:{'d-none': _vm.busy || _vm.submitOk}},[(!_vm.errForm)?_c('button',{staticClass:"btn btn-lg btn-block btn-outline-dark",staticStyle:{"border":"2px solid black"},attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.submit($event)}}},[_vm._v("\n            "+_vm._s(_vm.msg.submit)+" "),_c('i',{staticClass:"fas fa-arrow-right"})]):_vm._e()]),_vm._v(" "),_c('h5',{staticClass:"text-center",class:{'d-none': !_vm.errForm},attrs:{"id":"form-err"}},[_vm._v("\n          "+_vm._s(_vm.msg.formErr)+"\n        ")]),_vm._v(" "),_c('h5',{staticClass:"text-center",class:{'d-none': !_vm.busy}},[_vm._v("\n          "+_vm._s(_vm.msg.busy)+" "),_c('i',{staticClass:"fas fa-spinner fa-spin"})]),_vm._v(" "),_c('h5',{staticClass:"text-center",class:{'d-none': !_vm.submitOk}},[_c('router-link',{attrs:{"to":"/login"}},[_c('ly-flex-center',[_c('u',[_vm._v(_vm._s(_vm.msg.success))]),_vm._v(" "),_c('img',{staticStyle:{"width":"3rem"},attrs:{"src":__webpack_require__("n8K7"),"alt":"Erfolg"}})])],1)],1),_vm._v(" "),_c('h5',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.errmsg))])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Lr6B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_profile_vue__ = __webpack_require__("j2go");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f6d4c24_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_profile_vue__ = __webpack_require__("bD/a");
function injectStyle (ssrContext) {
  __webpack_require__("WWcw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5f6d4c24"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_profile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f6d4c24_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_profile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "M9YT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ly-input-img position-relative"},[_c('label',{staticClass:"d-block m-auto",attrs:{"for":"image-input"}},[(_vm.preview)?_c('img',{staticClass:"rounded-circle",staticStyle:{"border":"2px solid black"},attrs:{"src":_vm.preview,"alt":"Datei auswählen"}}):_vm._t("default")],2),_vm._v(" "),_c('input',{ref:"img",staticClass:"custom-input",attrs:{"id":"image-input","type":"file"},on:{"change":_vm.setImg}}),_vm._v(" "),(_vm.preview)?_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Profilbild löschen"},on:{"click":_vm.unsetImg}},[_c('span',{attrs:{"aria-hidden":!_vm.preview}},[_vm._v("×")])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MaJA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ly-disableplayer"},[_c('div',{staticClass:"d-none"},[_c('video',{attrs:{"id":_vm.playerId,"preload":"auto","width":_vm.pw,"data-force-lang":""}},[(_vm.main_ok && _vm.sign_ok)?[_c('source',{attrs:{"type":"video/mp4","src":_vm.src,"data-sign-src":_vm.sign}})]:_vm._e(),_vm._v(" "),(_vm.main_ok && !_vm.sign_ok)?[_c('source',{attrs:{"type":"video/mp4","src":_vm.src}})]:_vm._e(),_vm._v(" "),(_vm.sub_ok)?[_c('track',{attrs:{"kind":"captions","src":_vm.sub,"default":""}})]:_vm._e()],2)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.busy),expression:"busy"}],staticClass:"vid-loader"},[_c('i',{staticClass:"fas fa-circle-notch fa-spin"})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.main_ok && !_vm.busy),expression:"main_ok && !busy"}]},[_c('div',{attrs:{"id":_vm.playerContainerId}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.main_ok && !_vm.busy),expression:"!main_ok && !busy"}]},[_c('h1',{staticStyle:{"text-align":"center","margin-top":"2rem"}},[_vm._v("\n      "+_vm._s(_vm.i18n.videoDoesNotYetExist)+" "),_c('i',{staticClass:"far fa-grin-beam-sweat"})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Mew9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ly-video-wrapper"},[_c('div',{staticClass:"text text-secondary"},[_c('i',{staticClass:"far fa-lightbulb"}),_vm._v(" "),_c('a',{staticClass:"media-switch ly-focus",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.toggleMedia('video')}}},[_vm._v("\n      "+_vm._s(_vm.hint)+"\n    ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.profile.prefs.media.video),expression:"profile.prefs.media.video"}]},[_c('keep-alive',[_vm._t("default")],2)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "N/Iy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_footer_vue__ = __webpack_require__("A3so");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45aad445_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__ = __webpack_require__("t7Gr");
function injectStyle (ssrContext) {
  __webpack_require__("Wegs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-45aad445"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45aad445_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "N45j":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__("YkRm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("cHtD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__backendURL_js__ = __webpack_require__("ksDr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap_vue__ = __webpack_require__("e6fC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_bootstrap_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_bootstrap_dist_js_bootstrap_min_js__ = __webpack_require__("Bb4J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_bootstrap_dist_js_bootstrap_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_bootstrap_dist_js_bootstrap_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_bootstrap_dist_css_bootstrap_min_css__ = __webpack_require__("qb6w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_bootstrap_dist_css_bootstrap_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_bootstrap_dist_css_bootstrap_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__("9M+g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__css_input_css__ = __webpack_require__("dP61");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__css_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__css_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_ls__ = __webpack_require__("yXtV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_ls___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_ls__);









/* bootstrap */





/* base css */




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_vue_ls___default.a, { name: 'ls', namespace: 'vuejs__', storage: 'local' });
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_bootstrap_vue___default.a);

/* set backend address */
__WEBPACK_IMPORTED_MODULE_5_axios___default.a.defaults.baseURL = __WEBPACK_IMPORTED_MODULE_4__backendURL_js__["a" /* default */];

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  template: '<app/>',
  components: { app: __WEBPACK_IMPORTED_MODULE_1__app__["a" /* default */] }
});

/***/ }),

/***/ "NWro":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return icons; });
/* unused harmony export ids */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_language_icons_icons_de_svg__ = __webpack_require__("LWt6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_language_icons_icons_de_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_language_icons_icons_de_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_language_icons_icons_es_svg__ = __webpack_require__("Q5hG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_language_icons_icons_es_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_language_icons_icons_es_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_language_icons_icons_it_svg__ = __webpack_require__("CYcw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_language_icons_icons_it_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_language_icons_icons_it_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_language_icons_icons_pl_svg__ = __webpack_require__("fQiR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_language_icons_icons_pl_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_language_icons_icons_pl_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_language_icons_icons_nl_svg__ = __webpack_require__("6VII");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_language_icons_icons_nl_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_language_icons_icons_nl_svg__);

//import en from "language-icons/icons/en.svg"





var icons = {
  de: __WEBPACK_IMPORTED_MODULE_0_language_icons_icons_de_svg___default.a, /* en, */es: __WEBPACK_IMPORTED_MODULE_1_language_icons_icons_es_svg___default.a, it: __WEBPACK_IMPORTED_MODULE_2_language_icons_icons_it_svg___default.a, pl: __WEBPACK_IMPORTED_MODULE_3_language_icons_icons_pl_svg___default.a, nl: __WEBPACK_IMPORTED_MODULE_4_language_icons_icons_nl_svg___default.a
};

var ids = ['de', /* 'en', */'es', 'it', 'pl', 'nl'];

/***/ }),

/***/ "NwLz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__de_json__ = __webpack_require__("JJzB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__de_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__de_json__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "de", function() { return __WEBPACK_IMPORTED_MODULE_0__de_json___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__en_json__ = __webpack_require__("pc4X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__en_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__en_json__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "en", function() { return __WEBPACK_IMPORTED_MODULE_1__en_json___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__es_json__ = __webpack_require__("wFL9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__es_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__es_json__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "es", function() { return __WEBPACK_IMPORTED_MODULE_2__es_json___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__it_json__ = __webpack_require__("cP6K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__it_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__it_json__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "it", function() { return __WEBPACK_IMPORTED_MODULE_3__it_json___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pl_json__ = __webpack_require__("wbZI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pl_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pl_json__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "pl", function() { return __WEBPACK_IMPORTED_MODULE_4__pl_json___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__nl_json__ = __webpack_require__("+HJ+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__nl_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__nl_json__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "nl", function() { return __WEBPACK_IMPORTED_MODULE_5__nl_json___default.a; });







/***/ }),

/***/ "O35T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  easyLanguage: 'Łatwy język',
  videoDoesNotYetExist: 'Wideo jeszcze nie istnieje'
});

/***/ }),

/***/ "OUlO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue_es_components_nav_nav_item__ = __webpack_require__("xGBE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue_es_components_nav_nav_item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_bootstrap_vue_es_components_nav_nav_item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue_es_components_nav_nav_item_dropdown__ = __webpack_require__("QjOx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue_es_components_nav_nav_item_dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_bootstrap_vue_es_components_nav_nav_item_dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue_es_components_dropdown_dropdown_item_button_js__ = __webpack_require__("V2Be");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue_es_components_dropdown_dropdown_item_button_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_bootstrap_vue_es_components_dropdown_dropdown_item_button_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_header__ = __webpack_require__("ejFi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__misc_langs_js__ = __webpack_require__("NWro");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__comps_busy_note__ = __webpack_require__("Y5Hx");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ly-header',
  data: function data() {
    return {
      icons: __WEBPACK_IMPORTED_MODULE_7__misc_langs_js__["a" /* icons */]
    };
  },

  watch: {
    '$route': 'checkCourse'
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])(['profile', 'auth', 'note']), {
    i18n: function i18n() {
      return __WEBPACK_IMPORTED_MODULE_6__i18n_header__[this.$store.state.profile.lang];
    }
  }),
  mounted: function mounted() {
    this.checkCourse();
    this.$forceUpdate();
    var store = this.$store;
    /*
     * get browser locale */
    __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('lang').then(function (_ref) {
      var data = _ref.data;

      var lang = data.split("-")[0];
      store.commit('setLang', lang);
    }).catch(function () {
      store.commit('setLang', 'de');
    });
  },
  methods: {
    toggleMedia: function toggleMedia(type) {
      this.$store.commit('toggleMedia', type);
    },
    checkCourse: function checkCourse() {
      this.isCourse = /courses[/]./.test(location.hash);
      this.$forceUpdate();
    },
    setLang: function setLang(lang) {
      this.$store.commit('setLang', lang);
    },
    logout: function logout() {
      this.$ls.remove('auth');
      this.$store.commit('logout');
      this.$router.push('/login');
    }
  },
  components: {
    navItem: __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue_es_components_nav_nav_item___default.a,
    busyNote: __WEBPACK_IMPORTED_MODULE_8__comps_busy_note__["a" /* default */],
    navItemDd: __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue_es_components_nav_nav_item_dropdown___default.a,
    navItemDdBtn: __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue_es_components_dropdown_dropdown_item_button_js___default.a
  }
});

/***/ }),

/***/ "OgvV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__de_js__ = __webpack_require__("CYh6");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "de", function() { return __WEBPACK_IMPORTED_MODULE_0__de_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__en_js__ = __webpack_require__("C1hs");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "en", function() { return __WEBPACK_IMPORTED_MODULE_1__en_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "es", function() { return __WEBPACK_IMPORTED_MODULE_1__en_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "it", function() { return __WEBPACK_IMPORTED_MODULE_1__en_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "pl", function() { return __WEBPACK_IMPORTED_MODULE_1__en_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "nl", function() { return __WEBPACK_IMPORTED_MODULE_1__en_js__["a"]; });







/***/ }),

/***/ "P+mf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  easyLanguage: 'Easy Language',
  videoDoesNotYetExist: 'Video does not yet exist'
});

/***/ }),

/***/ "PMOm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__misc_langs_js__ = __webpack_require__("NWro");




/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    name: '',
    email: '',
    prefs: {
      media: {
        text: true,
        simple: false,
        video: true,
        audio: false
      }
    },
    lang: 'de',
    avatar: ''
  },
  mutations: {
    setLang: function setLang(state, lang) {
      state.lang = __WEBPACK_IMPORTED_MODULE_2__misc_langs_js__["a" /* icons */][lang] !== undefined ? lang : "de";
    },
    toggleMedia: function toggleMedia(state, type) {
      state.prefs.media[type] = !state.prefs.media[type];
    },
    setPrefs: function setPrefs(state, _ref) {
      var media = _ref.media;

      state.prefs.media = {
        text: media.text,
        simple: media.simple,
        video: media.video,
        audio: media.audio
      };
    },
    setProfile: function setProfile(state, _ref2) {
      var username = _ref2.username,
          email = _ref2.email,
          prefs = _ref2.prefs,
          lang = _ref2.lang,
          avatar = _ref2.avatar;

      state.name = username;
      state.email = email;
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(prefs).length > 0) {
        state.prefs = prefs;
      }
      // state.lang = lang
      state.avatar = avatar;
    }
  },
  actions: {
    fetchProfile: function fetchProfile(_ref3) {
      var commit = _ref3.commit,
          state = _ref3.state,
          rootState = _ref3.rootState;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('accounts/' + rootState.auth.userId).then(function (_ref4) {
        var data = _ref4.data;
        return commit('setProfile', data);
      }).catch(function (err) {
        return console.error(err);
      });
    }
  }
});

/***/ }),

/***/ "PelO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  submenu: 'Submenu:',
  content: 'Inhoud',
  overview: 'Overzicht',
  longTermSupport: 'Langdurige ondersteuning',
  skillsAndTalents: 'Vaardigheden en Talenten',
  yourMap: 'Uw kaart',
  motivationAndEmotionalIntelligence: 'Motivatie en Emotionele Intelligentie',
  alliancesCompromisesAndResources: 'Allianties, compromissen en resources',
  skillsToStartABusiness: 'Vaardigheden om meen bedrijf te starten',
  accountingAndFinance: 'Boekhouding en Financiën',
  settingUpYourOwnBusiness: 'Je eigen bedrijf opzetten',
  accountingBasics: 'Basiskennis boekhouden',
  openingABankAccount: 'Een bankrekening openen',
  businessPlanBasicInformation: 'Business Plan, basisinformatie',
  taxes: 'Belastingen',
  legalFormsOfEmployment: 'Wettelijke regelgeving voor ondernemerschap',
  marketingAndSales: 'Marketing & Sales',
  whatAreMyProducts: 'Wat zijn mijn producten?',
  whoAreMyClients: 'Wat zijn mijn cliënten?',
  communication: 'Communicatie',
  positioning: 'Positionering',
  sales: 'Sales',
  uniqueSellingPoints: 'Unique Selling Points',
  publicRelations: 'Public Relations',
  introduction: 'Introductie',
  strategy: 'Strategie',
  messagesAndTools: 'Berichten en Instrumenten',
  digitalPRAndSMRevolution: 'Digitale PR en social media revolutie',
  it: 'ICT',
  cloudVSOnPremises: 'Cloud vs. On-Premises',
  email: 'Email',
  onlineMarketing: 'Online Marketing',
  webshop: 'Webshop',
  website: 'Website'
});

/***/ }),

/***/ "PftW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  avatar: 'Avatar',

  title: 'My Profile',

  namePH: 'Name',
  nameTaken: 'This name is already taken',
  nameErr: 'Your name may only contain letters and numbers',

  emailPH: 'Email',
  emailTaken: 'This email is already taken',
  emailErr: 'This email is invalid',

  oldPwd: 'Current password',
  newPwd: 'New password',
  pwdFail: 'The current password you entered is wrong',

  defmedia: {
    label: 'Content representation',
    text: 'Text',
    simple: 'Simple Language',
    video: 'Video',
    audio: 'Audio'
  },

  submit: 'Save',
  busy: 'Please Wait',
  submitOk: 'Your profile has been successfully updated',
  submitFail: '[PH]'
});

/***/ }),

/***/ "Q5hG":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMjgiIGhlaWdodD0iMTI4IiB2ZXJzaW9uPSIxIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGZpbGw9IiNGOEM0MzMiIGQ9Ik0wIDBoMTI4djEyOEgweiIvPjxwYXRoIGZpbGw9IiNERTNCMzAiIGQ9Ik0xMjggMzh2ODlsLTEgMUgzOGw5MC05MHoiLz48cGF0aCBmaWxsPSIjREUzQjMwIiBkPSJNMSAwaDg5TDAgOTBWMWwxLTF6Ii8+PHRleHQgZmlsbD0iI0ZGRkZGRiIgZm9udC1mYW1pbHk9IkFyaWFsIiBmb250LXNpemU9IjY0Ij48dHNwYW4geD0iMjEiIHk9Ijg1Ij5FUzwvdHNwYW4+PC90ZXh0PjwvZz48L3N2Zz4K"

/***/ }),

/***/ "QD4S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  shortDate: function shortDate(dateStr) {
    var lang = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'de';

    return new Date(Date.parse(dateStr)).toLocaleDateString(lang, {
      day: '2-digit',
      month: '2-digit',
      year: '2-digit'
    });
  },
  locDate: function locDate(dateStr) {
    var lang = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'de';

    return new Date(Date.parse(dateStr)).toLocaleDateString(lang);
  },
  categorize: function categorize(arr, target, key) {
    if (!arr) return;
    arr.forEach(function (data) {
      var category = data.category;

      if (!target[category]) {
        target[category] = {};
        target[category][key] = [];
      }
      if (!target[category][key]) {
        target[category][key] = [];
      }
      target[category][key].push(data);
    });
  }
});

/***/ }),

/***/ "QP9e":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "Quw4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_vue__ = __webpack_require__("unXG");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a6f2b98_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_login_vue__ = __webpack_require__("1Uil");
function injectStyle (ssrContext) {
  __webpack_require__("kraY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2a6f2b98"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a6f2b98_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "R8db":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'privacy-view',
  mounted: function mounted() {
    window.scroll(0, 0);
  }
});

/***/ }),

/***/ "R9pO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__comps_ableplayer__ = __webpack_require__("Um6u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__comps_video_wrapper__ = __webpack_require__("quEe");
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'test-view',
  data: function data() {
    return {};
  },

  computed: {},
  methods: {},
  components: {
    lyAbleplayer: __WEBPACK_IMPORTED_MODULE_0__comps_ableplayer__["a" /* default */],
    lyVideoWrapper: __WEBPACK_IMPORTED_MODULE_1__comps_video_wrapper__["a" /* default */]
  }
});

/***/ }),

/***/ "Rg+h":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RhD6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ly-input-wrapper"},[_c('div',{staticClass:"ly-input",class:{error: _vm.invalid}},[_c('input',{ref:"input",staticClass:"w-100",attrs:{"placeholder":_vm.ph,"type":_vm.type,"disabled":_vm.disabled},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.onValue($event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"text-center",class:{'d-none': !_vm.invalid}},[_vm._v("\n    "+_vm._s(_vm.hint)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RuOD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  submenu: 'Sottomenu:',
  content: 'Contenuto',
  overview: 'Panoramica ',
  longTermSupport: 'Supporto a Lungo Termine',
  skillsAndTalents: 'Competenze e Talenti',
  yourMap: 'La tua Mappa',
  motivationAndEmotionalIntelligence: 'Motivazione ed intelligenza emotiva',
  alliancesCompromisesAndResources: 'Alleanze, compromessi e risorse',
  skillsToStartABusiness: 'Abilità per avviare un\'impresa',
  accountingAndFinance: 'Contabilità e Finanza',
  settingUpYourOwnBusiness: 'Impostare il proprio business',
  accountingBasics: 'Nozioni base di contabilità',
  openingABankAccount: 'Apertura di un conto bancario',
  businessPlanBasicInformation: 'Nozioni base sul piano aziendale',
  taxes: 'Tasse',
  legalFormsOfEmployment: 'Forme giuridiche del lavoro',
  marketingAndSales: 'Marketing e vendite',
  whatAreMyProducts: 'Quali sono i miei prodotti?',
  whoAreMyClients: 'Chi sono i miei clienti?',
  communication: 'Comunicazione',
  positioning: 'Posizionamento',
  sales: 'Vendite',
  uniqueSellingPoints: 'Punti vendita unici',
  publicRelations: 'Relazioni pubbliche',
  introduction: 'Introduzione',
  strategy: 'Strategia',
  messagesAndTools: 'Messaggi e strumenti',
  digitalPRAndSMRevolution: 'Le PR.digitali e la rivoluzione dei social media',
  it: 'IT (Tecnologia Informatica)',
  cloudVSOnPremises: 'Differenza tra Cloud e On Premise',
  email: 'Email',
  onlineMarketing: 'Marketing online',
  webshop: 'Negozio elettronico',
  website: 'Sito web'
});

/***/ }),

/***/ "SH0Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__comps_media_selector__ = __webpack_require__("cCPC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__comps_content_nav_vue__ = __webpack_require__("vqPg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__comps_disableplayer_vue__ = __webpack_require__("2dQQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__backendURL_js__ = __webpack_require__("ksDr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__awsURL_js__ = __webpack_require__("Fp8L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__comps_quiz_choice_vue__ = __webpack_require__("jOuJ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var dseVideoPath = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__awsURL_js__["a" /* default */])() + '/dse/videos';

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dse-view',
  created: function created() {},
  data: function data() {
    return {
      moduleMap: {
        "overview": "Overview",
        "long-term-support": "Long Term Support",
        "accounting-finance": "Accouning & Finance",
        "marketing-sales": "Marketing & Sales",
        "public-relations": "Public Relations",
        "it": "IT"
      }
    };
  },

  computed: {},
  methods: {
    backend: function backend(file) {
      return __WEBPACK_IMPORTED_MODULE_3__backendURL_js__["a" /* default */] + '/storage/dse/download/' + file;
    },
    getVid: function getVid() {
      var id = this.$route.params.module;
      var lang = this.$store.state.profile.lang;
      var easy = this.$store.state.profile.prefs.media.simple ? ".easy" : "";
      return dseVideoPath + '/' + id + '.' + lang + easy + '.mp4';
    },
    getSign: function getSign() {
      var id = this.$route.params.module;
      var lang = this.$store.state.profile.lang;
      return dseVideoPath + '/' + id + '.' + lang + '.sign.mp4';
    },
    getSub: function getSub() {
      var id = this.$route.params.module;
      var lang = this.$store.state.profile.lang;
      var easy = this.$store.state.profile.prefs.media.simple ? ".easy" : "";
      return dseVideoPath + '/' + id + '.' + lang + easy + '.vtt';
    },
    getQuiz: function getQuiz() {
      var id = this.$route.params.module;
      var lang = this.$store.state.profile.lang;
      var easy = this.$store.state.profile.prefs.media.simple ? ".easy" : "";
      return 'storage/dse/download/' + id + '.' + lang + easy + '.json';
    }

  },
  components: {
    // lyContentIcon,
    lyChoice: __WEBPACK_IMPORTED_MODULE_5__comps_quiz_choice_vue__["a" /* default */],
    lyAbleplayer: __WEBPACK_IMPORTED_MODULE_2__comps_disableplayer_vue__["a" /* default */],
    lyContentNav: __WEBPACK_IMPORTED_MODULE_1__comps_content_nav_vue__["a" /* default */],
    lyMediaSelector: __WEBPACK_IMPORTED_MODULE_0__comps_media_selector__["a" /* default */]
  }
});

/***/ }),

/***/ "SdPe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ly-accordion"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.data.length > 0),expression:"data.length > 0"}]},[_vm._t("header"),_vm._v(" "),_c('div',{staticClass:"list"},_vm._l((_vm.data),function(d){return _c('div',{staticClass:"item"},[_vm._t("item",null,{"item":d})],2)}),0)],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.data.length === 0),expression:"data.length === 0"}],staticClass:"p-3"},[_c('h3',{staticClass:"empty text-center"},[_c('i',{staticClass:"far fa-frown"}),_vm._v(" "),(_vm.$store.state.profile.lang === 'de')?_c('span',[_vm._v("\n        Keine Kurse gefunden\n      ")]):_c('span',[_vm._v("No courses found")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SkqW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ly-flex-center"},[_c('div',{staticClass:"d-flex justify-content-center align-items-center",staticStyle:{"height":"100%"}},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Sl7e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue__ = __webpack_require__("OUlO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0eefa766_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__ = __webpack_require__("tgcj");
function injectStyle (ssrContext) {
  __webpack_require__("rtHv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0eefa766"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0eefa766_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Sqh6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  submenu: 'Submenú:',
  content: 'Contenido',
  overview: 'Introducción',
  longTermSupport: 'Recursos y competencias',
  skillsAndTalents: 'Habilidades y talento',
  yourMap: 'Tu hoja de ruta',
  motivationAndEmotionalIntelligence: 'Motivación e Inteligencia Emocional',
  alliancesCompromisesAndResources: 'Alianzas, pactos y recursos',
  skillsToStartABusiness: 'Habilidades emprendedoras',
  accountingAndFinance: 'Contabilidad y Finanzas',
  settingUpYourOwnBusiness: 'Poniendo en marcha tu propio negocio',
  accountingBasics: 'Contabilidad básica',
  openingABankAccount: 'Cuentas bancarias',
  businessPlanBasicInformation: 'Plan de empresa: información básica',
  taxes: 'Impuestos',
  legalFormsOfEmployment: 'Formas jurídicas',
  marketingAndSales: 'Marketing y ventas',
  whatAreMyProducts: '¿Cuáles son mis productos?',
  whoAreMyClients: '¿Quiénes son mis clientes?',
  communication: 'Comunicación',
  positioning: 'Posicionamiento',
  sales: 'Ventas',
  uniqueSellingPoints: 'Puntos únicos de venta',
  publicRelations: 'Relaciones Públicas',
  introduction: 'Introducción',
  strategy: 'Estrategia',
  messagesAndTools: 'Mensajes y herramientas',
  digitalPRAndSMRevolution: 'RP Digital y Revolución MS',
  it: 'Tecnologías de la Información',
  cloudVSOnPremises: 'La nube vs. Trabajo local',
  email: 'Email',
  onlineMarketing: 'Marketing Online',
  webshop: 'Comercio electrónico',
  website: 'Página web'
});

/***/ }),

/***/ "Swq6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ly-quiz-schoice',
  created: function created() {},
  data: function data() {
    return {
      tries: 0,
      answer: -1,
      feedback: '',
      freeze: false
    };
  },

  props: {
    task: String,
    options: Array,
    solution: Number,
    maxTries: Number
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])(['profile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['isAuthor']), {
    feedbackId: function feedbackId() {
      return 'schoice-feedback-' + this._uid;
    }
  }),
  methods: {
    check: function check() {
      if (this.freeze) return;

      this.tries++;
      var correct = this.answer === this.solution;
      if (correct) {
        this.feedback = "Richtig!";
        this.freeze = true;
        document.getElementById(this.feedbackId).focus();
        return;
      } else {
        this.feedback = "Leider falsch!";
        if (this.tries >= this.maxTries) {
          this.freeze = true;
          this.answer = this.solution;
          this.feedback = "Die Lösung wird angezeigt";
        }
        document.getElementById(this.feedbackId).focus();
      }
    }
  }
});

/***/ }),

/***/ "TZ5u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__i18n_root__ = __webpack_require__("OgvV");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'root-view',
  data: function data() {
    return {};
  },

  computed: {
    msg: function msg() {
      return __WEBPACK_IMPORTED_MODULE_0__i18n_root__[this.$store.state.profile.lang];
    }
  },
  components: {}
});

/***/ }),

/***/ "UO8k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_root_vue__ = __webpack_require__("TZ5u");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73266f63_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_root_vue__ = __webpack_require__("+UcY");
function injectStyle (ssrContext) {
  __webpack_require__("kiA1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-73266f63"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_root_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73266f63_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_root_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "Um6u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ableplayer_vue__ = __webpack_require__("4utZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e475502_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ableplayer_vue__ = __webpack_require__("LXeo");
function injectStyle (ssrContext) {
  __webpack_require__("rwV4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ableplayer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e475502_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ableplayer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VXS7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  easyLanguage: 'Linguaggio semplice',
  videoDoesNotYetExist: 'Il video non esiste ancora'
});

/***/ }),

/***/ "Vbt8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-3"},[_c('div',{staticClass:"sidebar"},[_c('ly-content-nav')],1)]),_vm._v(" "),_c('div',{staticClass:"col-9 pl-0"},[_c('div',{staticClass:"media-selector-wrapper"},[_c('ly-media-selector')],1),_vm._v(" "),_c('ly-ableplayer',{attrs:{"src":_vm.getVid(),"sign":_vm.getSign(),"sub":_vm.getSub()}})],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row",attrs:{"role":"banner"}},[_c('div',{staticClass:"col header text-center"},[_c('h1',[_vm._v("Disabled and Self-Employed")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WWcw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Wegs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XLNN":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "XSxF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ly-button',
  props: {

    ph: String,
    type: String,

    hint: String,
    invalid: Boolean,

    disabled: Boolean,

    value: null
  },
  methods: {

    onValue: function onValue(val) {
      this.$emit('input', val);
    }
  }
});

/***/ }),

/***/ "Y2pJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  avatar: 'Foto',

  title: 'Mein Profil',

  namePH: 'Name',
  nameTaken: 'Dieser Name ist bereits vergeben',
  nameErr: 'Dein Name darf nur aus Buchstaben und Zahlen bestehen',

  emailPH: 'Email',
  emailTaken: 'Diese Email ist bereits vergeben',
  emailErr: 'Diese Email ist ungültig',

  oldPwd: 'Altes Passwort',
  newPwd: 'Neues Passwort',
  pwdFail: 'Bitte überprüfe Deine Eingaben',

  defmedia: {
    label: 'Darstellungsformen',
    text: 'Text',
    simple: 'Einfach',
    video: 'Video',
    audio: 'Audio'
  },

  submit: 'Speichern',
  busy: 'Bitte Warten',
  submitOk: 'Dein Profil wurde erneuert',
  submitFail: '[PH]'
});

/***/ }),

/***/ "Y5Hx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_busy_note_vue__ = __webpack_require__("t197");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_685d69e2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_busy_note_vue__ = __webpack_require__("tdMd");
function injectStyle (ssrContext) {
  __webpack_require__("so+g")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-685d69e2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_busy_note_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_685d69e2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_busy_note_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YkRm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_vue__ = __webpack_require__("39ur");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30dd437e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_vue__ = __webpack_require__("9v0i");
function injectStyle (ssrContext) {
  __webpack_require__("1rPj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30dd437e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZiK9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aatY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__de_js__ = __webpack_require__("gbyy");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "de", function() { return __WEBPACK_IMPORTED_MODULE_0__de_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__en_js__ = __webpack_require__("9Y/g");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "en", function() { return __WEBPACK_IMPORTED_MODULE_1__en_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "es", function() { return __WEBPACK_IMPORTED_MODULE_1__en_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "it", function() { return __WEBPACK_IMPORTED_MODULE_1__en_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "pl", function() { return __WEBPACK_IMPORTED_MODULE_1__en_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "nl", function() { return __WEBPACK_IMPORTED_MODULE_1__en_js__["a"]; });







/***/ }),

/***/ "bCH/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bD/a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"bg-dark w-100 pt-5 pb-3"},[(_vm.avatar !== '')?_c('img',{staticClass:"d-block rounded-circle mx-auto avatar",attrs:{"src":_vm.avatarURL,"alt":"Avatar"}}):_c('img',{staticClass:"d-block rounded-circle mx-auto avatar",attrs:{"src":__webpack_require__("ya+h"),"alt":"Avatar"}}),_vm._v(" "),_c('h1',{staticClass:"text-center text-light"},[_vm._v(_vm._s(_vm.profile.name))])])])]),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('form',{staticClass:"w-100",staticStyle:{"margin-top":"1rem"}},[_c('h1',[_vm._v(_vm._s(_vm.msg.title))]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-3 col-form-label",attrs:{"for":"username"}},[_vm._v("\n            "+_vm._s(_vm.msg.namePH)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.profile.name),expression:"profile.name"}],staticClass:"form-control",attrs:{"id":"username","type":"text","readonly":"","tabindex":"-1"},domProps:{"value":(_vm.profile.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.profile, "name", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-3 col-form-label",attrs:{"for":"email"}},[_vm._v("\n            "+_vm._s(_vm.msg.emailPH)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.profile.email),expression:"profile.email"}],staticClass:"form-control",attrs:{"id":"email","type":"text","readonly":"","tabindex":"-1"},domProps:{"value":(_vm.profile.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.profile, "email", $event.target.value)}}})])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-3 col-form-label",attrs:{"for":"oldPwd"}},[_vm._v("\n            "+_vm._s(_vm.msg.oldPwd)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.oldPwd),expression:"oldPwd"}],staticClass:"form-control",attrs:{"id":"oldPwd","type":"password","placeholder":_vm.msg.oldPwd,"autocomplete":"on"},domProps:{"value":(_vm.oldPwd)},on:{"input":function($event){if($event.target.composing){ return; }_vm.oldPwd=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-3 col-form-label",attrs:{"for":"newPwd"}},[_vm._v("\n            "+_vm._s(_vm.msg.newPwd)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newPwd),expression:"newPwd"}],staticClass:"form-control",attrs:{"id":"newPwd","type":"password","placeholder":_vm.msg.newPwd,"aria-describedby":"pwdMsg"},domProps:{"value":(_vm.newPwd)},on:{"input":function($event){if($event.target.composing){ return; }_vm.newPwd=$event.target.value}}}),_vm._v(" "),_c('strong',{staticClass:"form-text text-center",attrs:{"id":"pwdMsg"}},[_vm._v("\n              "+_vm._s(_vm.pwdMsg)+"\n            ")])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-3 col-form-label"},[_vm._v(_vm._s(_vm.msg.defmedia.label))]),_vm._v(" "),_c('div',{staticClass:"col-sm-9 d-inline-flex justify-content-between align-items-center"},[_c('div',{staticClass:"checkbox-inline"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.prefs.media.text),expression:"prefs.media.text"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.prefs.media.text)?_vm._i(_vm.prefs.media.text,null)>-1:(_vm.prefs.media.text)},on:{"change":function($event){var $$a=_vm.prefs.media.text,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.prefs.media, "text", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.prefs.media, "text", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.prefs.media, "text", $$c)}}}}),_vm._v("\n                "+_vm._s(_vm.msg.defmedia.text)+"\n              ")])]),_vm._v(" "),_c('div',{staticClass:"checkbox-inline"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.prefs.media.simple),expression:"prefs.media.simple"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.prefs.media.simple)?_vm._i(_vm.prefs.media.simple,null)>-1:(_vm.prefs.media.simple)},on:{"change":function($event){var $$a=_vm.prefs.media.simple,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.prefs.media, "simple", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.prefs.media, "simple", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.prefs.media, "simple", $$c)}}}}),_vm._v("\n                "+_vm._s(_vm.msg.defmedia.simple)+"\n              ")])]),_vm._v(" "),_c('div',{staticClass:"checkbox-inline"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.prefs.media.video),expression:"prefs.media.video"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.prefs.media.video)?_vm._i(_vm.prefs.media.video,null)>-1:(_vm.prefs.media.video)},on:{"change":function($event){var $$a=_vm.prefs.media.video,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.prefs.media, "video", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.prefs.media, "video", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.prefs.media, "video", $$c)}}}}),_vm._v("\n                "+_vm._s(_vm.msg.defmedia.video)+"\n              ")])]),_vm._v(" "),_c('div',{staticClass:"checkbox-inline"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.prefs.media.audio),expression:"prefs.media.audio"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.prefs.media.audio)?_vm._i(_vm.prefs.media.audio,null)>-1:(_vm.prefs.media.audio)},on:{"change":function($event){var $$a=_vm.prefs.media.audio,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.prefs.media, "audio", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.prefs.media, "audio", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.prefs.media, "audio", $$c)}}}}),_vm._v("\n                "+_vm._s(_vm.msg.defmedia.audio)+"\n              ")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn btn-block btn-lg btn-outline-dark",staticStyle:{"border-width":"2px"},attrs:{"type":"submit","disabled":_vm.busy},on:{"click":_vm.submit}},[_c('i',{staticClass:"fas fa-check"}),_vm._v(" "+_vm._s(_vm.msg.submit)+"\n          ")])]),_vm._v(" "),_c('strong',{staticClass:"form-text text-center"},[_vm._v(_vm._s(_vm.formMsg))])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bL42":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_courses_vue__ = __webpack_require__("fBef");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03436970_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_courses_vue__ = __webpack_require__("xbdJ");
function injectStyle (ssrContext) {
  __webpack_require__("iZV8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-03436970"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_courses_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03436970_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_courses_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "bRiP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ly-quiz-choice"},[(_vm.type === 'single')?_c('schoice',{attrs:{"task":_vm.task,"options":_vm.options,"solution":_vm.solutions[0],"maxTries":_vm.maxTries}}):_c('mchoice',{attrs:{"task":_vm.task,"options":_vm.options,"solutions":_vm.solutions,"maxTries":_vm.maxTries}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "c2lw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_register_vue__ = __webpack_require__("5iqm");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_761ba232_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_register_vue__ = __webpack_require__("Lfuy");
function injectStyle (ssrContext) {
  __webpack_require__("hX1X")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-761ba232"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_register_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_761ba232_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_register_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "c7Sd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cCPC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_media_selector_vue__ = __webpack_require__("9cbl");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75946c1a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_media_selector_vue__ = __webpack_require__("gcd3");
function injectStyle (ssrContext) {
  __webpack_require__("qTjK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-75946c1a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_media_selector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75946c1a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_media_selector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cHtD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_index_js__ = __webpack_require__("fTIY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_dse__ = __webpack_require__("LAIC");



/* views */


/* dse speciale */


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [
  /*
  {
    path: '/test',
    name: 'test-view',
    component: views.test
  },
  {
    path: '/',
    name: 'root-view',
    component: views.root
  },
  {
    path: '/register',
    name: 'register-view',
    component: views.register
  },
  {
    path: '/login',
    name: 'login-view',
    component: views.login
  },
  {
    path: '/profile',
    name: 'profile-view',
    component: views.profile
  },
  {
    path: '/courses',
    name: 'courses-view',
    component: views.courses
  },
  {
    path: '/courses/:id',
    name: 'course-detail-view',
    component: views.coursedetail
  },
  {
    path: '/mycourses',
    name: 'mycourses-view',
    component: views.mycourses
  },
  */
  /* DSE speciale */
  {
    path: '/',
    redirect: "/dse/overview"
  }, {
    path: "/dse",
    redirect: "/dse/overview"
  }, {
    path: '/dse/:module',
    name: 'dse',
    component: __WEBPACK_IMPORTED_MODULE_3__views_dse__["a" /* default */]
  }, {
    path: '/imprint',
    name: 'imprint-view',
    component: __WEBPACK_IMPORTED_MODULE_2__views_index_js__["a" /* imprint */]
  }, {
    path: '/privacy',
    name: 'privacy-view',
    component: __WEBPACK_IMPORTED_MODULE_2__views_index_js__["b" /* privacy */]
  }]
}));

/***/ }),

/***/ "cP6K":
/***/ (function(module, exports) {

module.exports = {"title":"Einloggen","emailPH":"Email","pwdPH":"Passwort","submitTxt":"Einloggen","errMsg":"Deine Anmeldung war nicht erfolgreich","registerHint1":"Noch keinen Account ?","registerHint2":"Hier geht es zur Anmeldung"}

/***/ }),

/***/ "cPUx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  ADMIN: 'admin',
  AUTHOR: 'author',
  TEACHER: 'teacher',
  STUDENT: 'student'
});

/***/ }),

/***/ "dEBs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dP61":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "diA9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  title: 'Meine Kurse',
  searchPH: 'Suche nach Kursnamen',
  noCourses: 'Keine Kurse gefunden'
});

/***/ }),

/***/ "ejFi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__de_js__ = __webpack_require__("hCGg");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "de", function() { return __WEBPACK_IMPORTED_MODULE_0__de_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__en_js__ = __webpack_require__("yaJd");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "en", function() { return __WEBPACK_IMPORTED_MODULE_1__en_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "es", function() { return __WEBPACK_IMPORTED_MODULE_1__en_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "it", function() { return __WEBPACK_IMPORTED_MODULE_1__en_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "pl", function() { return __WEBPACK_IMPORTED_MODULE_1__en_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "nl", function() { return __WEBPACK_IMPORTED_MODULE_1__en_js__["a"]; });







/***/ }),

/***/ "epL0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "erqz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  submenu: 'Submenu:',
  content: 'Content',
  overview: 'Overview',
  longTermSupport: 'Long Term Support',
  skillsAndTalents: 'Skills and Talents',
  yourMap: 'Your Map',
  motivationAndEmotionalIntelligence: 'Motivation and Emotional Intelligence',
  alliancesCompromisesAndResources: 'Alliances, Compromises and Resources',
  skillsToStartABusiness: 'Skills to Start a Business',
  accountingAndFinance: 'Accounting & Finance',
  settingUpYourOwnBusiness: 'Setting up Your Own Business',
  accountingBasics: 'Accounting Basics',
  openingABankAccount: 'Opening a Bank Account',
  businessPlanBasicInformation: 'Business Plan, Basic Information',
  taxes: 'Taxes',
  legalFormsOfEmployment: 'Legal Forms of Employment',
  marketingAndSales: 'Marketing & Sales',
  whatAreMyProducts: 'What are My Products?',
  whoAreMyClients: 'Who are My Clients?',
  communication: 'Communication',
  positioning: 'Positioning',
  sales: 'Sales',
  uniqueSellingPoints: 'Unique Selling Points',
  publicRelations: 'Public Relations',
  introduction: 'Introduction',
  strategy: 'Strategy',
  messagesAndTools: 'Messages and Tools',
  digitalPRAndSMRevolution: 'Digital PR and SM Revolution',
  it: 'IT',
  cloudVSOnPremises: 'Cloud vs. On-Premises',
  email: 'Email',
  onlineMarketing: 'Online Marketing',
  webshop: 'Webshop',
  website: 'Website'
});

/***/ }),

/***/ "exSp":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "fBef":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue_es_components_collapse_collapse__ = __webpack_require__("UePd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue_es_components_collapse_collapse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_bootstrap_vue_es_components_collapse_collapse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_vue_es_directives_toggle_toggle__ = __webpack_require__("nIHM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_vue_es_directives_toggle_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_bootstrap_vue_es_directives_toggle_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__comps_accordion__ = __webpack_require__("IznZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__i18n_courses__ = __webpack_require__("h4v/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__misc_utils_js__ = __webpack_require__("QD4S");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'courses-view',
  data: function data() {
    return {
      cats: {},
      newCourse: {},
      searchInput: '',
      vstate: {}
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])(['note', 'auth']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['isAuthor']), {

    i18n: function i18n() {
      return __WEBPACK_IMPORTED_MODULE_7__i18n_courses__[this.$store.state.profile.lang];
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_8__misc_utils_js__["a" /* default */], {

    toggle: function toggle(cat) {
      this.vstate[cat] = !this.vstate[cat];
    },
    search: function search(courses) {
      var input = this.searchInput;
      if (input === '') return courses;
      var matches = courses.filter(function (course) {
        var re = new RegExp(input, 'i');
        return re.test(course.name);
      });
      return matches;
    },
    countMsg: function countMsg(courses) {
      var count = courses.length;
      return count + ' ' + (count > 1 ? 'Kurse' : 'Kurs');
    },
    noCourses: function noCourses() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.cats).length === 0;
    },

    storeNewCourse: function storeNewCourse() {
      var $store = this.$store,
          newCourse = this.newCourse,
          auth = this.auth,
          fetchCourses = this.fetchCourses;

      $store.commit('setBusy', true);
      /*
       * create course */
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post('courses', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, newCourse, {
        authorId: auth.userId
      })).then(function (_ref) {
        var data = _ref.data;

        fetchCourses();
      }).catch(function (err) {
        console.log(err);
      }).then(function () {
        return $store.commit('setBusy', false);
      });
      /*
       * create storage */
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post('storage', {
        name: newCourse.name
      }).then(function () {
        return console.log('New Storage: ' + newCourse.name);
      }).catch(function (err) {
        return console.error(err);
      });
    },

    delCourse: function delCourse(name) {
      var $store = this.$store,
          fetchCourses = this.fetchCourses;

      $store.commit('setBusy', true);
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.delete('courses/' + name).then(fetchCourses).catch(function (err) {
        return console.error(err);
      }).then(function () {
        $store.commit('setBusy', false);
      });
    },

    fetchCourses: function fetchCourses() {
      var ctx = this;
      ctx.$store.commit('setBusy', true);
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get('courses?filter[include]=author').then(function (_ref2) {
        var data = _ref2.data;

        /*
         * categorize courses */
        var cats = {};
        data.forEach(function (course) {
          var cat = cats[course.category];
          if (!cat) {
            cats[course.category] = [];
          }
          cats[course.category].push(course);
        });
        ctx.cats = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, cats);
      }).catch(function (err) {
        return console.error(err);
      }).then(function () {
        return ctx.$store.commit('setBusy', false);
      });
    }
  }),
  mounted: function mounted() {
    document.querySelector('#search-bar').focus();
    this.fetchCourses();
  },

  components: {
    lyAccordion: __WEBPACK_IMPORTED_MODULE_5__comps_accordion__["a" /* default */], bCollapse: __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue_es_components_collapse_collapse___default.a, vBToggle: __WEBPACK_IMPORTED_MODULE_4_bootstrap_vue_es_directives_toggle_toggle___default.a
  }
});

/***/ }),

/***/ "fQiR":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMjgiIGhlaWdodD0iMTI4IiB2ZXJzaW9uPSIxIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGZpbGw9IiMyOTgwYjkiIGQ9Ik0wIDBoMTI4djEyOEgweiIvPjxwYXRoIGZpbGw9InVuZGVmaW5lZCIgZD0iTTEyOCAwdjEyOEgwTDEyOCAweiIvPjx0ZXh0IGZpbGw9IiNGRkZGRkYiIGZvbnQtZmFtaWx5PSJBcmlhbCIgZm9udC1zaXplPSI2NCI+PHRzcGFuIHg9IjI0IiB5PSI4NSI+UEw8L3RzcGFuPjwvdGV4dD48L2c+PC9zdmc+Cg=="

/***/ }),

/***/ "fTIY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__test_vue__ = __webpack_require__("BERp");
/* unused harmony reexport test */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_vue__ = __webpack_require__("UO8k");
/* unused harmony reexport root */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__register_vue__ = __webpack_require__("c2lw");
/* unused harmony reexport register */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__login_vue__ = __webpack_require__("Quw4");
/* unused harmony reexport login */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__courses_vue__ = __webpack_require__("bL42");
/* unused harmony reexport courses */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mycourses_vue__ = __webpack_require__("FFAd");
/* unused harmony reexport mycourses */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__course_detail_vue__ = __webpack_require__("3uio");
/* unused harmony reexport coursedetail */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__profile_vue__ = __webpack_require__("Lr6B");
/* unused harmony reexport profile */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__imprint_vue__ = __webpack_require__("xyRd");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_8__imprint_vue__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__privacy_vue__ = __webpack_require__("vudA");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_9__privacy_vue__["a"]; });











/***/ }),

/***/ "flDJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_input_img_vue__ = __webpack_require__("2i4H");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f2a6dec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_input_img_vue__ = __webpack_require__("M9YT");
function injectStyle (ssrContext) {
  __webpack_require__("+sJJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3f2a6dec"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_input_img_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f2a6dec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_input_img_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gbyy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  title: 'Anmeldung',

  namePH: 'Name',
  nameTaken: 'Dieser Name ist bereits vergeben',
  nameErr: 'Dein Name darf nur aus Buchstaben und Zahlen bestehen',

  emailPH: 'Email',
  emailTaken: 'Diese Email ist bereits vergeben',
  emailErr: 'Diese Email ist ungültig',

  pwd1PH: 'Passwort',
  pwd2PH: 'Passwort wiederholen',
  pwdErr: 'Die Passwörter müssen übereinstimmen',

  profilePic: 'Foto',

  formErr: 'Bitte korrigiere zuerst Deine Eingaben',
  submit: 'Speichern',
  busy: 'Bitte Warten',
  success: 'Deine Anmeldung war erfolgreich! Hier gehts weiter zum Login',
  fail: 'Da ist etwas schiefgelaufen - bitte versuch es später nochmal'
});

/***/ }),

/***/ "gcd3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"ly-media-selector",attrs:{"novalidate":"","role":"form","aria-label":"Darstellungsauswahl"}},[_c('div',{staticClass:"d-flex justify-content-between"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.profile.prefs.media.simple),expression:"profile.prefs.media.simple"}],class:{active: _vm.profile.prefs.media.simple},staticStyle:{"margin-right":"5px"},attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.profile.prefs.media.simple)?_vm._i(_vm.profile.prefs.media.simple,null)>-1:(_vm.profile.prefs.media.simple)},on:{"click":function($event){return _vm.toggleMedia('simple')},"change":function($event){var $$a=_vm.profile.prefs.media.simple,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.profile.prefs.media, "simple", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.profile.prefs.media, "simple", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.profile.prefs.media, "simple", $$c)}}}}),_vm._v(" "),_c('ly-simple-icon'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.i18n.easyLanguage))])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "h4v/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__de_js__ = __webpack_require__("diA9");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "de", function() { return __WEBPACK_IMPORTED_MODULE_0__de_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__en_js__ = __webpack_require__("BXiF");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "en", function() { return __WEBPACK_IMPORTED_MODULE_1__en_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "es", function() { return __WEBPACK_IMPORTED_MODULE_1__en_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "it", function() { return __WEBPACK_IMPORTED_MODULE_1__en_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "pl", function() { return __WEBPACK_IMPORTED_MODULE_1__en_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "nl", function() { return __WEBPACK_IMPORTED_MODULE_1__en_js__["a"]; });







/***/ }),

/***/ "hCGg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  courses: 'Kurse',
  myCourses: 'Meine Kurse',
  register: 'Registrieren',
  profile: 'Profil',
  login: 'Einloggen',
  logout: 'Ausloggen'
});

/***/ }),

/***/ "hX1X":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iZV8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iogu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  easyLanguage: 'Gemakkelijke taal',
  videoDoesNotYetExist: 'Video bestaat nog niet'
});

/***/ }),

/***/ "j2go":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__comps_input_img__ = __webpack_require__("flDJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__i18n_profile__ = __webpack_require__("sWnG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__backendURL_js__ = __webpack_require__("ksDr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'profile-view',
  data: function data() {
    return {
      avatar: null,
      oldPwd: '',
      newPwd: '',
      pwdMsg: '',
      formMsg: '',
      busy: false,

      prefs: {}
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])(['profile']), {

    msg: function msg() {
      return __WEBPACK_IMPORTED_MODULE_3__i18n_profile__[this.profile.lang];
    },

    avatarURL: function avatarURL() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__backendURL_js__["a" /* default */])() + '/storage/img/download/' + this.avatar;
    }
  }),
  created: function created() {
    this.avatar = this.profile.avatar;
    this.prefs = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.profile.prefs);
  },

  methods: {
    submit: function submit() {
      this.busy = true;
      var ctx = this;
      ctx.formMsg = '';

      var requests = [];

      /* change password request */
      if (ctx.oldPwd !== '' && ctx.newPwd !== '') {
        requests.push(__WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('accounts/change-password', {
          oldPassword: ctx.oldPwd,
          newPassword: ctx.newPwd
        }).catch(function (err) {
          console.error(err);
          ctx.pwdMsg = ctx.msg.pwdFail;
        }));
      }

      /* fire requests */
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.all(requests).then(__WEBPACK_IMPORTED_MODULE_2_axios___default.a.spread(function () {
        ctx.formMsg = ctx.msg.submitOk;
      })).catch(function (err) {
        console.log(err);
        // ctx.formMsg = ctx.msg.submitFail
      }).then(function () {
        ctx.busy = false;
        setTimeout(function () {
          ctx.formMsg = '';
        }, 2000);
      });

      /* update state */
      ctx.$store.commit('setPrefs', ctx.prefs);
    },
    onProfileImg: function onProfileImg(img) {
      if (!img) return;
    }
  },
  components: {
    lyInputImg: __WEBPACK_IMPORTED_MODULE_1__comps_input_img__["a" /* default */]
  }
});

/***/ }),

/***/ "jOuJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_quiz_choice_vue__ = __webpack_require__("BxaP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2da6301a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_quiz_choice_vue__ = __webpack_require__("bRiP");
function injectStyle (ssrContext) {
  __webpack_require__("xd2/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2da6301a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_quiz_choice_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2da6301a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_quiz_choice_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kiA1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kraY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ksDr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// IMPORTANT:
// Currently DSE needs no LAYA API backend.
// For video URLs the same AWS S3 bucket is used as for the DSE webapp (see awsURL.js)
/* harmony default export */ __webpack_exports__["a"] = (function () {
  return (/localhost/.test(location.host) ? 'https://CURRENTLY-NO-LAYA-BACKEND-IS-USED-FOR-DSE' : 'https://CURRENTLY-NO-LAYA-BACKEND-IS-USED-FOR-DSE'
  );
});

/***/ }),

/***/ "mVMy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  submenu: 'Untermenü:',
  content: 'Inhalt',
  overview: 'Übersicht',
  longTermSupport: 'Langzeitunterstützung',
  skillsAndTalents: 'Fähigkeiten und Talente',
  yourMap: 'Ihre Karte',
  motivationAndEmotionalIntelligence: 'Motivation und emotionale Intelligenz',
  alliancesCompromisesAndResources: 'Allianzen, Kompromisse und Ressourcen',
  skillsToStartABusiness: 'Fähigkeiten, um ein Unternehmen zu gründen',
  accountingAndFinance: 'Kontoführung und Finanzen',
  settingUpYourOwnBusiness: 'Ein eigenes Unternehmen gründen',
  accountingBasics: 'Grundlagen der Rechnungslegung',
  openingABankAccount: 'Eröffnung eines Bankkontos',
  businessPlanBasicInformation: 'Business Plan, Grundinformationen',
  taxes: 'Steuern',
  legalFormsOfEmployment: 'Rechtsformen der Beschäftigung',
  marketingAndSales: 'Marketing & Vertrieb',
  whatAreMyProducts: 'Welche Produkte möchte ich anbieten?',
  whoAreMyClients: 'Wer sind meine Kunden?',
  communication: 'Kommunikation',
  positioning: 'Positionierung',
  sales: 'Vertrieb',
  uniqueSellingPoints: 'Alleinstellungsmerkmale',
  publicRelations: 'Öffentlichkeitsarbeit',
  introduction: 'Einführung',
  strategy: 'Strategie',
  messagesAndTools: 'Nachrichten und Werkzeuge',
  digitalPRAndSMRevolution: 'Digitale PR and SM Revolution',
  it: 'IT',
  cloudVSOnPremises: 'Cloud vs. On-Premises',
  email: 'E-Mail',
  onlineMarketing: 'Online Marketing',
  webshop: 'Webshop',
  website: 'Webseite'
});

/***/ }),

/***/ "n8K7":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+Cjxzdmcgd2lkdGg9IjI1cHgiIGhlaWdodD0iMjZweCIgdmlld0JveD0iMCAwIDI1IDI2IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCAzLjcuMiAoMjgyNzYpIC0gaHR0cDovL3d3dy5ib2hlbWlhbmNvZGluZy5jb20vc2tldGNoIC0tPgogICAgPHRpdGxlPmZlcnRpZzwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxkZWZzPjwvZGVmcz4KICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJmZXJ0aWciIGZpbGw9IiMxRDFDMUIiPgogICAgICAgICAgICA8cG9seWdvbiBpZD0iUGFnZS0xIiBwb2ludHM9IjIwLjkzNjczMzIgLTAuMDAwMSA5LjAxMzczMzE4IDE3Ljg0ODkgMy41NDM3MzMxOCAxMS4zMjU5IDAuMTcxNzMzMTc1IDE0LjE1MTkgOS40MTI3MzMxOCAyNS4xNzE5IDI0LjU5NDczMzIgMi40NDM5Ij48L3BvbHlnb24+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4="

/***/ }),

/***/ "nmo2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  laya: 'Die digitale Lernplattform zum inklusiven Lernen',
  imprint: 'Impressum',
  privacy: 'Datenschutz'
});

/***/ }),

/***/ "oYty":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ly-simple-icon'
});

/***/ }),

/***/ "pTqu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ly-flex-center',
  components: {}
});

/***/ }),

/***/ "pc4X":
/***/ (function(module, exports) {

module.exports = {"title":"Login","emailPH":"Email","pwdPH":"Password","submitTxt":"Login","busyTxt":"Please Wait...","errMsg":"The login failed - please check your inputs","registerHint1":"Don't have an account yet ?","registerHint2":"Register here"}

/***/ }),

/***/ "qTjK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qb6w":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "quEe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_video_wrapper_vue__ = __webpack_require__("AyZG");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67e79f1d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_video_wrapper_vue__ = __webpack_require__("Mew9");
function injectStyle (ssrContext) {
  __webpack_require__("wjw9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-67e79f1d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_video_wrapper_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67e79f1d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_video_wrapper_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rHpT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fieldset',{staticClass:"ly-quiz-schoice"},[_c('legend',{attrs:{"tabindex":"0"}},[_vm._v(_vm._s(_vm.task))]),_vm._v(" "),_c('div',{staticClass:"p-3 bg-light"},_vm._l((_vm.options),function(option,i){return _c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.answer),expression:"answer"}],staticClass:"form-check-input",attrs:{"type":"radio","disabled":_vm.freeze},domProps:{"value":i,"checked":_vm._q(_vm.answer,i)},on:{"change":function($event){_vm.answer=i}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(option))])])])}),0),_vm._v(" "),(_vm.maxTries > 0)?_c('div',{staticClass:"text-secondary my-2",attrs:{"tabindex":"0"}},[_c('span',[_vm._v("Versuche übrig:")]),_vm._v("\n    "+_vm._s(_vm.maxTries-_vm.tries)+"\n  ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":_vm.freeze},on:{"click":_vm.check}},[_c('i',{staticClass:"fas fa-check"}),_vm._v(" "),(_vm.profile.lang === 'de')?_c('span',[_vm._v("Prüfen")]):_c('span',[_vm._v("Check")])]),_vm._v(" "),_c('span',{staticClass:"ml-2",attrs:{"id":_vm.feedbackId,"aria-live":"polite"}},[_vm._v(_vm._s(_vm.feedback))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rtHv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rwV4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sWnG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__de_js__ = __webpack_require__("Y2pJ");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "de", function() { return __WEBPACK_IMPORTED_MODULE_0__de_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__en_js__ = __webpack_require__("PftW");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "en", function() { return __WEBPACK_IMPORTED_MODULE_1__en_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "es", function() { return __WEBPACK_IMPORTED_MODULE_1__en_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "it", function() { return __WEBPACK_IMPORTED_MODULE_1__en_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "pl", function() { return __WEBPACK_IMPORTED_MODULE_1__en_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "nl", function() { return __WEBPACK_IMPORTED_MODULE_1__en_js__["a"]; });







/***/ }),

/***/ "sknz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__de_js__ = __webpack_require__("Fbqb");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "de", function() { return __WEBPACK_IMPORTED_MODULE_0__de_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__en_js__ = __webpack_require__("P+mf");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "en", function() { return __WEBPACK_IMPORTED_MODULE_1__en_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__es_js__ = __webpack_require__("+8M5");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "es", function() { return __WEBPACK_IMPORTED_MODULE_2__es_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__it_js__ = __webpack_require__("VXS7");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "it", function() { return __WEBPACK_IMPORTED_MODULE_3__it_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pl_js__ = __webpack_require__("O35T");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "pl", function() { return __WEBPACK_IMPORTED_MODULE_4__pl_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__nl_js__ = __webpack_require__("iogu");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "nl", function() { return __WEBPACK_IMPORTED_MODULE_5__nl_js__["a"]; });







/***/ }),

/***/ "so+g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "t197":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);

//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ly-busy-note',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])(['note']))
});

/***/ }),

/***/ "t7Gr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{attrs:{"id":"ly-footer"}},[_c('div',{staticClass:"container",staticStyle:{"border-top":"0.2rem solid black","padding-top":"1rem"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-lg-12"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_vm._m(1),_vm._v(" "),_c('p',[_c('b',[_vm._v(_vm._s(_vm.i18n.laya))])])]),_vm._v(" "),_vm._m(2)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('a',{attrs:{"href":"#/imprint"}},[_c('u',{staticClass:"text-dark"},[_vm._v(_vm._s(_vm.i18n.imprint))])]),_vm._v(" "),_c('span',[_vm._v("/")]),_vm._v(" "),_c('a',{attrs:{"href":"#/privacy"}},[_c('u',{staticClass:"text-dark"},[_vm._v(_vm._s(_vm.i18n.privacy))])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row no-gutters"},[_c('div',{staticClass:"col",staticStyle:{"padding-bottom":"1rem"}},[_c('a',{staticClass:"social-link",attrs:{"href":"https://www.facebook.com/projectDSE/","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__("3EWg"),"alt":"Facebook Link"}})])]),_vm._v(" "),_c('div',{staticClass:"row justify-content-end",staticStyle:{"padding-bottom":"1rem"}},[_c('div',{staticClass:"col-4"},[_c('a',{attrs:{"href":"https://www.erasmusplus.de/","target":"_blank"}},[_c('img',{staticClass:"w-100",attrs:{"src":__webpack_require__("XLNN"),"alt":"Logo von Erasmus Plus"}})])]),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('a',{attrs:{"href":"https://www.erasmusplus.de/","target":"_blank"}},[_c('img',{staticClass:"w-100",attrs:{"src":__webpack_require__("xJ8C"),"alt":"Logo von Erasmus Plus Erwachsenenbildung"}})])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('b',[_vm._v("LAYA")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col"},[_c('a',{attrs:{"rel":"license","href":"http://creativecommons.org/licenses/by-nc-sa/4.0/","target":"_blank"}},[_c('img',{staticStyle:{"border-width":"0"},attrs:{"alt":"Creative Commons Lizenzvertrag","src":"https://i.creativecommons.org/l/by-nc-sa/4.0/80x15.png"}})]),_c('br'),_c('span',{staticStyle:{"font-size":"small"}},[_vm._v("Dieses Werk ist lizenziert unter einer "),_c('a',{attrs:{"rel":"license","href":"http://creativecommons.org/licenses/by-nc-sa/4.0/","target":"_blank"}},[_vm._v("\n            Creative Commons Namensnennung - Nicht-kommerziell - Weitergabe unter gleichen Bedingungen 4.0 International Lizenz")]),_vm._v(".")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "t8ey":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ly-accordion',
  props: {
    data: Array
  }
});

/***/ }),

/***/ "tY2k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"imprint-view"},[_c('div',{staticClass:"container mt-3"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('h1',[_c('b',[_vm._v("Impressum")])]),_vm._v(" "),_c('div',{staticStyle:{"height":"1rem"}}),_vm._v(" "),_c('p',[_c('b',[_vm._v("KOPF, HAND + FUSS gemeinnützige Gesellschaft für Bildung mbH")]),_vm._v(" "),_c('br'),_vm._v("\n          Unsere Büros:"),_c('br'),_vm._v("\n          Hauptsitz: c/o TUECHTIG - Raum für Inklusion,\n          Oudenarder Str. 16, 13347 Berlin"),_c('br'),_vm._v("\n          Zweigstelle: Ludwigkirchstr. 2, 10719 Berlin"),_c('br')]),_vm._v(" "),_c('p',[_vm._v("\n          Tel: 030 / 8 321 66 40 Fax: 030 / 8 321 66 41"),_c('br'),_vm._v("\n          E-Mail:\n          "),_c('a',{attrs:{"href":"mailto:info@kopfhandundfuss.de"}},[_c('u',{staticClass:"text-dark"},[_vm._v("info[at]kopfhandundfuss.de")])]),_vm._v(" "),_c('br'),_vm._v("\n          Internet:\n          "),_c('a',{attrs:{"href":"https://www.kopfhandundfuss.de"}},[_c('u',{staticClass:"text-dark"},[_vm._v("https://www.kopfhandundfuss.de")])])]),_vm._v(" "),_c('p',[_vm._v("Geschäftsführerin: Stefanie Trzecinski")]),_vm._v(" "),_c('p',[_vm._v("\n          Handelsregister Amtsgericht Berlin (Charlottenburg) HR B 128577 B"),_c('br'),_vm._v("\n          Steuernummer: 27/613/02219"),_c('br'),_vm._v("\n          Inhaltlich Verantwortliche gemäß § 55 Abs. 2 RStV (V.i.S.d.M.):\n          Stefanie Trzecinski (Anschrift wie oben)\n        ")]),_vm._v(" "),_c('h3',{staticStyle:{"margin-top":"2em"}},[_c('b',[_vm._v("EU-Disclaimer:")])]),_vm._v(" "),_c('p',[_vm._v("\n          Die Unterstützung der Europäischen Kommission für die Erstellung dieser Veröffentlichung stellt keine\n          Billigung des Inhalts dar, welcher nur die Ansichten der Verfasser wiedergibt, und die Kommission kann\n          nicht für eine etwaige Verwendung der darin enthaltenen Informationen haftbar gemacht werden.\n        ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',{staticStyle:{"margin-top":"1em"}},[_c('b',[_vm._v("Rechtliche Hinweise")])]),_vm._v(" "),_c('p',[_c('b',[_vm._v("1. Haftungsbeschränkung")]),_c('br'),_vm._v("\n          Die Inhalte dieser Website werden mit größtmöglicher Sorgfalt erstellt. Die KOPF, HAND + FUSS gGmbH\n          übernimmt jedoch keine Gewähr für die Richtigkeit, Vollständigkeit und Aktualität der bereitgestellten\n          Inhalte. Die Nutzung der Inhalte der Website erfolgt auf eigene Gefahr des Nutzers. Namentlich\n          gekennzeichnete Beiträge geben die Meinung des jeweiligen Autors und nicht immer die Meinung der\n          KOPF, HAND + FUSS gGmbH wieder. Mit der reinen Nutzung der Website der KOPF, HAND + FUSS gGmbH kommt\n          keinerlei Vertragsverhältnis zwischen dem Nutzer und der KOPF, HAND + FUSS gGmbH zustande.\n        ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("2. Externe Links")]),_c('br'),_vm._v("\n          Diese Website enthält Verknüpfungen zu Websites Dritter (\"externe Links\"). Diese Websites unterliegen der\n          Haftung der jeweiligen Betreiber. Die KOPF, HAND + FUSS gGmbH hat bei der erstmaligen Verknüpfung der\n          externen Links die fremden Inhalte daraufhin überprüft, ob etwaige Rechtsverstöße bestehen. Zu dem\n          Zeitpunkt waren keine Rechtsverstöße ersichtlich. Die KOPF, HAND + FUSS gGmbH hat keinerlei Einfluss auf\n          die aktuelle und zukünftige Gestaltung und auf die Inhalte der verknüpften Seiten. Das Setzen von externen\n          Links bedeutet nicht, dass sich die KOPF, HAND + FUSS gGmbH die hinter dem Verweis oder Link liegenden\n          Inhalte zu Eigen macht. Eine ständige Kontrolle der externen Links ist für die KOPF, HAND + FUSS gGmbH ohne\n          konkrete Hinweise auf Rechtsverstöße nicht zumutbar. Bei Kenntnis von Rechtsverstößen werden jedoch\n          derartige externe Links unverzüglich gelöscht.\n        ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("3. Urheber- und Leistungsschutzrechte")]),_c('br'),_vm._v("\n          Die auf dieser Website veröffentlichten Inhalte unterliegen dem deutschen Urheber- und Leistungsschutzrecht.\n          Jede vom deutschen Urheber- und Leistungsschutzrecht nicht zugelassene Verwertung bedarf der vorherigen\n          schriftlichen Zustimmung der KOPF, HAND + FUSS gGmbH oder des jeweiligen Rechteinhabers. Dies gilt\n          insbesondere für Vervielfältigung, Bearbeitung, Übersetzung, Einspeicherung, Verarbeitung bzw. Wiedergabe\n          von Inhalten in Datenbanken oder anderen elektronischen Medien und Systemen. Inhalte und Rechte Dritter sind\n          dabei als solche gekennzeichnet. Die unerlaubte Vervielfältigung oder Weitergabe einzelner Inhalte oder\n          kompletter Seiten ist nicht gestattet und strafbar. Lediglich die Herstellung von Kopien und Downloads für\n          den persönlichen, privaten und nicht kommerziellen Gebrauch ist erlaubt.\n        ")]),_vm._v(" "),_c('p',[_vm._v("Die Darstellung dieser Website in fremden Frames ist nur mit schriftlicher Erlaubnis zulässig.")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("4. Datenschutz")]),_c('br'),_vm._v("\n          \"Diese Website benutzt Google Analytics, einen Webanalysedienst der Google Inc. (\"Google\"). Google Analytics\n          verwendet sog. \"Cookies\", Textdateien, die auf Ihrem Computer gespeichert werden und die eine Analyse der\n          Benutzung der Website durch Sie ermöglicht. Die durch den Cookie erzeugten Informationen über Ihre Benutzung\n          diese Website (einschließlich Ihrer IP-Adresse) wird an einen Server von Google in den USA übertragen und\n          dort gespeichert. Google wird diese Informationen benutzen, um Ihre Nutzung der Website auszuwerten, um\n          Reports über die Websiteaktivitäten für die Websitebetreiber zusammenzustellen und um weitere mit der\n          Websitenutzung und der Internetnutzung verbundene Dienstleistungen zu erbringen. Auch wird Google diese\n          Informationen gegebenenfalls an Dritte übertragen, sofern dies gesetzlich vorgeschrieben oder soweit Dritte\n          diese Daten im Auftrag von Google verarbeiten. Google wird in keinem Fall Ihre IP-Adresse mit anderen Daten\n          der Google in Verbindung bringen. Sie können die Installation der Cookies durch eine entsprechende\n          Einstellung Ihrer Browser Software verhindern; wir weisen Sie jedoch darauf hin, dass Sie in diesem Fall\n          gegebenenfalls nicht sämtliche Funktionen dieser Website voll umfänglich nutzen können. Durch die Nutzung\n          dieser Website erklären Sie sich mit der Bearbeitung der über Sie erhobenen Daten durch Google in der zuvor\n          beschriebenen Art und Weise und zu dem zuvor benannten Zweck einverstanden.\" Die KOPF, HAND + FUSS gGmbH\n          weist ausdrücklich darauf hin, dass die Datenübertragung im Internet (z.B. bei der Kommunikation per E-Mail)\n          Sicherheitslücken aufweisen und nicht lückenlos vor dem Zugriff durch Dritte geschützt werden kann.\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          Die Verwendung der Kontaktdaten des Impressums zur gewerblichen Werbung ist ausdrücklich nicht erwünscht,\n          es sei denn die KOPF, HAND + FUSS gGmbH hatte zuvor seine schriftliche Einwilligung erteilt oder es besteht\n          bereits eine Geschäftsbeziehung. Die KOPF, HAND + FUSS gGmbH und alle auf dieser Website genannten Personen\n          widersprechen hiermit jeder kommerziellen Verwendung und Weitergabe ihrer Daten.\n        ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("5. Besondere Nutzungsbedingungen")]),_c('br'),_vm._v("\n          Soweit besondere Bedingungen für einzelne Nutzungen dieser Website von den vorgenannten Nummern 1. bis 4.\n          abweichen, wird an entsprechender Stelle ausdrücklich darauf hingewiesen. In diesem Falle gelten im\n          jeweiligen Einzelfall die besonderen Nutzungsbedingungen.\n        ")]),_vm._v(" "),_c('p',[_c('i',[_vm._v("Quelle:")]),_vm._v(" Disclaimer von\n          "),_c('a',{attrs:{"href":"www.Juraforum.de"}},[_c('u',{staticClass:"text-dark"},[_vm._v("www.Juraforum.de")])]),_vm._v(" - Rechtsportal.\n        ")]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"3em"}},[_c('b',[_vm._v("Entwicklung dieser Seite")]),_c('br'),_vm._v("\n          Diese Seite wird in Kooperation mit dem\n          "),_c('a',{attrs:{"href":"https://cses.informatik.hu-berlin.de"}},[_c('u',{staticClass:"text-dark"},[_vm._v("Institut für Didaktik in der Informatik")])]),_vm._v("\n          an der Humboldt-Universität zu Berlin entwickelt.\n        ")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tdMd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.note.busy),expression:"note.busy"}],staticClass:"ly-busy-note"},[_c('i',{staticClass:"fas fa-spinner fa-spin"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tgcj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"ly-header"}},[_c('nav',{staticClass:"navbar sticky-top navbar-expand-sm navbar-dark"},[_c('router-link',{staticClass:"navbar-brand",attrs:{"to":"/"}},[_c('img',{staticStyle:{"width":"4rem"},attrs:{"src":__webpack_require__("+riO"),"alt":"Laya - Learn as you are"}})]),_vm._v(" "),_c('busy-note',{staticClass:"text-white position-absolute",staticStyle:{"font-size":"2rem","left":"50%"}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse flex-wrap mt-sm-3 mt-md-0",attrs:{"id":"nav-collapse"}},[_c('ul',{staticClass:"navbar-nav ml-auto"},[_c('nav-item-dd',{attrs:{"no-caret":"","right":""}},[_c('img',{staticClass:"lang-icon",attrs:{"slot":"button-content","src":_vm.icons[_vm.profile.lang]},slot:"button-content"}),_vm._v(" "),_vm._l((_vm.icons),function(svg,lang){return _c('nav-item-dd-btn',{key:lang,on:{"click":function($event){return _vm.setLang(lang)}}},[_c('img',{staticClass:"lang-icon lang-icon-list",attrs:{"src":svg,"alt":lang}})])})],2)],1)])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"navbar-toggler",attrs:{"type":"button","data-toggle":"collapse","data-target":"#nav-collapse","aria-controls":"nav-collapse","aria-extended":"false","aria-label":"Navigation schalten"}},[_c('span',{staticClass:"navbar-toggler-icon"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "u77a":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uSsV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "unXG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__comps_btn__ = __webpack_require__("FP6n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__comps_input__ = __webpack_require__("xzCB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__i18n_login__ = __webpack_require__("NwLz");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'login-view',
  mounted: function mounted() {
    document.querySelector('#email-input').focus();
  },
  data: function data() {
    return {

      /* form */
      email: '',
      pwd: '',

      /* temp */
      busy: false,
      errMsg: '',
      submitFailed: false
    };
  },

  computed: {

    i18n: function i18n() {
      return __WEBPACK_IMPORTED_MODULE_3__i18n_login__[this.$store.state.profile.lang];
    },

    errEmail: function errEmail() {
      return this.email.length === 0;
    },

    errPwd: function errPwd() {
      return this.pwd.length === 0;
    },

    errForm: function errForm() {
      return this.errEmail || this.errPwd;
    }
  },
  methods: {
    submit: function submit() {
      if (this.errForm || this.busy) {
        console.log('Not Submitting');
        return;
      }

      console.log('Submitting...');
      this.busy = true;
      var ctx = this;

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('accounts/login', {
        email: ctx.email,
        password: ctx.pwd
      }).then(function (_ref) {
        var data = _ref.data;

        /*
         * set login state */
        ctx.$store.commit('login', data);

        /* load profile */
        ctx.$store.dispatch('fetchProfile');
        ctx.$store.dispatch('fetchRole');

        /* store auth for reloads */
        var id = data.id,
            userId = data.userId,
            created = data.created,
            ttl = data.ttl;

        var expire = new Date(created);
        expire.setSeconds(expire.getSeconds() + ttl);
        console.log('Auth expires on', expire);
        ctx.$ls.set('auth', { 'id': id, 'userId': userId }, expire.getTime());

        /* move to view */
        ctx.$router.push('/mycourses');
      }).catch(function (err) {
        console.log(err);
        ctx.submitFailed = true;
        ctx.errMsg = ctx.i18n.errMsg;
      }).then(function () {
        ctx.busy = false;
      });
    }
  },
  components: {
    lyBtn: __WEBPACK_IMPORTED_MODULE_0__comps_btn__["a" /* default */], lyInput: __WEBPACK_IMPORTED_MODULE_1__comps_input__["a" /* default */]
  }
});

/***/ }),

/***/ "v0mw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.note.busy)?_c('div',[_c('div',{staticClass:"nav-padding bg-dark"},[_c('h1',{staticClass:"text-center text-light"},[_c('b',[_vm._v(_vm._s(_vm.course.name))])]),_vm._v(" "),_c('h6',{staticClass:"text-center text-light"},[_c('u',[_vm._v(_vm._s(_vm.course.category))]),_vm._v(" "),_c('span',[_vm._v("/")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.course.author.username))])])]),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('div',{staticStyle:{"height":"1rem"}}),_vm._v(" "),_c('h5',{attrs:{"role":"navigation"}},[_c('a',{staticClass:"text-dark",attrs:{"href":'#'+_vm.backUrl,"tabindex":"0"}},[_c('u',[_c('i',{staticClass:"fas fa-angle-left"}),_vm._v(" zurück zu\n              "+_vm._s(/my/.test(_vm.backUrl) ? 'meinen Kursen' : 'allen Kursen')+"\n            ")])])]),_vm._v(" "),_c('div',{staticStyle:{"height":"1rem"}}),_vm._v(" "),_c('div',{staticClass:"course-meta d-flex justify-content-between pt-2"},[_c('div',[(_vm.course.locked)?_c('span',{staticClass:"mr-2"},[_c('i',{staticClass:"fas fa-lock fa-lg"})]):_vm._e(),_vm._v(" "),(_vm.course.endDate)?_c('span',[_c('i',{staticClass:"fas fa-stopwatch fa-lg"})]):_vm._e(),_vm._v(" "),(_vm.course.endDate)?_c('div',{staticClass:"mt-3"},[_vm._v("\n              "+_vm._s(_vm.shortDate(_vm.course.startDate))+" —"),_c('br'),_vm._v("\n              "+_vm._s(_vm.shortDate(_vm.course.endDate))+"\n            ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"text-right"},[_c('span',[_vm._v(_vm._s(_vm.locDate(_vm.course.createDate)))]),_vm._v(" "),(_vm.userEnrolled)?_c('a',{staticClass:"d-block mt-2 text-dark",attrs:{"href":""},on:{"click":function($event){$event.preventDefault();return _vm.unsubscribe($event)}}},[_c('i',{staticClass:"fas fa-exclamation-circle"}),_vm._v(" "),_c('u',[_vm._v("Abmelden")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticStyle:{"height":"3rem"}}),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.course.abstract))]),_vm._v(" "),_c('div',{staticStyle:{"height":"3rem"}}),_vm._v(" "),(!_vm.userEnrolled)?_c('button',{staticClass:"btn btn-lg btn-block btn-outline-dark subscribe-btn",attrs:{"type":"button"},on:{"click":_vm.subscribe}},[_vm._v("\n          Für diesen Kurs anmelden "),_c('i',{staticClass:"fas fa-arrow-right"})]):_vm._e()])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.userEnrolled || _vm.isAuthor),expression:"userEnrolled || isAuthor"}],staticClass:"ly-bg-grey"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col py-5"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.empty(_vm.contents)),expression:"empty(contents)"}],staticClass:"py-4"},[_vm._m(0)]),_vm._v(" "),_vm._l((_vm.contents),function(content,cat){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.empty(content)),expression:"!empty(content)"}],staticClass:"catHeader",attrs:{"role":"tablist"}},[_c('h4',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:(cat),expression:"cat"}],key:cat,staticClass:"d-flex justify-content-between align-item-center\n              my-3",attrs:{"tabindex":"0"},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.toggle(cat)}}},[_vm._m(1,true),_vm._v(" "),_c('u',{staticClass:"click",staticStyle:{"flex":"2"}},[_c('b',[_vm._v(_vm._s(cat))])]),_vm._v(" "),_c('div',{staticClass:"w-25 text-right click"},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.vstate[cat]),expression:"!vstate[cat]"}],staticClass:"fas fa-plus"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.vstate[cat]),expression:"vstate[cat]"}],staticClass:"fas fa-minus"})])]),_vm._v(" "),_c('b-collapse',{key:cat+'-C',attrs:{"id":cat,"role":"tabpanel"},model:{value:(_vm.vstate[cat]),callback:function ($$v) {_vm.$set(_vm.vstate, cat, $$v)},expression:"vstate[cat]"}},[_vm._l((content.topics),function(topic,i){return _c('div',{key:cat+topic.name+i},[_c('div',{staticClass:"d-flex flex-wrap align-items-center pb-2"},[_c('div',{staticStyle:{"width":"10%"}},[_c('i',{staticClass:"fas fa-circle fa-xs"}),_vm._v(" "),_c('i',{staticClass:"fas fa-circle fa-xs"})]),_vm._v(" "),_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:(cat+'_topic_'+i),expression:"cat+'_topic_'+i"}],staticClass:"topic-button",attrs:{"type":"button"}},[_c('u',[_vm._v(_vm._s(topic.name))])]),_vm._v(" "),_c('div',{staticClass:"w-25 d-inline-flex\n                    flex-column justify-content-between align-items-end"},[(_vm.isAuthor)?_c('button',{staticClass:"btn btn-sm btn-danger ly-del-btn",staticStyle:{"font-size":"0.75em"},attrs:{"tabindex":"-1"},on:{"click":function($event){return _vm.delContent(topic.id, i, cat, 'topics')}}},[_c('i',{staticClass:"fas fa-exclamation-triangle"}),_vm._v(" "),_c('span',[_vm._v("Löschen")])]):_vm._e()]),_vm._v(" "),_c('b-collapse',{key:cat+'_topic_'+i,staticClass:"topic-content mt-2",attrs:{"id":cat+'_topic_'+i,"role":"tabpanel"}})],1)])}),_vm._v(" "),_vm._l((content.quizzes),function(quiz,i){return _c('div',{key:cat+quiz.name+i},[_c('div',{staticClass:"d-flex flex-wrap align-items-center pb-2"},[_c('div',{staticStyle:{"width":"10%"}},[_c('i',{staticClass:"fas fa-pencil-alt"})]),_vm._v(" "),_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:(cat+'_quiz'+i),expression:"cat+'_quiz'+i"}],staticClass:"topic-button",attrs:{"type":"button"}},[_c('u',[_vm._v(_vm._s(quiz.name))])]),_vm._v(" "),_c('div',{staticClass:"w-25 d-inline-flex\n                    flex-column justify-content-between align-items-end"},[(_vm.isAuthor)?_c('button',{staticClass:"btn btn-sm btn-danger ly-del-btn",staticStyle:{"font-size":"0.75em"},attrs:{"tabindex":"-1"},on:{"click":function($event){return _vm.delContent(quiz.id, i, cat, 'quizzes')}}},[_c('i',{staticClass:"fas fa-exclamation-triangle"}),_vm._v(" "),_c('span',[_vm._v("Löschen")])]):_vm._e()]),_vm._v(" "),_c('b-collapse',{key:cat+'_quiz'+i,staticClass:"topic-content mt-2",attrs:{"id":cat+'_quiz'+i,"role":"tabpanel"}})],1)])})],2)],1)})],2)])])]),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('div',{staticStyle:{"height":"3rem"}}),_vm._v(" "),(_vm.isAuthor)?_c('div',[_c('div',{staticClass:"card"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('form',[_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newContent.name),expression:"newContent.name"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Name"},domProps:{"value":(_vm.newContent.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newContent, "name", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newContent.category),expression:"newContent.category"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Kategorie"},domProps:{"value":(_vm.newContent.category)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newContent, "category", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"form-group"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.newContent.type),expression:"newContent.type"}],staticClass:"form-control custom-select",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.newContent, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Typ wählen ...")]),_vm._v(" "),_c('option',{attrs:{"value":"topics"}},[_vm._v("Lerninhalt")]),_vm._v(" "),_c('option',{attrs:{"value":"quizzes"}},[_vm._v("Übung")])])])]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('button',{staticClass:"btn btn-block btn-primary",attrs:{"type":"submit"},on:{"click":_vm.storeNewContent}},[_c('i',{staticClass:"fas fa-check"}),_vm._v(" Speichern\n                    ")])])]),_vm._v(" "),_c('b',{staticClass:"d-block text-center w-100"},[_vm._v(_vm._s(_vm.authorMsg))])])])])]):_vm._e()])])])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"empty text-center text-muted m-0"},[_c('i',{staticClass:"far fa-meh"}),_vm._v(" "),_c('span',[_vm._v("Dieser Kurs ist noch leer")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"10%"}},[_c('i',{staticClass:"fas fa-check d-none"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header text-white bg-primary"},[_c('i',{staticClass:"fas fa-plus"}),_vm._v(" Neuer Inhalt\n            ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vqPg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_content_nav_vue__ = __webpack_require__("8bKB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ed72d54_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_content_nav_vue__ = __webpack_require__("3E4u");
function injectStyle (ssrContext) {
  __webpack_require__("6Rv0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4ed72d54"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_content_nav_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ed72d54_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_content_nav_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vudA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_privacy_vue__ = __webpack_require__("R8db");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cd8bd68_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_privacy_vue__ = __webpack_require__("4U1n");
function injectStyle (ssrContext) {
  __webpack_require__("KDSd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0cd8bd68"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_privacy_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cd8bd68_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_privacy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "w/wq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ly-quiz-mchoice',
  created: function created() {},
  data: function data() {
    return {
      tries: 0,
      answers: [],
      checked: [],
      feedback: '',
      freeze: false
    };
  },

  props: {
    task: String,
    options: Array,
    solutions: Array,
    maxTries: Number
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])(['profile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['isAuthor']), {
    feedbackId: function feedbackId() {
      return 'mchoice-feedback-' + this._uid;
    }
  }),
  methods: {
    correct: function correct(i) {
      return this.answers.includes(i) && this.checked[i];
    },
    incorrect: function incorrect(i) {
      return this.answers.includes(i) && this.checked[i] === false;
    },
    markAnwsers: function markAnwsers() {
      var zis = this;
      this.answers.forEach(function (answer) {
        zis.checked[answer] = zis.solutions.includes(answer);
      });
    },
    check: function check() {
      var _this = this;

      if (this.freeze) return;

      this.tries++;
      /*
       * check given answers */
      this.markAnwsers();

      /*
       * check if solutions === answers */
      if (this.solutions.every(function (s) {
        return _this.answers.includes(s);
      }) && this.answers.every(function (a) {
        return _this.solutions.includes(a);
      })) {
        this.feedback = this.profile.lang === 'de' ? 'Alles richtig!' : 'All correct!';
        document.getElementById(this.feedbackId).focus();
        this.freeze = true;
        return;
      }

      /*
       * solutions !== answers, still has tries ? */
      if (this.maxTries - this.tries > 0) {
        this.feedback = this.profile.lang === 'de' ? 'Es fehlen noch richtige Antworten oder Korrekturen!' : 'You are still missing some answers or corrections!';
        document.getElementById(this.feedbackId).focus();
        return;
      }

      /*
       * no tries left - show solutions */
      this.answers = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.solutions));
      this.markAnwsers();
      this.feedback = this.profile.lang === 'de' ? 'Die Lösung wurde ergänzt!' : 'The solution is being shown!';
      document.getElementById(this.feedbackId).focus();
      this.freeze = true;
    }
  }
});

/***/ }),

/***/ "wFL9":
/***/ (function(module, exports) {

module.exports = {"title":"Einloggen","emailPH":"Email","pwdPH":"Passwort","submitTxt":"Einloggen","errMsg":"Deine Anmeldung war nicht erfolgreich","registerHint1":"Noch keinen Account ?","registerHint2":"Hier geht es zur Anmeldung"}

/***/ }),

/***/ "wbZI":
/***/ (function(module, exports) {

module.exports = {"title":"Einloggen","emailPH":"Email","pwdPH":"Passwort","submitTxt":"Einloggen","errMsg":"Deine Anmeldung war nicht erfolgreich","registerHint1":"Noch keinen Account ?","registerHint2":"Hier geht es zur Anmeldung"}

/***/ }),

/***/ "wjw9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wxLn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__de_js__ = __webpack_require__("nmo2");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "de", function() { return __WEBPACK_IMPORTED_MODULE_0__de_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__en_js__ = __webpack_require__("C2Dk");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "en", function() { return __WEBPACK_IMPORTED_MODULE_1__en_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "es", function() { return __WEBPACK_IMPORTED_MODULE_1__en_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "it", function() { return __WEBPACK_IMPORTED_MODULE_1__en_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "pl", function() { return __WEBPACK_IMPORTED_MODULE_1__en_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "nl", function() { return __WEBPACK_IMPORTED_MODULE_1__en_js__["a"]; });







/***/ }),

/***/ "xJ8C":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "xOdV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ly-button',
  props: {
    left: { type: Boolean, default: false },
    right: { type: Boolean, default: false },
    submit: { type: Boolean, default: false }
  }
});

/***/ }),

/***/ "xbdJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-margin"},[_c('div',{staticClass:"container"},[_vm._m(0),_vm._v(" "),_c('div',{staticStyle:{"height":"2rem"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('h1',{staticClass:"text-center"},[_c('strong',[_vm._v(_vm._s(_vm.i18n.title))])])])]),_vm._v(" "),_c('div',{staticStyle:{"height":"2rem"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"ly-search-bar"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchInput),expression:"searchInput"}],attrs:{"id":"search-bar","type":"text","placeholder":_vm.i18n.searchPH},domProps:{"value":(_vm.searchInput)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchInput=$event.target.value}}}),_vm._v(" "),_c('i',{staticClass:"fas fa-search"})])])]),_vm._v(" "),_c('div',{staticStyle:{"height":"2rem"}})]),_vm._v(" "),_c('div',{staticClass:"ly-bg-grey"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.noCourses() && !_vm.note.busy),expression:"noCourses() && !note.busy"}],staticClass:"py-4"},[_c('h3',{staticClass:"empty text-center text-muted m-0"},[_c('i',{staticClass:"far fa-frown"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.i18n.noCourses))])])]),_vm._v(" "),_vm._l((_vm.cats),function(courses,cat){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.search(courses).length > 0 && !_vm.note.busy),expression:"search(courses).length > 0 && !note.busy"}]},[_c('div',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:(cat),expression:"cat"}],key:cat,staticClass:"d-flex justify-content-between align-item-center catHeader",attrs:{"tabindex":"0"},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.toggle(cat)}}},[_c('u',[_vm._v(_vm._s(cat))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.countMsg(courses)))])]),_vm._v(" "),_c('b-collapse',{key:cat+'-C',attrs:{"id":cat},model:{value:(_vm.vstate[cat]),callback:function ($$v) {_vm.$set(_vm.vstate, cat, $$v)},expression:"vstate[cat]"}},[_c('ly-accordion',{attrs:{"data":_vm.search(courses)},scopedSlots:_vm._u([{key:"item",fn:function(data){return _c('div',{},[_c('div',{staticClass:"d-flex"},[_c('div',{staticClass:"w-25 pr-5 pl-1"},[_c('h4',[_c('i',{directives:[{name:"show",rawName:"v-show",value:(data.item.locked),expression:"data.item.locked"}],staticClass:"fas fa-lock"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(data.item.endDate),expression:"data.item.endDate"}],staticClass:"fas fa-stopwatch"})]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(data.item.endDate),expression:"data.item.endDate"}]},[_vm._v("\n                        "+_vm._s(_vm.shortDate(data.item.startDate))+" —\n                        "+_vm._s(_vm.shortDate(data.item.endDate))+"\n                      ")])]),_vm._v(" "),_c('a',{staticClass:"w-50 pl-xs-1 pl-md-0",attrs:{"href":'#/dse'}},[_c('h4',[_c('u',[_c('b',[_vm._v(_vm._s(data.item.name))])])]),_vm._v(" "),_c('span',[_vm._v(_vm._s(data.item.category))]),_vm._v(" "),_c('span',[_vm._v("—")]),_c('br'),_vm._v(" "),_c('span',[_vm._v(_vm._s(data.item.author.username))])]),_vm._v(" "),_c('div',{staticClass:"w-25 d-inline-flex flex-column\n                      justify-content-between align-items-end"},[_c('div',{staticClass:"text-right"},[_vm._v("\n                          "+_vm._s(_vm.shortDate(data.item.createDate))+"\n                        ")]),_vm._v(" "),(_vm.isAuthor)?_c('button',{staticClass:"btn btn-sm btn-danger ly-del-btn",on:{"click":function($event){return _vm.delCourse(data.item.name)}}},[_c('i',{staticClass:"fas fa-exclamation-triangle"}),_vm._v(" "),_c('span',[_vm._v("Löschen")])]):_vm._e()])])])}}],null,true)})],1)],1)})],2)])])]),_vm._v(" "),_c('div',{staticStyle:{"height":"2rem"}}),_vm._v(" "),(_vm.isAuthor)?_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"card"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('form',[_c('div',{staticClass:"form-row mb-2"},[_c('div',{staticClass:"col"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newCourse.name),expression:"newCourse.name"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Name"},domProps:{"value":(_vm.newCourse.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newCourse, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newCourse.category),expression:"newCourse.category"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Kategorie"},domProps:{"value":(_vm.newCourse.category)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newCourse, "category", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-row mb-2"},[_c('div',{staticClass:"col"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.newCourse.abstract),expression:"newCourse.abstract"}],staticClass:"form-control",attrs:{"placeholder":"Abstrakt"},domProps:{"value":(_vm.newCourse.abstract)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newCourse, "abstract", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group col"},[_c('label',[_vm._v("Startdatum")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newCourse.startDate),expression:"newCourse.startDate"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.newCourse.startDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newCourse, "startDate", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col"},[_c('label',[_vm._v("Enddatum")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newCourse.endDate),expression:"newCourse.endDate"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.newCourse.endDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newCourse, "endDate", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newCourse.locked),expression:"newCourse.locked"}],staticClass:"form-check-input",attrs:{"type":"checkbox","placeholder":"Kategorie"},domProps:{"checked":Array.isArray(_vm.newCourse.locked)?_vm._i(_vm.newCourse.locked,null)>-1:(_vm.newCourse.locked)},on:{"change":function($event){var $$a=_vm.newCourse.locked,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.newCourse, "locked", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.newCourse, "locked", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.newCourse, "locked", $$c)}}}}),_vm._v("\n                      Kurs sperren\n                    ")])])]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('button',{staticClass:"btn btn-block btn-primary",attrs:{"type":"submit"},on:{"click":_vm.storeNewCourse}},[_c('i',{staticClass:"fas fa-check"}),_vm._v(" Speichern\n                  ")])])])])])])])])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('img',{staticClass:"mx-auto",attrs:{"src":__webpack_require__("y0GG"),"alt":"Gerhirn"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header text-white bg-primary"},[_c('i',{staticClass:"fas fa-plus"}),_vm._v(" Neuer Kurs\n          ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xd2/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xyRd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_imprint_vue__ = __webpack_require__("EQ5Q");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ecc74a32_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_imprint_vue__ = __webpack_require__("tY2k");
function injectStyle (ssrContext) {
  __webpack_require__("+Cth")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ecc74a32"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_imprint_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ecc74a32_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_imprint_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xzCB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_input_vue__ = __webpack_require__("XSxF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16863f2c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_input_vue__ = __webpack_require__("RhD6");
function injectStyle (ssrContext) {
  __webpack_require__("bCH/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-16863f2c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_input_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16863f2c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_input_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "y0GG":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "yMiU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    busy: false,
    myCourses: 0
  },
  mutations: {
    addMyCourse: function addMyCourse(state) {
      state.myCourses++;
    },
    clearMyCourse: function clearMyCourse(state) {
      state.myCourses = 0;
    },
    setBusy: function setBusy(state, bool) {
      state.busy = bool;
    }
  }
});

/***/ }),

/***/ "ya+h":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "yaJd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  courses: 'Courses',
  myCourses: 'My Courses',
  register: 'Register',
  profile: 'Profile',
  login: 'Login',
  logout: 'Logout'
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.1860be6053c60806d32e.js